import React, { useState, useEffect, useCallback, useRef } from "react";
import Pagination from "react-js-pagination";
import ConfigDB from "../../config";
import {
  Button,
  Form,
  FormGroup,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import { Dropdown } from "react-bootstrap";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { Range } from "react-range";
import ReactPaginate from "react-paginate";
import * as XLSX from "xlsx";

import { toast } from "react-toastify";
import Utils from "../../utils";
import {
  getPartsInventoryList,
  deletePartInventory,
  deletePartInventoryHard,
  getpartInventoryQuentityDetails,
  getpartQuantityHistoryList,
  getpartQuantityList,
  actionPartStatusUpdate,
  getwarHouseEntityList,
  getCatalogList,
  getPartInventoryDetails,
  createReplicatePart,
  createReservesPart,
  getImportPartCSVPrice,
  getExportPartInvenrotyList,
  ReservesSerachData,
  AddReservesSendPart,
  getReservesPartPendingList,
  partInvenoryVehicleSearch,
  getRepairPartInventoryList,
  createRepairPartInventory,
  updatePartInventoryPrice,
  generateShoppingCartLink,
  getBrandList,
  getManufacterList,
  getSearchSearchManufacturerMotorCodeList,
  getPartRefcodeConditionDetails,
  getPartEstimatePriceDetails,
  getAllPartDamageList,
  PartInventoryImageDetails,
  getHistoryLogList,
  partInventoryOutOfStock,
  partInventoryInStock,
} from "../../services/PartsInventory";
import { useNavigate, useLocation } from "react-router-dom";
import Barcode from "react-barcode";
import {
  getCommonSearchList,
  getSettingsCompanyDetails,
} from "../../services/settingsServices";
import DesmeImage from "../../asset/images/dismantle_icon.svg";
import {
  getVehicleAllProcessList,
  getVehicleFuelAllList,
  getVehicleProcessDetails,
  getvehicleYearList,
} from "../../services/VehicleService";
import moment from "moment/moment";
import Select from "react-select";
import { getLerCodeList } from "../../services/DepollutionService";
import { useTranslation } from "react-i18next";
import { tConst, tConstStatic } from "../../utils/constantsTranslator";
import { getAllVehicleSerachType } from "../../services/VehicleMakeService";
import { getVehicleAllModalSerachList } from "../../services/VehicleModelService";
import { getVehicleSerachVariantList } from "../../services/VehicleVariantsService";
import {
  getPartGroupAllList,
  getPartLocationAllList,
  getPartSideAllList,
  getPartTypeAllList,
} from "../../services/PartTypeService";
import { getAllBrandSerachList } from "../../services/PartBrandServices";
import {
  createLabelBrothers,
  createLabelZebras,
  printPartLabel,
} from "../../services/LabelServices";
import PartPrintButton from "../../components/PartPrintButton";
import { profileDetailForWeb } from "../../services/AuthServices";
import { createSyncInvoiceProduct } from "../../services/moloniProductService";
import {
  getDocumentSetList,
  getListCustomerList,
} from "../../services/MoloniServices";
import { debounce } from "../../utils/debounce";
import {
  getSearchPartReferenceListDropdownList,
  getSearchVehicleListDropdownList,
  getVehicleMakesSearchDropdownList,
  getVehicleModelSearchDropdownList,
  getVehicleVariantsSearchDropdownList,
  getCatalogSearchDropdownList,
  getVehicleEngineSearchManufacturerDropdownList,
} from "../../services/SerachApiServices";
import { PhotoProvider, PhotoView } from "react-photo-view";
import "react-photo-view/dist/react-photo-view.css";
import MessageCell from "../../components/MessageCell";
import { getLotsActiveList } from "../../services/LotsServices";

// Note: labels here are translation keys; components should render with `t()`.
const InvoiceDeleteData = [
  { id: 0, value: "pi_mgmt_status" },
  { id: 1, value: "pi_mgmt_delete_record" },
  { id: 2, value: "pi_mgmt_invoice_record" },
];

const sortTypeData = [
  { value: 0, label: "pi_sort_asc" },
  { value: 1, label: "pi_sort_desc" },
];

const partWithPriceList = [
  { value: 0, label: "all" },
  { value: 1, label: "pi_filter_price" },
  { value: 2, label: "pi_filter_without_price" },
];

const partWithPhotoList = [
  { value: 0, label: "all" },
  { value: 1, label: "pi_filter_photo" },
  { value: 2, label: "pi_filter_without_photo" },
];

const partWithReferenceList = [
  { value: 0, label: "all" },
  { value: 1, label: "pi_filter_reference" },
  { value: 2, label: "pi_filter_without_reference" },
];

const partWithDamageList = [
  { value: 0, label: "all" },
  { value: 1, label: "pi_filter_damage" },
  { value: 2, label: "pi_filter_without_damage" },
];

const partWithLocationList = [
  { value: 0, label: "all" },
  { value: 1, label: "pi_filter_location" },
  { value: 2, label: "pi_filter_without_location" },
];

const PartsInventory = () => {
  const location = useLocation();
  const RolePermission = Utils.getRecordForCurrentPath(location);
  const tableLengthList = ConfigDB.data.dataTableLength;
  const data = localStorage.getItem(ConfigDB.data.login_data);
  const companyId = JSON.parse(data);
  const navigate = useNavigate();
  const { t } = useTranslation();
  const LangData = localStorage.getItem("lng");

  const [delModal, setDelModal] = useState(false);
  const [delPartId, setDelPartId] = useState("");
  // Peças compostas — popup para replicar a acção (eliminar / indisponível)
  // nas peças filho activas. cascadeAction: "delete" | "status" | "oos"
  const [cascadeModal, setCascadeModal] = useState(false);
  const [cascadeAction, setCascadeAction] = useState("");
  const [catalog, setCatalog] = useState("");
  const [model, setModel] = useState("");
  const [year, SetYear] = useState("");
  const [make, SetMake] = useState("");
  const [variant, SetVariant] = useState("");
  const [internalId, SetInternalId] = useState("");
  const [isDelButtonLoad, setIsDelButtonLoad] = useState(false);
  const [inventoryStatus, setInventoryStatus] = useState("");
  const [recordStatus, setRecordStatus] = useState(0);
  const [settingCompanyDetails, setSettingCompanyDetails] = useState("");
  const [activeTab, setActiveTab] = useState("");
  const [freeSearch, setFreeSearch] = useState("");
  const [filterSearch, setFilterSearch] = useState({
    is_search_part_catalog: 1,
    is_search_vehicle_catalog: 1,
    is_search_references_codes: 1,
    is_search_damages: 1,
    is_search_notes: 1,
    is_search_compatible_vehicles: 1,
  });

  const [filterData, setFilterData] = useState({
    is_free_search: settingCompanyDetails?.is_free_search,
    vehicle_year_id: "",
    make_id: "",
    variants_id: "",
    model_id: "",
    vehicle_fuel: "",
    vehicle_doors: "",
    part_type: "",
    part_location: "",
    part_group: "",
    part_side: "",
    brand_id: "",
    condition_id: "",
    state_id: "",
    type_damage_id: "",
    location_damage_id: "",
    order_field: settingCompanyDetails?.sort_field ?? "",
    order_type: "1",
    reference_name: "",
    price_from: "",
    price_to: "",
    rating_from: "",
    rating_to: "",
    part_with_price: "",
    part_with_photo: "",
    part_with_reference: "",
    part_with_damage: "",
    part_with_location: "",
    serach: "",
    is_compatible_search: "",
    catalog_name: "",
    motorization: "",
    is_master_part: "",
    brand: "",
    manufacter: "",
    vehicle_make_name: "",
    reference_name_type: "",
    brand_name: "",
    vehicle_id: "",
    manufacturer_engine: "",
    vehicle_engine_code: "",
    parts_height: "",
    parts_weight: "",
    parts_width: "",
    parts_length: "",
    print_label: 0,
    vat_included: 0,
    part_on_order: 0,
    part_draft: 0,
    cc: "",
    cv: "",
    kw: "",
    internal_id: "",
    record_show_type: 0,
    free_search: freeSearch || localStorage.getItem("freeSearch"),
  });

  let defaultParams = {
    limit: settingCompanyDetails
      ? settingCompanyDetails?.no_of_parts_per_page
      : tableLengthList[0],
    page: 1,
    search: "",
    is_reload: false,
    company_id: companyId.company_id || 0,
    vehicle_year: "",
    vehicle_model: "",
    vehicle_variant: "",
    vehicle_make: "",
    catalog_name: "",
    part_name: "",
    inventory_status: "",
    record_show_type: 0,
    internal_id: "",
    search_warehouse: "",
    search_warehouse_barcode: "",
    vehicle_type: "",
    is_free_search: filterData?.is_free_search,
    vehicle_fuel: "",
    vehicle_doors: "",
    part_type: "",
    part_location: "",
    part_group: "",
    part_side: "",
    brand_id: "",
    condition_id: "",
    state_id: "",
    type_damage_id: "",
    location_damage_id: "",
    order_field: filterData?.order_field,
    order_type: "",
    reference_name: "",
    price_from: "",
    price_to: "",
    rating_from: "",
    rating_to: "",
    part_with_price: "0",
    part_with_photo: "0",
    part_with_reference: "0",
    part_with_damage: "0",
    part_with_location: "0",
    is_compatible_search: "",
    motorization: "",
    is_master_part: "",
    brand: "",
    manufacter: "",
    vehicle_id: "",
    inventory_status_filter: settingCompanyDetails?.inventory_status_filter,
    vehicle_engine_code: "",
    parts_height: "",
    parts_weight: "",
    parts_width: "",
    parts_length: "",
    print_label: 0,
    vat_included: 0,
    part_on_order: 0,
    part_draft: 0,
    cc: "",
    cv: "",
    kw: "",
    free_search: freeSearch || localStorage.getItem("freeSearch"),
  };

  const [params, setParams] = useState(defaultParams);
  const [totalRecords, setTotalRecords] = useState(0);
  const [partsInventoryList, setPartsInventoryList] = useState([]);
  const [qrDetails, setQrDetails] = useState(false);
  const [qrPartDetails, setQrPartDetails] = useState(false);
  const [DelPartQRId, setDelPartQRId] = useState("");
  const [DelPartInternalQRId, setDelPartInternalQRId] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingExport, setIsLoadingExport] = useState(false);
  const [inventoryList, setInventoryList] = useState([]);
  const [vehiclePartDetails, setVehiclePartDetails] = useState([]);
  const [vehiclePartDetailsId, setVehiclePartDetailsId] = useState("");
  const [vehiclePartDetailsModal, setVehiclePartDetailsModal] = useState(false);
  const [partDetails, setPartDetails] = useState([]);
  const [show, setShow] = useState(false);
  const [partHistoryQtyModal, setPartHistoryQtyModal] = useState(false);
  const [partHistoryQtyDetails, setPartHistoryQtyDetails] = useState([]);
  const [partHistoryQtyId, setpartHistoryQtyId] = useState("");
  const [allPartQtyList, setAllPartQtyList] = useState([]);
  const [partQtyStatusId, setpartQtyStatusId] = useState(0);
  const [partStatusChangeModal, setPartStatusChangeModal] = useState(false);
  const [inventoryPartStatusChange, setInventoryPartStatusChange] = useState(0);
  const [addedParts, setAddedParts] = useState([]);
  // ---- "Adicionar a Lote" — modal de selecção de lote para entrar
  // no flow Add For Parts com lot_id propagado.
  const [lotPickerOpen, setLotPickerOpen] = useState(false);
  const [lotPickerSearch, setLotPickerSearch] = useState("");
  const [lotPickerList, setLotPickerList] = useState([]);
  const [lotPickerLoading, setLotPickerLoading] = useState(false);
  const [LerCatalogList, setLerCatalogList] = useState([]);
  const [vehiclePartsData, setVehiclePartsData] = useState({
    ler_code_id: [],
    unit_value: [],
  });
  const [inputValueLer, setInputValueLer] = useState("");
  const [partCatalogData, setPartCatalogData] = useState({
    ler_codes_id: "",
  });
  const [modifyQrSearchModal, setmodifyQrSearchModal] = useState(false);
  const [selectedEntities, setSelectedEntities] = useState({
    value: "",
    name: "",
  });
  const [entityList, setEntityList] = useState([]);
  const [selectBarcodeValue, setSelectBarcodeValue] = useState("");
  const [VehicleTypeList, setVehicleTypeList] = useState([]);
  const [filterSerachList, setFilterSerachList] = useState([]);
  const [VehicleYearList, setVehicleYearList] = useState([]);
  const [inputSelctedeYearValue, setInputSelctedYearValue] = useState("");
  const [VehicleFuelList, setVehicleFuelList] = useState([]);
  const [vehicleDoorList, setVehicleDoorList] = useState([]);
  const [partTypeList, setPartTypeList] = useState([]);
  const [partLocationList, setPartLocationList] = useState([]);
  const [partGroupList, setPartGroupList] = useState([]);
  const [partSideList, setPartSideList] = useState([]);
  const [allBrandList, SetAllBrandList] = useState([]);
  const [conditionList, setConditionList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [locationDamageList, setLocationDamageList] = useState([]);
  const [typeDamageList, setTypeDamageList] = useState([]);
  const [partsName, setPartsName] = useState("");
  const [sortList, setSortList] = useState([]);
  const [refNameList, setRefNameList] = useState([]);
  const [priceValues, setPriceValues] = useState([0, 0]);
  const [ratingValues, setRatingValues] = useState([0.0, 0.0]);
  const [modifyReplicateParts, setModifyReplicateParts] = useState(false);
  const [PartsDataList, setPartsDataList] = useState("");
  const [replicatePartsData, setReplicatePartsData] = useState({
    copy_photo: 0,
    copy_video: 0,
    copy_reference: 0,
    copy_damage: 0,
    copy_compatiable_vehicles: 0,
    replicate_type: "",
    new_vehicle_id: "",
  });
  const [partAddDetails, setPartAddDetails] = useState("");
  const [loading, setLoading] = useState(false);
  const [modifyVehiclereplica, setModifyVehiclereplica] = useState(false);
  const [modifyReservesParts, setModifyReservesParts] = useState(false);
  const [modifyImportModal, setModifyImportModal] = useState(false);
  const [isModifyButtonLoad, setIsModifyButtonLoad] = useState(false);
  const [file, setFile] = useState(null);
  const [reservesSerachList, setReservesSerachList] = useState([]);
  const [reservesData, setReservesData] = useState({
    reservation_id: "",
  });
  const [selectedPrices, setSelectedPrices] = useState({});
  const [selectedParts, setSelectedParts] = useState([]);
  let errorsObjImport = {
    file: "",
  };
  const [errorsImport, setErrorsImport] = useState(errorsObjImport);
  const [resOrderData, setResOrderData] = useState({
    reservation_order_notes: "",
  });
  const [selectedEntitiesRes, setSelectedEntitiesRes] = useState({});
  const [reservesPenList, setReservesPenList] = useState([]);
  const [inputSelectedCatelog, setInputSelectedCatelog] = useState("");
  const [replicateVehicleList, setReplicateVehicleList] = useState([]);
  const [VehicleModelAllList, setVehicleModelAllList] = useState([]);
  const [repairsPartsModal, setRepairsPartsModal] = useState(false);
  const [loadingRepairs, setloadingRepairs] = useState("");
  const [repairsPartsList, setRepairsPartsList] = useState([]);
  const [addedRepairsParts, setAddedRepairsParts] = useState([]);
  const [repairsTotal, setRepairsTotal] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [repairsPartsSingleModal, setRepairsPartsSingleModal] = useState(false);
  const [repairsPartsData, setRepairsPartsData] = useState("");
  const [serachRepair, setSerachRepair] = useState("");
  const [repairFilterData, setRepairFilterData] = useState({
    catalog_name: "",
    internal_id: "",
  });
  const [VehicleTypePartList, setVehicleTypePartList] = useState([]);
  const [modifyPriceModal, setModifyPriceModal] = useState(false);
  const [priceList, setPriceList] = useState("");
  const [priceData, setPriceData] = useState({
    part_price: "",
    sponsor_price: "",
    part_original_price: "",
  });
  const [loadingPrice, setLoadingPrice] = useState("");
  const [settingDetails, setSettingDetails] = useState("");
  const [modifyCartModal, setModifyCartModal] = useState(false);
  const [cartQtyList, setCartQtyList] = useState("");
  const [selectedRowsByCart, setSelectedRowsByCart] = useState({});
  const [selectedPartDetails, setSelectedPartDetails] = useState([]);
  const [savedPartIdsByCart, setSavedPartIdsByCart] = useState({});
  const [cartModal, setCartModal] = useState(false);
  const [saveCartList, setSaveCartList] = useState("");
  const [saveCartModal, setSaveCartModal] = useState(false);
  const [copied, setCopied] = useState(false);
  const [loadingCart, setLoadingCart] = useState("");
  const [brandList, setbrandList] = useState([]);
  const [manufacterList, setManufacterList] = useState([]);
  const [brandName, setBrandName] = useState("");
  const [manufacterName, setManufacterName] = useState("");
  const [inputSelectedBrand, setInputSelectedBrand] = useState("");
  const [printPart, setPrintPart] = useState(false);
  const [IsLoadingprintPart, setisLoadingprintPart] = useState(false);
  const [printPartId, setPrintPartId] = useState(false);
  const [storeCount, setStoreCount] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [countVehicleList, setCountVehicleList] = useState([]);
  const [totalVehicleList, setTotalVehicleList] = useState([]);
  const [popupLimit] = useState(10); // or tableLengthList[0]
  const [popupPage, setPopupPage] = useState(1);
  const [popupVehicleIds, setPopupVehicleIds] = useState([]);
  const [vehicleList, setVehicleList] = useState([]);
  const [vehiclePage, setVehiclePage] = useState(1);
  const [vehicleTotal, setVehicleTotal] = useState(0);
  const [vehicleLoading, setVehicleLoading] = useState(false);
  const [VehicleMakeList, setVehicleMakeList] = useState([]);
  const [vehicleMakePage, setVehicleMakePage] = useState(1);
  const [vehicleMakeTotal, setVehicleMakeTotal] = useState(0);
  const [vehicleMakeLoading, setVehicleMakeLoading] = useState(false);
  const [VehicleModalList, setVehicleModalList] = useState([]);
  const [vehicleModelPage, setVehicleModelPage] = useState(1);
  const [vehicleModelTotal, setVehicleModelTotal] = useState(0);
  const [vehicleModelLoading, setVehicleModelLoading] = useState(false);
  const [VehicleVariantList, setVehicleVariantList] = useState([]);
  const [vehicleVariantsPage, setVehicleVariantsPage] = useState(1);
  const [vehicleVariantsTotal, setVehicleVariantsTotal] = useState(0);
  const [vehicleVariantsLoading, setVehicleVariantsLoading] = useState(false);
  const [catelogList, setCatelogList] = useState([]);
  const [catelogPage, setCatelogPage] = useState(1);
  const [catelogTotal, setCatelogTotal] = useState(0);
  const [catelogLoading, setCatelogLoading] = useState(false);
  const [manufacturerEngineList, setManufacturerEngineList] = useState([]);
  const [engineMotorCodeList, setEngineMotorCodeList] = useState([]);
  const [refCodeConditionDataList, setRefCodeConditionDataList] = useState([]);
  const [estimatePricDataRefList, setEstimatePricDataRefList] = useState("");
  const [profileDetails, setProfileDetails] = useState("");
  const [damagesList, setDamagesList] = useState([]);
  const [damagesId, setDamagesId] = useState("");
  const [damagesModal, setDamagesModal] = useState(false);
  const [syncAllModal, setSyncAllModal] = useState(false);
  const [syncAllID, setSyncAllID] = useState("");
  const [syncFormData, setSyncFormData] = useState({
    date: new Date().toISOString().split("T")[0],
    expiration_date: new Date().toISOString().split("T")[0],
    document_set_id: "",
    customer_id: "",
    our_reference: "",
    your_reference: "",
    notes: "",
    total_value_packaging: "",
    total_value_other_parcel: "",
    total_value_shipping: "",
    exemption_vat_products: "",
    exemption_vat_shipping: "",
    exemption_vat_packaging: "",
    price_value: Number(syncAllID?.part_price) || 0,
    selected_ids: [],
    exemption_reason: "",
  });

  const [loadingSync, setLoadingSync] = useState(false);
  const [documentSetList, setDocumentSetList] = useState([]);
  const [customerList, seCustomerList] = useState([]);
  const [exemptionList, setExemptionList] = useState([]);

  let errorsObj = {
    date: "",
    document_set_id: "",
    customer_id: "",
    expiration_date: "",
  };
  const [errors, setErrors] = useState(errorsObj);
  const [syncButtonType, setSyncButtonType] = useState("");
  const [imageShow, setImageShow] = useState(false);
  const [vehicleImageDetails, setVehicleImageDetails] = useState([]);
  const [partInventoryHistoryList, setPartInventoryHistoryList] = useState([]);
  const [activeHistoryTab, setActiveHistoryTab] = useState("qty"); // qty | inventory
  const [totalPartInven, setTotalPartInven] = useState(0);
  const [partPage, setPartPage] = useState(1); // current page
  const [partLimit] = useState(50); // items per page
  const [outOfStockModel, setOutOfStockModel] = useState(false);
  const [inStockModel, setInStockModel] = useState(false);
  const [isOutOfStockDelButtonLoad, setIsOutOfStockDelButtonLoad] =
    useState(false);
  const [isInStockDelButtonLoad, setIsIntockDelButtonLoad] = useState(false);

  const columnNames =
    settingCompanyDetails?.part_display_columns?.columnsNames?.split(",");
  const columnKeys = settingCompanyDetails?.part_display_columns?.columns;

  const handleImageOpen = (e, item) => {
    if (!item?.total_part_image || item.total_part_image === 0) {
      toast.info(t("toast_image_unavailable"));
      return;
    }

    const obj = { id: item?.id };

    PartInventoryImageDetails(obj)
      .then((response) => {
        const data = response.data.data || [];
        setVehicleImageDetails(data);

        setImageShow(true);
      })
      .catch((err) => {
        console.error(err);
        toast.error(t("toast_image_fetch_err"));
      });
  };

  const handleSyncModalOpen = (e, item, type) => {
    setSyncAllID(item);
    setSyncButtonType(type);
    setSyncAllModal(true);
  };

  useEffect(
    function () {
      if (partHistoryQtyId) {
        let data = {
          id: partHistoryQtyId,
          module_type: 1, //1 = parrt 2 =vehicle
          limit: 50,
          page: partPage,
          search: "",
        };
        getHistoryLogList(data)
          .then((response) => {
            setPartInventoryHistoryList(response.data.data);
            setTotalPartInven(response.data.total);
          })
          .catch((err) => {});
      }
    },
    [partHistoryQtyId, partPage],
  );

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
      type: "exception_list",
    };
    getCommonSearchList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].code,
            label: response.data[i].description,
          });
        }

        setExemptionList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(() => {
    if (settingCompanyDetails) {
      setSyncFormData((prev) => ({
        ...prev,
        total_value_packaging:
          settingCompanyDetails.total_value_packaging || "",
        total_value_other_parcel:
          settingCompanyDetails.total_value_other_parcel || "",
        total_value_shipping: settingCompanyDetails.total_value_shipping || "",
        exemption_vat_products:
          settingCompanyDetails.exemption_vat_products || "",
        exemption_vat_shipping:
          settingCompanyDetails.exemption_vat_shipping || "",
        exemption_vat_packaging:
          settingCompanyDetails.exemption_vat_packaging || "",
        exemption_reason: settingCompanyDetails.exemption_reason || "",
      }));
    }
  }, [settingCompanyDetails]);

  useEffect(() => {
    if (syncAllID?.part_price) {
      setSyncFormData((prev) => ({
        ...prev,
        price_value: Number(syncAllID.part_price),
      }));
    }
  }, [syncAllID]);

  const handleSyncModalClose = () => {
    setSyncAllModal(false);
    setSyncFormData({
      date: new Date().toISOString().split("T")[0],
      expiration_date: new Date().toISOString().split("T")[0],
      document_set_id: "",
      customer_id: "",
      our_reference: "",
      your_reference: "",
      notes: "",
      total_value_packaging: settingCompanyDetails.total_value_packaging || "",
      total_value_other_parcel:
        settingCompanyDetails.total_value_other_parcel || "",
      total_value_shipping: settingCompanyDetails.total_value_shipping || "",
      exemption_vat_products:
        settingCompanyDetails.exemption_vat_products || "",
      exemption_vat_shipping:
        settingCompanyDetails.exemption_vat_shipping || "",
      exemption_vat_packaging:
        settingCompanyDetails.exemption_vat_packaging || "",
      price_value: "",
      selected_ids: [],
      exemption_reason: "",
    });
  };

  const handleDamageModalClose = () => {
    setDamagesModal(false);
  };

  const handleDamageModalOpen = (e, item) => {
    setDamagesId(item);
    setDamagesModal(true);
    setDelPartQRId(item.id);
  };

  const handleShowPopup = () => {
    setShowPopup(false);
  };

  const handleCopy = () => {
    if (saveCartList?.link) {
      navigator.clipboard.writeText(saveCartList.link);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    }
  };

  useEffect(() => {
    if (settingCompanyDetails?.inventory_status_filter !== undefined) {
      setParams((prev) => ({
        ...prev,
        inventory_status_filter: settingCompanyDetails.inventory_status_filter,
      }));
    }
  }, [settingCompanyDetails?.inventory_status_filter]);

  useEffect(() => {
    profileDetailForWeb()
      .then((response) => {
        setProfileDetails(response.data.data);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getDocumentSetList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].name,
          });
        }

        setDocumentSetList(list);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getListCustomerList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].name,
          });
        }

        seCustomerList(list);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  }, []);

  const handleShowVehicles = (vehicleIds) => {
    if (vehicleIds?.length > 0) {
      setPopupVehicleIds(vehicleIds);

      let data = {
        limit: popupLimit,
        page: 1,
        search: "",
        vehicle_ids: vehicleIds,
      };

      getVehicleAllProcessList(data)
        .then((response) => {
          setCountVehicleList(response?.data?.data || []);
          setTotalVehicleList(response?.data?.total);
          setPopupPage(1);
          setShowPopup(true);
        })
        .catch(() => {
          setCountVehicleList([]);
          setShowPopup(true);
        });
    } else {
      setPopupVehicleIds([]);
      setCountVehicleList([]);
      setTotalVehicleList(0);
      setShowPopup(true);
    }
  };

  const handlePopupPageChange = (selectedPage) => {
    const newPage = selectedPage.selected + 1;
    setPopupPage(newPage);

    let data = {
      limit: popupLimit,
      page: newPage,
      search: "",
      vehicle_ids: popupVehicleIds,
    };

    getVehicleAllProcessList(data)
      .then((response) => {
        setCountVehicleList(response?.data?.data || []);
        setTotalVehicleList(response?.data?.total);
      })
      .catch(() => {
        setCountVehicleList([]);
      });
  };

  const partPrintRef = useRef(null);
  const handlePrintOpen = (e, item) => {
    // Set part id, then trigger the shared PartPrintButton modal which
    // fetches active units + print targets and opens the correct picker
    // (1 unit + no bench → direct print; else → modal).
    setPrintPartId(item.id);
    // Wait one tick so the prop change propagates before triggering.
    setTimeout(() => partPrintRef.current?.trigger(), 0);
  };

  const handlePrintClose = () => {
    setPrintPart(false);
  };

  const handleSaveCartClose = () => {
    setSaveCartModal(false);
  };

  const handleSelectedCartModalOpen = () => {
    setCartModal(true);
  };

  const handleSelectedCartClose = () => {
    setCartModal(false);
  };

  const handleCartModalOpen = (e, item) => {
    setCartQtyList(item);
    setModifyCartModal(true);
  };

  const handleCartModalClose = () => {
    setModifyCartModal(false);
  };

  const handleRowCartSelect = (cartId, partId) => {
    setSelectedRowsByCart((prev) => {
      const selected = prev[cartId] || [];

      const updated = selected.includes(partId)
        ? selected.filter((id) => id !== partId)
        : [...selected, partId];

      return {
        ...prev,
        [cartId]: updated,
      };
    });
  };

  const handleCartSelectAll = (cartId, partList) => {
    setSelectedRowsByCart((prev) => {
      const allIds = partList.map((item) => item.id);
      const alreadySelected = prev[cartId]?.length === allIds.length;

      return {
        ...prev,
        [cartId]: alreadySelected ? [] : allIds,
      };
    });
  };

  const handleSaveSelectedParts = () => {
    if (!cartQtyList?.part_qty_list?.length) return;

    const currentCartId = String(cartQtyList.id);
    const selectedIds = selectedRowsByCart[currentCartId] || [];

    if (selectedIds?.length === 0) {
      toast.warning(t("pi_toast_no_qty_available"));
      return;
    }

    const selectedPartsForThisCart = cartQtyList.part_qty_list
      .filter((part) => selectedIds.includes(part.id))
      .map((part) => ({
        ...part,
        parts_id: cartQtyList.id,
        part_name: cartQtyList.namePartPT,
        part_internal_id: cartQtyList.parts_internal_id,
      }));

    setSelectedPartDetails((prev) => {
      const filtered = prev.filter(
        (item) =>
          !selectedPartsForThisCart.some(
            (newItem) =>
              newItem.id === item.id && newItem.parts_id === item.parts_id,
          ),
      );

      return [...filtered, ...selectedPartsForThisCart];
    });

    setSavedPartIdsByCart((prev) => ({
      ...prev,
      [cartQtyList.id]: [...(prev[cartQtyList.id] || []), ...selectedIds],
    }));

    setModifyCartModal(false);
  };

  const handleDeleteSelectedPart = (item) => {
    const { parts_id, id } = item;

    setSelectedPartDetails((prev) =>
      prev.filter((part) => !(part.parts_id === parts_id && part.id === id)),
    );

    setSelectedRowsByCart((prev) => {
      const existing = prev[parts_id] || [];
      const updated = existing.filter((selectedId) => selectedId !== id);

      return {
        ...prev,
        [parts_id]: updated,
      };
    });

    setSavedPartIdsByCart((prev) => {
      const existing = prev[parts_id] || [];
      const updated = existing.filter((savedId) => savedId !== id);

      return {
        ...prev,
        [parts_id]: updated,
      };
    });
  };

  const handlePriceModalOpen = (e, item) => {
    setPriceList(item);
    setModifyPriceModal(true);
  };

  const handlePriceModalClose = () => {
    setModifyPriceModal(false);
  };

  useEffect(() => {
    if (!priceList?.reference_list?.length) return;

    const refCodeConditionData = priceList?.reference_list?.map((item) => ({
      ref_code: item?.reference_code,
      condition: item?.condition_id,
    }));

    const requestData = {
      search: "",
      limit: 10,
      page: 1,
      refcode_condition: refCodeConditionData,
    };

    getPartRefcodeConditionDetails(requestData)
      .then((response) => setRefCodeConditionDataList(response.data.data))
      .catch((err) => toast.error(Utils.getErrorMessage(err)));
  }, [priceList]);

  useEffect(() => {
    if (!priceList?.reference_list?.length) return;

    let refCodeConditionData = priceList?.reference_list?.map((item) => ({
      reference: item?.reference_code,
      referenceType: item?.condition_name,
    }));

    const data = {
      regNumberCompany:
        profileDetails?.company_details?.company_registration_number,
      language: LangData ? LangData : "EN",
      references: refCodeConditionData,
    };

    getPartEstimatePriceDetails(data)
      .then((response) => setEstimatePricDataRefList(response.data.data))
      .catch((err) => toast.error(Utils.getErrorMessage(err)));
  }, [priceList]);

  useEffect(() => {
    if (!damagesId?.id) return;

    const data = {
      part_id: damagesId?.id,
    };

    getAllPartDamageList(data)
      .then((response) => setDamagesList(response.data.data))
      .catch((err) => toast.error(Utils.getErrorMessage(err)));
  }, [damagesId]);

  const handleRepairsPartClose = () => {
    setRepairsPartsModal(false);
    setRepairFilterData({
      catalog_name: "",
      internal_id: "",
    });
    setAddedRepairsParts([]);
  };
  const handleRepairsPartOpen = () => {
    setRepairsPartsModal(true);
  };

  const handleRepairsSinglePartClose = () => {
    setRepairsPartsSingleModal(false);
  };
  const handleRepairModalOpen = (e, item) => {
    setRepairsPartsData(item.id);
    setRepairsPartsSingleModal(true);
  };

  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected);
  };

  const handleSelectChangeRes = (event, item) => {
    const value = event.target.value;

    setSelectedEntitiesRes((prevState) => ({
      ...prevState,
      [item.id]: value,
    }));
  };

  const handleManualInput = (partId, value) => {
    setSelectedPrices((prev) => ({
      ...prev,
      [partId]: value,
    }));
  };

  const handleCheckboxChange = (partId, id) => {
    setSelectedParts((prev) => {
      const isAlreadySelected = prev.some((item) => item.id === id);

      if (isAlreadySelected) {
        return prev.filter((item) => item.id !== id);
      } else {
        return [...prev, { parts_id: partId, id }];
      }
    });
  };

  const handlePriceChange = (e) => {
    const { name, value } = e.target;
    const parsedValue = parseFloat(value) || 0;

    let updatedPriceData = {
      ...priceData,
      [name]: value,
    };

    if (name === "part_original_price") {
      const discountPercentage =
        (settingDetails?.discount_percentage || 0) / 100;
      const sponsorPrice = parsedValue * (1 - discountPercentage);
      updatedPriceData.part_price = sponsorPrice.toFixed(2);
    }

    setPriceData(updatedPriceData);
  };

  useEffect(() => {
    if (settingCompanyDetails) {
      setParams((prev) => ({
        ...prev,
        limit: settingCompanyDetails.no_of_parts_per_page || tableLengthList[0],
      }));
    }
  }, [settingCompanyDetails]);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const companyResponse = await getSettingsCompanyDetails();

        setSettingDetails(companyResponse.data.data);
      } catch (err) {
        console.error(err);
      }
    };

    fetchSettings();
  }, []);

  useEffect(() => {
    if (priceList) {
      setPriceData({
        part_price: priceList.part_price || "",
        sponsor_price: priceList.part_cost_price || "",
        part_original_price: priceList.part_original_price || "",
      });
    }
  }, [priceList]);

  const fetchVehicleList = (search = "", page = 1, limit = 20) => {
    setVehicleLoading(true);
    getSearchVehicleListDropdownList({ search, page, limit })
      .then((response) => {
        const data = response.data.data;
        const list = data.map((item) => ({
          value: item.id,
          label: `${item?.vehicle_type_name || ""} | ${
            item?.vehicle_model || ""
          } | ${item?.vehicle_internal_id || ""}`,
        }));
        setVehicleList(page > 1 ? [...vehicleList, ...list] : list); // append for pagination
        setVehicleTotal(response.data.total);
      })
      .catch((err) => console.error(err))
      .finally(() => setVehicleLoading(false));
  };

  // Debounced version of fetch
  const debouncedVehicle = useCallback(
    debounce((searchText) => {
      setVehiclePage(1); // reset to first page on new search
      fetchVehicleList(searchText, 1);
    }, 400),
    [],
  );

  // Initial fetch on mount
  useEffect(() => {
    fetchVehicleList();
  }, []);

  //make api
  const fetchVehicleMakeList = (payload) => {
    setVehicleMakeLoading(true);

    getVehicleMakesSearchDropdownList(payload)
      .then((response) => {
        const data = response.data.data;
        const list = data.map((item) => ({
          value: item.id,
          label: item.description,
        }));

        setVehicleMakeList((prev) =>
          payload.page > 1 ? [...prev, ...list] : list,
        );
        setVehicleMakeTotal(response.data.total);
      })
      .catch((err) => console.error(err))
      .finally(() => setVehicleMakeLoading(false));
  };

  // Debounced version of fetch
  const debouncedVehicleMake = useCallback(
    debounce((searchText) => {
      const payload = {
        limit: 20,
        page: 1,
        search: searchText,
        is_reload: true,
        is_Filter: 1,
        ...(filterData?.vehicle_year_id && {
          year: filterData.vehicle_year_id,
        }),
        ...(filterData?.vehicle_type && {
          vehicle_type_id: filterData.vehicle_type,
        }),
      };

      setVehicleMakePage(1); // reset page
      fetchVehicleMakeList(payload);
    }, 400),
    [],
  );

  // Initial fetch on mount
  useEffect(() => {
    const payload = {
      limit: 20,
      page: 1,
      search: "",
      is_reload: true,
      is_Filter: 1,
      ...(filterData?.vehicle_year_id && { year: filterData.vehicle_year_id }),
      ...(filterData?.vehicle_type && {
        vehicle_type_id: filterData.vehicle_type,
      }),
    };

    fetchVehicleMakeList(payload);
  }, [filterData?.vehicle_year_id, filterData?.vehicle_type]);

  //model api
  const fetchVehicleModelist = (payload) => {
    setVehicleModelLoading(true);

    getVehicleModelSearchDropdownList(payload)
      .then((response) => {
        const data = response.data.data;
        const list = data.map((item) => ({
          value: item.id,
          label: item.model_name,
        }));

        setVehicleModalList((prev) =>
          payload.page > 1 ? [...prev, ...list] : list,
        );
        setVehicleModelTotal(response.data.total);
      })
      .catch((err) => console.error(err))
      .finally(() => setVehicleModelLoading(false));
  };

  // Debounced version of fetch
  const debouncedVehicleModel = useCallback(
    debounce((searchText) => {
      const payload = {
        limit: 20,
        page: 1,
        search: searchText,
        is_reload: true,
        is_Filter: 1,
        ...(filterData?.vehicle_year_id && {
          vehicle_year: filterData.vehicle_year_id,
        }),
        ...(filterData?.vehicle_type && {
          vehicle_type_id: filterData.vehicle_type,
        }),
        ...(filterData?.make_id && {
          make_id: filterData.make_id,
        }),
      };

      setVehicleModelPage(1); // reset page
      fetchVehicleModelist(payload);
    }, 400),
    [],
  );

  // Initial fetch on mount
  useEffect(() => {
    const payload = {
      limit: 20,
      page: 1,
      search: "",
      is_reload: true,
      is_Filter: 1,
      ...(filterData?.vehicle_year_id && { year: filterData.vehicle_year_id }),
      ...(filterData?.vehicle_type && {
        vehicle_type_id: filterData.vehicle_type,
      }),
      ...(filterData?.make_id && {
        make_id: filterData.make_id,
      }),
    };

    fetchVehicleModelist(payload);
  }, [
    filterData?.vehicle_year_id,
    filterData?.vehicle_type,
    filterData?.make_id,
  ]);

  //variants api

  const fetchVehicleVariantsList = (payload) => {
    setVehicleVariantsLoading(true);

    getVehicleVariantsSearchDropdownList(payload)
      .then((response) => {
        const data = response.data.data;
        const list = data.map((item) => ({
          value: item.id,
          label: item.variants_name,
        }));

        setVehicleVariantList((prev) =>
          payload.page > 1 ? [...prev, ...list] : list,
        );
        setVehicleVariantsTotal(response.data.total);
      })
      .catch((err) => console.error(err))
      .finally(() => setVehicleVariantsLoading(false));
  };

  // Debounced version of fetch
  const debouncedVehicleVariants = useCallback(
    debounce((searchText) => {
      const payload = {
        limit: 20,
        page: 1,
        search: searchText,
        is_reload: true,
        ...(filterData?.vehicle_year_id && {
          vehicle_year: filterData.vehicle_year_id,
        }),
        ...(filterData?.vehicle_type && {
          vehicle_type_id: filterData.vehicle_type,
        }),
        ...(filterData?.model_id && {
          model_id: filterData.model_id,
        }),
      };

      setVehicleVariantsPage(1); // reset page
      fetchVehicleVariantsList(payload);
    }, 400),
    [],
  );

  // Initial fetch on mount
  useEffect(() => {
    const payload = {
      limit: 20,
      page: 1,
      search: "",
      is_reload: true,
      ...(filterData?.vehicle_year_id && { year: filterData.vehicle_year_id }),
      ...(filterData?.vehicle_type && {
        vehicle_type_id: filterData.vehicle_type,
      }),
      ...(filterData?.model_id && {
        model_id: filterData.model_id,
      }),
    };

    fetchVehicleVariantsList(payload);
  }, [
    filterData?.vehicle_year_id,
    filterData?.vehicle_type,
    filterData?.model_id,
  ]);

  const fetchVehicleCatalogList = (payload) => {
    setCatelogLoading(true);

    getCatalogSearchDropdownList(payload)
      .then((response) => {
        const data = response.data.data;
        const list = data.map((item) => ({
          value: item.id,
          label: item.namePartPT,
        }));

        setCatelogList((prev) =>
          payload.page > 1 ? [...prev, ...list] : list,
        );
        setCatelogTotal(response.data.total);
      })
      .catch((err) => console.error(err))
      .finally(() => setCatelogLoading(false));
  };

  // Debounced version of fetch
  const debouncedVehicleCatalog = useCallback(
    debounce((searchText) => {
      const payload = {
        limit: 20,
        page: 1,
        search: searchText,
        is_reload: true,
      };

      setCatelogPage(1); // reset page
      fetchVehicleCatalogList(payload);
    }, 400),
    [],
  );

  // Initial fetch on mount
  useEffect(() => {
    const payload = {
      limit: 20,
      page: 1,
      search: "",
      is_reload: true,
    };

    fetchVehicleCatalogList(payload);
  }, []);

  useEffect(function () {
    getVehicleEngineSearchManufacturerDropdownList()
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].manufacturer_engine,
            label: response.data[i].manufacturer_engine,
          });
        }
        setManufacturerEngineList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(
    function () {
      if (!filterData.manufacturer_engine) return;
      const obj = {
        search: "",
        limit: 20,
        page: 1,
        manufacturer_engine: filterData.manufacturer_engine,
      };
      getSearchSearchManufacturerMotorCodeList(obj)
        .then((response) => {
          response = response.data;
          let list = [];
          for (let i = 0; i < response.data.length; i++) {
            list.push({
              value: response.data[i].id,
              label: response.data[i].motor_code,
            });
          }
          setEngineMotorCodeList(list);
        })
        .catch((err) => {});
    },
    [filterData],
  );

  const handleMotorCodeEngineSearch = (value) => {
    if (value?.length < 1) return;

    const params = {
      search: value,
      limit: 20,
      page: 1,
      manufacturer_engine: filterData.manufacturer_engine,
    };

    getSearchSearchManufacturerMotorCodeList(params)
      .then((response) => {
        const data = response.data.data;

        const list = data?.map((item) => ({
          value: item.id,
          label: item.motor_code,
        }));

        setEngineMotorCodeList(list);
      })
      .catch((err) => {});
  };

  useEffect(function () {
    const obj = {
      search: "",
      limit: 20,
      page: 1,
    };
    getAllVehicleSerachType(obj)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].vehicle_type_name,
          });
        }
        setVehicleTypePartList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(function () {
    var obj = {
      text: "",
      limit: 20,
      page: 1,
    };

    partInvenoryVehicleSearch(obj)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i]?.id,
            label: `${response.data[i]?.vehicle_make_name || ""} | ${
              response.data[i]?.vehicle_model_name || ""
            } | ${response.data[i]?.registration_plate || ""} | ${
              response.data[i]?.registration || ""
            }
            | ${response.data[i]?.vehicle_internal_id}
         `,
            vehicle_model_name: response.data[i]?.vehicle_model_name,
            vehicle_year: response.data[i]?.vehicle_year,
            vehicle_model_id: response.data[i]?.vehicle_model_id,
            make_id: response.data[i]?.make_id,
            vehicle_process_end_date:
              response.data[i]?.vehicle_process_end_date,
            vehicle_in_inventory: response.data[i]?.vehicle_in_inventory,
            variants_id: response.data[i]?.variants_id,
            vehicle_make_name: response.data[i]?.vehicle_make_name,
            registration_plate: response.data[i]?.registration_plate,
            registration: response.data[i]?.registration,
            id: response.data[i]?.id,
          });
        }
        setVehicleModelAllList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(() => {
    if (settingCompanyDetails?.select_open_search_tab) {
      setActiveTab(`${settingCompanyDetails.select_open_search_tab}-tab`);
    }
  }, [settingCompanyDetails]);

  const handleImportModal = () => {
    setModifyImportModal(true);
  };

  const handleImportCloseModal = () => {
    setModifyImportModal(false);
  };

  const handleReservesOpen = (e, item) => {
    setPartsDataList(item);
    setModifyReservesParts(true);
  };

  const handleReservesClose = () => {
    setModifyReservesParts(false);
    setSelectedParts([]);
    setReservesData({
      reservation_id: "",
    });
    setReservesPenList([]);
  };

  const handleReplicateOpen = (e, item) => {
    setPartsDataList(item);
    setModifyReplicateParts(true);
  };

  const handleReplicateClose = () => {
    setModifyReplicateParts(false);
    setReplicatePartsData({
      copy_photo: "",
      copy_video: "",
      copy_reference: "",
      copy_damage: "",
      copy_compatiable_vehicles: "",
    });
  };

  const handleVehiclereplicaOpen = () => {
    setModifyVehiclereplica(false);
    setModifyReplicateParts(false);
    setReplicatePartsData({
      copy_photo: "",
      copy_video: "",
      copy_reference: "",
      copy_damage: "",
      copy_compatiable_vehicles: "",
    });
  };

  const handleQrSerachClose = () => {
    setmodifyQrSearchModal(false);
  };
  const handleSelectChange = (event) => {
    const selectedIndex = event.target.selectedIndex;
    const selectedValue = event.target.value;
    const selectedName = event.target.options[selectedIndex].text;

    setSelectedEntities({ value: selectedValue, name: selectedName });

    setParams((prevParams) => ({
      ...prevParams,
      search_warehouse: parseInt(selectedValue) || "",
    }));

    setmodifyQrSearchModal(false);
  };

  const handleSelectWareHouseChange = (event) => {
    const selectedIndex = event.target.selectedIndex;
    const selectedValue = event.target.value;
    let selectedName = event.target.options[selectedIndex].text;

    if (!selectedValue) {
      selectedName = "";
    }

    setSelectedEntities({ value: selectedValue, name: selectedName });
  };

  const handleResetQRSerach = (event) => {
    setParams({
      limit: tableLengthList[0],
      page: 1,
      search: "",
      is_reload: false,
      company_id: companyId.company_id || 0,
      vehicle_model: "",
      vehicle_year: "",
      catalog_name: "",
      part_name: "",
      inventory_status: "",
      record_show_type: 0,
      internal_id: "",
      search_warehouse: "",
      search_warehouse_barcode: "",
      vehicle_type: "",
    });
    setModel("");
    setCatalog("");
    SetYear("");
    SetInternalId("");
    setInventoryStatus("");
    setRecordStatus(0);
    setSelectedEntities("");
    setSelectBarcodeValue("");
    setmodifyQrSearchModal(false);
  };

  const renderOptions = (nodes, level = 0) => {
    return nodes?.map((node) => {
      if (node.children && node.children.length > 0) {
        return (
          <>
            <optgroup
              label={"\u00A0\u00A0".repeat(level) + node.warehouse_name}
              key={node.id}
            />
            {renderOptions(node.children, level + 1)}
          </>
        );
      } else {
        return (
          <option value={node.id} key={node.id}>
            {"\u00A0\u00A0".repeat(level) + node.warehouse_name}
          </option>
        );
      }
    });
  };

  useEffect(() => {
    fetchRepairParts(currentPage + 1);
  }, [currentPage, serachRepair, repairFilterData]);

  const fetchRepairParts = (page) => {
    const paramsObj = {
      search: serachRepair ? serachRepair : "",
      catalog_name: repairFilterData?.catalog_name
        ? repairFilterData?.catalog_name
        : "",
      internal_id: repairFilterData?.internal_id
        ? repairFilterData?.internal_id
        : "",
      page,
      limit: 10,
    };

    getRepairPartInventoryList(paramsObj)
      .then((response) => {
        setRepairsPartsList(response.data.data);
        setRepairsTotal(response.data.total);
      })
      .catch((err) => {
        toast.dismiss();
        toast.error(Utils.getErrorMessage(err));
      });
  };

  useEffect(() => {
    if (reservesData?.reservation_id) {
      let data = {
        parts_id: [PartsDataList?.id],
        reservation_id: reservesData?.reservation_id
          ? reservesData?.reservation_id
          : "",
        limit: tableLengthList[0],
        page: 1,
        search: "",
        is_reload: false,
        company_id: companyId.company_id || 0,
        is_update: false,
      };
      getReservesPartPendingList(data)
        .then((response) => {
          setReservesPenList(response.data.data);
        })
        .catch((err) => {
          toast.dismiss();
          toast.error(Utils.getErrorMessage(err));
        });
    }
  }, [reservesData?.reservation_id]);

  useEffect(() => {
    if (Array.isArray(reservesPenList) && reservesData?.reservation_id) {
      const matchingParts = reservesPenList.find((item) =>
        item.reserve_order_list?.some(
          (r) =>
            Number(r.reservation_id) === Number(reservesData?.reservation_id),
        ),
      );

      if (matchingParts) {
        // Extract and map based on reservation_id
        const preSelectedParts = [];
        const preSelectedPrices = {};
        const preSelectedEntities = {};
        const preReservationNotes = {};

        matchingParts.reserve_order_list.forEach((reserve) => {
          if (
            Number(reserve.reservation_id) !==
            Number(reservesData?.reservation_id)
          )
            return;

          const matchedPart = matchingParts.part_qty_list.find(
            (p) => Number(p.id) === Number(reserve.part_qty_label_id),
          );

          if (matchedPart) {
            preSelectedParts.push(matchedPart);
            preSelectedPrices[matchedPart.id] = reserve.reserve_price;
            preSelectedEntities[matchedPart.id] = reserve.location_id;
            preReservationNotes[matchedPart.id] =
              reserve.reservation_order_notes || "";
          }
        });

        setSelectedParts(preSelectedParts);
        setSelectedPrices(preSelectedPrices);
        setSelectedEntitiesRes(preSelectedEntities);
        setResOrderData((prev) => ({
          ...prev,
          reservation_order_notes: preReservationNotes,
        }));
      }
    }
  }, [reservesPenList, reservesData]);

  useEffect(
    function () {
      if (PartsDataList?.id) {
        var obj = {
          id: PartsDataList?.id,
        };
        getPartInventoryDetails(obj)
          .then((response) => {
            response = response.data.data;
            setPartAddDetails(response);
          })
          .catch((err) => {});
      }
    },

    [PartsDataList],
  );
  useEffect(() => {
    setParams((prev) => ({
      ...prev,
      is_free_search: filterData?.is_free_search || "",
      order_field: filterData?.order_field || "",
    }));
  }, [filterData]);

  useEffect(() => {
    if (!settingCompanyDetails) return;

    setFilterData((prev) => ({
      ...prev,
      ...(settingCompanyDetails.is_free_search !== undefined && {
        is_free_search: settingCompanyDetails.is_free_search,
      }),
      ...(settingCompanyDetails.sort_field !== undefined && {
        order_field: settingCompanyDetails.sort_field,
      }),
    }));
  }, [settingCompanyDetails]);

  const sumWastageValue = vehiclePartsData.unit_value.reduce((acc, curr) => {
    const num = parseFloat(curr);
    return !isNaN(num) ? acc + num : acc;
  }, 0);

  const handleSelectLERChange = (selectedOptions) => {
    const selectedValues = selectedOptions?.map((option) => option.value) || [];
    const unitValues =
      selectedOptions?.map((option) => option.unit_value || 0) || [];

    setVehiclePartsData((prevData) => ({
      ...prevData,
      ler_code_id: selectedValues,
      unit_value: unitValues,
    }));

    setPartCatalogData((prevData) => ({
      ...prevData,
      ler_codes_id: selectedOptions,
    }));
  };

  const handleAddClick = (
    id,
    namePartPT,
    vehicle_model,
    vehicle_year,
    inventory_status_name,
    is_master_part,
  ) => {
    const isAdded = addedParts.some((part) => part.id === id);

    if (isAdded) {
      setAddedParts((prev) => prev.filter((part) => part.id !== id));
    } else {
      setAddedParts((prev) => [
        ...prev,
        {
          id,
          namePartPT,
          vehicle_model,
          vehicle_year,
          inventory_status_name,
          is_master_part,
        },
      ]);
    }
  };

  const filteredPartAssignList = partsInventoryList.filter(
    (item) => !addedParts.some((addedPart) => addedPart.id === item.id),
  );

  useEffect(function () {
    let data = {
      limit: 10,
      page: params.page,
      search: "",
      is_reload: true,
    };
    ReservesSerachData(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i]?.id,
            label: response.data[i]?.reservation_name,
          });
        }
        setReservesSerachList(list);
      })
      .catch((err) => {});
  }, []);

  const handleInputChangeLER = (inputValueLer) => {
    setInputValueLer(inputValueLer);

    if (inputValueLer.length > 2) {
      const obj = {
        search: inputValueLer,
        limit: tableLengthList[0],
        page: 1,
      };

      getLerCodeList(obj)
        .then((response) => {
          response = response.data;
          let list = [];
          for (let i = 0; i < response.data.length; i++) {
            list.push({
              value: response.data[i].id,
              label: response.data[i].ler_code,
              unit_value: response.data[i].unit_value || 0,
            });
          }
          setLerCatalogList(list);
        })
        .catch((err) => {});
    } else {
      setLerCatalogList([]);
      const obj = {
        search: "",
        limit: tableLengthList[0],
        page: 1,
      };

      getLerCodeList(obj)
        .then((response) => {
          response = response.data;
          let list = [];
          for (let i = 0; i < response.data.length; i++) {
            list.push({
              value: response.data[i].id,
              label: response.data[i].ler_code,
              unit_value: response.data[i].unit_value || 0,
            });
          }
          setLerCatalogList(list);
        })
        .catch((err) => {});
    }
  };

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
      type: "replicate_type",
    };
    getCommonSearchList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }

        setReplicateVehicleList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
      type: "sort_field",
    };
    getCommonSearchList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }

        setSortList(list);
      })
      .catch((err) => {});
  }, []);

  const handleInputSelectedChangeBrandList = (inputValue) => {
    setInputSelectedBrand(inputValue);

    const obj = {
      search: filterData?.brand_name ? filterData?.brand_name : inputValue,
      limit: tableLengthList[0],
      page: 1,
    };

    getAllBrandSerachList(obj)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].descriptionPT,
          });
        }

        SetAllBrandList(list);
      })
      .catch((err) => {});
  };

  useEffect(function () {
    getSearchPartReferenceListDropdownList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].reference_code,
            label: response.data[i].reference_code,
          });
        }

        setRefNameList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const companyResponse = await getSettingsCompanyDetails();
        setSettingCompanyDetails(companyResponse.data.data);
      } catch (err) {
        console.error(err);
      }
    };

    fetchSettings();
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
      type: "state",
    };
    getCommonSearchList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }

        setStateList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
      type: "type_damage",
    };
    getCommonSearchList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }

        setTypeDamageList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
      type: "location_damage",
    };
    getCommonSearchList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }

        setLocationDamageList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
      type: "condition",
    };
    getCommonSearchList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }

        setConditionList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(() => {
    const obj = {
      search: filterData?.brand_name ? filterData?.brand_name : "",
      limit: 10,
      page: 1,
    };

    getAllBrandSerachList(obj)
      .then((response) => {
        response = response.data;
        let list = [];

        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].descriptionPT,
          });
        }
        SetAllBrandList(list);
      })
      .catch((err) => {
        console.error(err);
      });
  }, []);

  useEffect(function () {
    getPartTypeAllList()
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].descriptionUK,
          });
        }

        setPartTypeList(list);
      })
      .catch(() => {});
  }, []);

  useEffect(function () {
    getPartLocationAllList()
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].descriptionUK,
          });
        }
        setPartLocationList(list);
      })
      .catch(() => {});
  }, []);

  useEffect(function () {
    getPartGroupAllList()
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].descriptionUK,
          });
        }
        setPartGroupList(list);
      })
      .catch(() => {});
  }, []);

  useEffect(function () {
    getPartSideAllList()
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].descriptionUK,
          });
        }
        setPartSideList(list);
      })
      .catch(() => {});
  }, []);

  useEffect(function () {
    getBrandList()
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].brand,
            label: response.data[i].brand,
          });
        }
        setbrandList(list);
      })
      .catch(() => {});
  }, []);

  useEffect(function () {
    getManufacterList()
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].manufacter,
            label: response.data[i].manufacter,
          });
        }
        setManufacterList(list);
      })
      .catch(() => {});
  }, []);

  useEffect(function () {
    getVehicleFuelAllList()
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].fuel_type,
          });
        }
        setVehicleFuelList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
      type: "vehicle_no_door",
    };
    getCommonSearchList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }

        setVehicleDoorList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: params.page,
      search: "",
      is_reload: true,
    };
    getvehicleYearList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i],
            label: response.data[i],
          });
        }
        setVehicleYearList(list);
      })
      .catch((err) => {});
  }, []);

  const handleInputSelectedChangeYearList = (inputSelctedeYearValue) => {
    setInputSelctedYearValue(inputSelctedeYearValue);
    const obj = {
      search: inputSelctedeYearValue,
      limit: 20,
      page: 1,
    };

    getvehicleYearList(obj)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i],
            label: response.data[i],
          });
        }
        setVehicleYearList(list);
      })
      .catch((err) => {});
  };

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
      type: "filter_search_column",
    };
    getCommonSearchList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }

        setFilterSerachList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(function () {
    var obj = {
      search: "",
      limit: tableLengthList[0],
      page: 1,
    };
    getLerCodeList(obj)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].ler_code,
            unit_value: response.data[i].unit_value,
          });
        }
        setLerCatalogList(list);
      })
      .catch((err) => {});
  }, []);

  const handleShowOpen = () => {
    setShow(true);
  };

  const handleShowClose = () => {
    setShow(false);
  };

  const filteredParts = partDetails.filter((item) => item.location_ids !== "");

  const onvehiclePartDetailsClose = () => {
    setVehiclePartDetailsModal(false);
  };

  const ontpartHistoryQtyDetailsOpen = (e, item) => {
    e.preventDefault();
    setpartHistoryQtyId(item.id);
    setPartHistoryQtyModal(true);
  };

  const onpartHistoryQtyDetailsClose = () => {
    setPartHistoryQtyModal(false);
  };

  const onPartStatusChangeOpen = () => {
    setPartStatusChangeModal(true);
  };

  const onPartStatusChangeClose = () => {
    setPartStatusChangeModal(false);
  };

  useEffect(function () {
    getAllVehicleSerachType()
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].vehicle_type_name,
          });
        }
        setVehicleTypeList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(() => {
    let data = {
      limit: 10,
      page: 1,
      search: "",
      is_reload: true,
    };
    getwarHouseEntityList(data)
      .then((response) => {
        setEntityList(response.data.data);
      })
      .catch((err) => {
        toast.error(err.message);
      });
  }, []);

  useEffect(() => {
    if (vehiclePartDetailsId) {
      let data = {
        vehicle_id: vehiclePartDetailsId,
        data_type: "vehicle",
      };

      getVehicleProcessDetails(data)
        .then((response) => {
          setVehiclePartDetails(response.data.data);
          setTotalRecords(response.data);
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
        });
    }
  }, [vehiclePartDetailsId]);

  useEffect(() => {
    if (partHistoryQtyId) {
      const obj = {
        part_id: partHistoryQtyId,
      };

      getpartQuantityList(obj)
        .then((response) => {
          response = response.data;
          let list = [];

          for (let i = 0; i < response.data.length; i++) {
            list.push({
              value: response.data[i].id,
              label: response.data[i].qty,
            });
          }

          setAllPartQtyList(list);
        })
        .catch((err) => {
          console.error(err);
        });
    }
  }, [partHistoryQtyId]);

  useEffect(() => {
    if (partHistoryQtyId) {
      let data = {
        part_id: partHistoryQtyId,
        id: parseInt(partQtyStatusId) ? parseInt(partQtyStatusId) : parseInt(0),
      };

      getpartQuantityHistoryList(data)
        .then((response) => {
          setPartHistoryQtyDetails(response.data.data);
          setTotalRecords(response.data);
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
        });
    }
  }, [partHistoryQtyId, partQtyStatusId]);

  const onQrPartDetailsOpen = (e, item) => {
    e.preventDefault();
    setDelPartInternalQRId(item);
    setQrPartDetails(true);
  };

  const handleQrPartDetailsClose = () => {
    setQrPartDetails(false);
  };

  const onQrDetailsOpen = (e, item) => {
    e.preventDefault();
    setDelPartQRId(item.id);
    setQrDetails(true);
  };

  const handleQrDetailsClose = () => {
    setQrDetails(false);
  };

  useEffect(() => {
    if (DelPartQRId) {
      let data = {
        part_id: DelPartQRId,
      };
      getpartInventoryQuentityDetails(data)
        .then((response) => {
          setPartDetails(response.data.data);
        })
        .catch((err) => {
          toast.error(err.message);
        });
    }
  }, [DelPartQRId]);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
      type: "part_inventory",
    };
    getCommonSearchList(data)
      .then((response) => {
        setInventoryList(response.data.data);
      })
      .catch((err) => {});
  }, []);

  const handleCheckboxChangeCompatible = (e) => {
    setFilterData({
      ...filterData,
      is_compatible_search: e.target.checked ? 1 : 0,
    });
  };
  const handleCheckboxChangeMasterPart = (e) => {
    setFilterData({
      ...filterData,
      is_master_part: e.target.checked ? 1 : 0,
    });
  };

  const handleCheckboxChangePrintLabel = (e) => {
    setFilterData({
      ...filterData,
      print_label: e.target.checked ? 1 : 0,
    });
  };

  const handleCheckboxChangeVatIncluded = (e) => {
    setFilterData({
      ...filterData,
      vat_included: e.target.checked ? 1 : 0,
    });
  };

  const handleCheckboxChangeCompatibleVehicle = (e) => {
    setReplicatePartsData({
      ...replicatePartsData,
      copy_compatiable_vehicles: e.target.checked ? 1 : 0,
    });
  };

  const handleCheckboxChangeCopyPhoto = (e) => {
    setReplicatePartsData({
      ...replicatePartsData,
      copy_photo: e.target.checked ? 1 : 0,
    });
  };

  const handleCheckboxChangeCopyVideo = (e) => {
    setReplicatePartsData({
      ...replicatePartsData,
      copy_video: e.target.checked ? 1 : 0,
    });
  };

  const handleCheckboxChangeCopyRef = (e) => {
    setReplicatePartsData({
      ...replicatePartsData,
      copy_reference: e.target.checked ? 1 : 0,
    });
  };

  const handleCheckboxChangeCopyDamage = (e) => {
    setReplicatePartsData({
      ...replicatePartsData,
      copy_damage: e.target.checked ? 1 : 0,
    });
  };

  useEffect(() => {
    const currentPath = location.pathname;
    const savedPath = localStorage.getItem("lastVisitedPath");

    if (savedPath && savedPath !== currentPath) {
      localStorage.removeItem("lastVisitedPage");
      localStorage.removeItem("filterData");
    }

    localStorage.setItem("lastVisitedPath", currentPath);

    const savedPage = localStorage.getItem("lastVisitedPage");
    if (savedPage) {
      setParams((prevParams) => ({
        ...prevParams,
        page: parseInt(savedPage, 10),
      }));
    }
  }, [location.pathname]);

  const handleParams = (e, type) => {
    const storedFilterSearch = JSON.parse(
      localStorage.getItem("filterSearch") || "{}",
    );

    let paramsObj = {
      ...params,

      is_free_search: filterData.is_free_search,
      vehicle_model: filterData.model_id,
      vehicle_year: filterData.vehicle_year_id,
      vehicle_make: filterData.make_id,
      vehicle_variant: filterData.variants_id,
      vehicle_type: filterData.vehicle_type,
      vehicle_fuel: filterData.vehicle_fuel,
      vehicle_doors: filterData.vehicle_doors,
      part_type: filterData.part_type,
      part_location: filterData.part_location,
      part_group: filterData.part_group,
      part_side: filterData.part_side,
      brand_id: filterData.brand_id,
      condition_id: filterData.condition_id,
      state_id: filterData.state_id,
      type_damage_id: filterData.type_damage_id,
      location_damage_id: filterData.location_damage_id,
      order_type: filterData.order_type,
      order_field: filterData.order_field,
      reference_name: filterData.reference_name,
      part_with_price: filterData.part_with_price,
      part_with_photo: filterData.part_with_photo,
      part_with_reference: filterData.part_with_reference,
      part_with_damage: filterData.part_with_damage,
      part_with_location: filterData.part_with_location,
      price_from: priceValues[0],
      price_to: priceValues[1],
      rating_from: ratingValues[0],
      rating_to: ratingValues[1],
      search: filterData.serach,
      is_compatible_search: filterData.is_compatible_search,
      is_master_part: filterData.is_master_part,
      motorization: filterData.motorization,
      manufacter: filterData.manufacter || manufacterName,
      brand: filterData.brand || brandName,
      vehicle_id: filterData?.vehicle_id,
      search_warehouse_barcode: parseInt(selectBarcodeValue),
      search_warehouse: parseInt(selectedEntities?.value),
      part_name: catalog, // default
      catalog_name: filterData.catalog_name,
      internal_id: filterData?.internal_id,
      inventory_status: inventoryStatus,
      record_show_type: Number(recordStatus),
      vehicle_engine_code: filterData?.vehicle_engine_code,
      parts_height: Number(filterData?.parts_height),
      parts_weight: Number(filterData?.parts_weight),
      parts_width: Number(filterData?.parts_width),
      parts_length: Number(filterData?.parts_length),
      print_label: filterData?.print_label,
      vat_included: filterData?.vat_included,
      // "Sob encomenda" / "Rascunhos" — 0 comporta-se como omitido na API
      // (todas / esconder rascunhos por defeito).
      part_on_order: Number(filterData?.part_on_order) || 0,
      part_draft: Number(filterData?.part_draft) || 0,
      cc: filterData?.cc,
      cv: filterData?.cv,
      kw: filterData?.kw,
      inventory_status_filter: settingCompanyDetails?.inventory_status_filter,
      free_search:
        filterData?.free_search || localStorage.getItem("freeSearch"),

      is_search_part_catalog:
        filterSearch?.is_search_part_catalog ||
        storedFilterSearch?.is_search_part_catalog,
      is_search_vehicle_catalog:
        filterSearch?.is_search_vehicle_catalog ||
        storedFilterSearch?.is_search_vehicle_catalog,
      is_search_references_codes:
        filterSearch?.is_search_references_codes ||
        storedFilterSearch?.is_search_references_codes,
      is_search_damages:
        filterSearch?.is_search_damages ||
        storedFilterSearch?.is_search_damages,
      is_search_notes:
        filterSearch?.is_search_notes || storedFilterSearch?.is_search_notes,
      is_search_compatible_vehicles:
        filterSearch?.is_search_compatible_vehicles ||
        storedFilterSearch?.is_search_compatible_vehicles,
    };

    if (type === "length") {
      paramsObj.limit = e.target.value;
    }

    if (type === "pagination") {
      paramsObj.page = e.selected + 1;
      localStorage.setItem("lastVisitedPage", paramsObj.page);
    } else {
      // Reset page to 1 when any filter changes
      paramsObj.page = 1;
      localStorage.setItem("lastVisitedPage", "1");

      if (freeSearch?.length > 0) {
        localStorage.setItem("freeSearch", freeSearch);
      } else {
        localStorage.removeItem("freeSearch");
        localStorage.setItem("lastVisitedPage", "1");
      }
    }

    if (settingCompanyDetails.is_free_search === 1) {
      paramsObj.vehicle_model = model;
      paramsObj.vehicle_year = filterData.vehicle_year_id;
      paramsObj.vehicle_make = make;
      paramsObj.vehicle_variant = variant;

      paramsObj.part_name = partsName;
      paramsObj.catalog_name = partsName;
    }

    // record_show_type vive em `recordStatus` (state à parte) — incluímos no
    // filterData persistido para que sobreviva à navegação para a página de
    // detalhes da peça e regresso.
    localStorage.setItem(
      "filterData",
      JSON.stringify({ ...filterData, record_show_type: Number(recordStatus) }),
    );

    setShow(false);
    // const newParams = { ...params, ...filterData };
    // setParams(newParams); // update state if needed for UI
    // fetchPartInventory(newParams); // call API explicitly

    setParams(paramsObj);
    fetchPartInventory(paramsObj);
  };

  useEffect(() => {
    const savedFilterData = localStorage.getItem("filterData");
    if (savedFilterData) {
      const parsedFilterData = JSON.parse(savedFilterData);

      setParams((prev) => ({
        ...prev,
        ...parsedFilterData,
      }));

      setFilterData(parsedFilterData);

      // Restaurar o dropdown "Restore Data" — vive em `recordStatus`
      // separado de filterData; sem isto o select volta a 0 e os eliminados
      // deixam de aparecer ao regressar.
      if (parsedFilterData?.record_show_type !== undefined) {
        setRecordStatus(Number(parsedFilterData.record_show_type) || 0);
      }
    }
  }, []);

  useEffect(() => {
    const savedData = JSON.parse(localStorage.getItem("filterData"));
    if (savedData) {
      setSelectedEntities({
        value: savedData?.search_warehouse,
      });
      setSelectBarcodeValue(savedData?.search_warehouse_barcode);

      setFilterData({
        is_free_search: savedData?.is_free_search,
        vehicle_year_id: savedData?.vehicle_year_id,
        make_id: savedData?.make_id,
        variants_id: savedData?.variants_id,
        model_id: savedData?.model_id,
        vehicle_fuel: savedData?.vehicle_fuel,
        vehicle_doors: savedData?.vehicle_doors,
        part_type: savedData?.part_type,
        part_location: savedData?.part_location,
        part_group: savedData?.part_group,
        part_side: savedData?.part_side,
        brand_id: savedData?.brand_id,
        brand_name: savedData?.brand_name,
        condition_id: savedData?.condition_id,
        state_id: savedData?.state_id,
        type_damage_id: savedData?.type_damage_id,
        location_damage_id: savedData?.location_damage_id,
        order_field: savedData?.order_field,
        order_type: savedData?.order_type,
        reference_name: savedData?.reference_name,
        price_from: savedData?.price_from,
        price_to: savedData?.price_to,
        rating_from: savedData?.rating_from,
        rating_to: savedData?.rating_to,
        part_with_price: savedData?.part_with_price,
        part_with_photo: savedData?.part_with_photo,
        part_with_reference: savedData?.part_with_reference,
        part_with_damage: savedData?.part_with_damage,
        part_with_location: savedData?.part_with_location,
        serach: savedData?.serach,
        is_compatible_search: savedData?.is_compatible_search,
        is_master_part: savedData?.is_master_part,
        catalog_name: savedData?.catalog_name,
        brand: savedData?.brand,
        manufacter: savedData?.manufacter,
        vehicle_id: savedData?.vehicle_id,
        vehicle_engine_code: savedData?.vehicle_engine_code,
        parts_height: savedData?.parts_height,
        parts_weight: savedData?.parts_weight,
        parts_width: savedData?.parts_width,
        parts_length: savedData?.parts_length,
        print_label: savedData?.print_label,
        vat_included: savedData?.vat_included,
        part_on_order: Number(savedData?.part_on_order) || 0,
        part_draft: Number(savedData?.part_draft) || 0,
        cc: savedData?.cc,
        cv: savedData?.cv,
        kw: savedData?.kw,
        internal_id: savedData?.internal_id,
        record_show_type: Number(savedData?.record_show_type) || 0,
        free_search: freeSearch || localStorage.getItem("freeSearch"),
      });
    }
  }, []);

  const ResetModal = () => {
    const defaultParams = {
      limit: settingCompanyDetails
        ? settingCompanyDetails?.no_of_parts_per_page
        : tableLengthList[0],
      page: 1,
      search: "",
      is_reload: false,
      company_id: companyId.company_id || 0,
      vehicle_year: "",
      vehicle_model: "",
      vehicle_variant: "",
      vehicle_make: "",
      catalog_name: "",
      part_name: "",
      inventory_status: "",
      record_show_type: 0,
      internal_id: "",
      search_warehouse: "",
      search_warehouse_barcode: "",
      vehicle_type: "",
      is_free_search: filterData?.is_free_search,
      vehicle_fuel: "",
      vehicle_doors: "",
      part_type: "",
      part_location: "",
      part_group: "",
      part_side: "",
      brand_id: "",
      condition_id: "",
      state_id: "",
      type_damage_id: "",
      location_damage_id: "",
      order_field: filterData?.order_field,
      order_type: "",
      reference_name: "",
      price_from: "",
      price_to: "",
      rating_from: "",
      rating_to: "",
      part_with_price: "0",
      part_with_photo: "0",
      part_with_reference: "0",
      part_with_damage: "0",
      part_with_location: "0",
      is_compatible_search: "",
      is_master_part: "",
      motorization: "",
      manufacter: "",
      brand: "",
      vehicle_id: "",
      vehicle_engine_code: "",
      parts_height: "",
      parts_weight: "",
      parts_width: "",
      parts_length: "",
      print_label: 0,
      vat_included: 0,
      part_on_order: 0,
      part_draft: 0,
      cc: "",
      cv: "",
      kw: "",
      free_search: "",
      inventory_status_filter: settingCompanyDetails?.inventory_status_filter,
      is_search_part_catalog: 1,
      is_search_vehicle_catalog: 1,
      is_search_references_codes: 1,
      is_search_damages: 1,
      is_search_notes: 1,
      is_search_compatible_vehicles: 1,
    };

    setParams(defaultParams);

    setFilterData({
      is_free_search: settingCompanyDetails?.is_free_search,
      vehicle_year_id: "",
      make_id: "",
      variants_id: "",
      model_id: "",
      vehicle_fuel: "",
      vehicle_doors: "",
      part_type: "",
      part_location: "",
      part_group: "",
      part_side: "",
      brand_id: "",
      condition_id: "",
      state_id: "",
      type_damage_id: "",
      location_damage_id: "",
      order_field: settingCompanyDetails?.sort_field ?? "",
      order_type: "1",
      reference_name: "",
      price_from: "",
      price_to: "",
      rating_from: "",
      rating_to: "",
      part_with_price: "",
      part_with_photo: "",
      part_with_reference: "",
      part_with_damage: "",
      part_with_location: "",
      serach: "",
      is_compatible_search: "",
      is_master_part: "",
      catalog_name: "",
      motorization: "",
      manufacter: "",
      brand: "",
      vehicle_id: "",
      manufacturer_engine: "",
      vehicle_engine_code: "",
      parts_height: "",
      parts_weight: "",
      parts_width: "",
      parts_length: "",
      print_label: 0,
      vat_included: 0,
      part_on_order: 0,
      part_draft: 0,
      cc: "",
      cv: "",
      kw: "",
      internal_id: "",
    });

    // Reset other UI states
    setModel("");
    setCatalog("");
    SetYear("");
    SetMake("");
    SetVariant("");
    setPartsName("");
    SetInternalId("");
    setInventoryStatus("");
    setInputSelectedCatelog("");
    setRecordStatus(0);
    setManufacterName("");
    setBrandName("");
    setEngineMotorCodeList([]);
    setSelectedEntities({ value: "", name: "" });
    setShow(false);

    localStorage.removeItem("filterData");
    localStorage.setItem("lastVisitedPage", "1");

    // Call API with default params
    fetchPartInventory(defaultParams);
  };

  // useEffect(() => {
  //   if (!filterData?.is_free_search) return;
  //     if (!triggerFetch) return;

  //   fetchPartInventory();
  // }, [fetchPartInventory, filterData?.is_free_search]);

  const fetchPartInventory = (fetchParams, free_search = "") => {
    setLoading(true);

    // Get stored free search if none provided
    const storedSearch = localStorage.getItem("freeSearch");

    const finalFreeSearch = free_search || storedSearch;
   

    // Parse stored filters
    const storedFilterSearch = JSON.parse(
      localStorage.getItem("filterSearch") || "{}",
    );

    // Prepare API data
    const data = {
      ...fetchParams,
      free_search: finalFreeSearch,
      is_search_part_catalog:
        filterSearch?.is_search_part_catalog ??
        storedFilterSearch?.is_search_part_catalog ??
        1,
      is_search_vehicle_catalog:
        filterSearch?.is_search_vehicle_catalog ??
        storedFilterSearch?.is_search_vehicle_catalog ??
        1,
      is_search_references_codes:
        filterSearch?.is_search_references_codes ??
        storedFilterSearch?.is_search_references_codes ??
        1,
      is_search_damages:
        filterSearch?.is_search_damages ??
        storedFilterSearch?.is_search_damages ??
        1,
      is_search_notes:
        filterSearch?.is_search_notes ??
        storedFilterSearch?.is_search_notes ??
        1,
      is_search_compatible_vehicles:
        filterSearch?.is_search_compatible_vehicles ??
        storedFilterSearch?.is_search_compatible_vehicles ??
        1,
    };

    // Call API
    getPartsInventoryList(data)
      .then((response) => {
        setPartsInventoryList(response.data.data);
        setTotalRecords(response.data.total);
        setStoreCount(response.data);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const hasFetched = useRef(false);

  useEffect(() => {
    // Only run if free_search flag is true and API hasn't been called yet
    if (!filterData?.is_free_search || hasFetched.current) return;

    // Determine actual free_search string
    const actualFreeSearch =
      freeSearch || localStorage.getItem("freeSearch") || "";

    fetchPartInventory(
      {
        ...params,
        is_search_part_catalog: filterSearch?.is_search_part_catalog ?? 1,
        is_search_vehicle_catalog: filterSearch?.is_search_vehicle_catalog ?? 1,
        is_search_references_codes:
          filterSearch?.is_search_references_codes ?? 1,
        is_search_damages: filterSearch?.is_search_damages ?? 1,
        is_search_notes: filterSearch?.is_search_notes ?? 1,
        is_search_compatible_vehicles:
          filterSearch?.is_search_compatible_vehicles ?? 1,
      },
      actualFreeSearch,
    );

    // Mark as fetched
    hasFetched.current = true;
  }, [filterData?.is_free_search]);

  useEffect(() => {
    const saved = localStorage.getItem("freeSearch") || "";
    setFreeSearch(saved);
  }, []);

  // Estes dois efeitos resetavam `lastVisitedPage` a "1" no primeiro render
  // (porque freeSearch/filterSearch arrancam vazios). Em cada remount da
  // página de Inventário (ex: voltar de uma edição de quantidades) isto
  // sobrepunha-se à paginação restaurada. Saltamos o primeiro disparo e
  // só corremos o side-effect quando o estado realmente muda durante a
  // sessão (utilizador limpa a pesquisa).
  const isFirstFreeSearchRun = useRef(true);
  useEffect(() => {
    if (isFirstFreeSearchRun.current) {
      isFirstFreeSearchRun.current = false;
      return;
    }
    if (freeSearch) {
      localStorage.setItem("freeSearch", freeSearch);
    } else {
      localStorage.removeItem("freeSearch");
      localStorage.setItem("lastVisitedPage", "1");
    }
  }, [freeSearch]);

  const isFirstFilterSearchRun = useRef(true);
  useEffect(() => {
    if (isFirstFilterSearchRun.current) {
      isFirstFilterSearchRun.current = false;
      return;
    }
    if (filterSearch) {
      localStorage.setItem("filterSearch", JSON.stringify(filterSearch));
    } else {
      localStorage.removeItem("filterSearch");
      localStorage.setItem("lastVisitedPage", "1");
    }
  }, [filterSearch]);

  //  Updated debounced function
  const debouncedFetch = useCallback(
    debounce((text) => {
      if (text.length > 0) {
        let newParams = {
          ...params,
          ...filterData,
          free_search: text,
          page: 1,
        };
        fetchPartInventory(newParams, text);
      } else {
        localStorage.removeItem("freeSearch"); // clear if short
        fetchPartInventory(defaultParams);
      }
    }, 400),
    [params, filterData],
  );

  const handlePartsInventory = () => {
    navigate("/parts-inventory/AddParts");
  };

  // ---- "Adicionar a Lote" — abre modal e carrega lotes activos
  // do endpoint /lot/active-list. Match com fluxo da app móvel
  // (addForLotScreen.dart). Após escolha → /parts-inventory-addparts
  // com lot_id em location.state. ----
  const openLotPicker = () => {
    setLotPickerOpen(true);
    setLotPickerSearch("");
    setLotPickerLoading(true);
    getLotsActiveList({ limit: 200, page: 1, search: "" })
      .then((res) => {
        const data = res?.data?.data ?? [];
        setLotPickerList(Array.isArray(data) ? data : []);
        setLotPickerLoading(false);
      })
      .catch(() => {
        setLotPickerList([]);
        setLotPickerLoading(false);
      });
  };

  const onPickLotForParts = (lot) => {
    setLotPickerOpen(false);
    // Step B do flow "Adicionar a Lote" — viatura picker + catálogo (paridade
    // mobile com part_inventory_screen.dart). Continua para AddForParts no
    // fim para o user finalizar (preço/qtd/fotos/danos).
    navigate("/parts-inventory/add-for-lot", {
      state: { lot_id: lot?.id, lot_name: lot?.name || "" },
    });
  };

  const filteredLotPickerList = (lotPickerList || []).filter((l) => {
    const q = (lotPickerSearch || "").trim().toLowerCase();
    if (!q) return true;
    return String(l?.name || "").toLowerCase().includes(q);
  });

  const onDeleteModalOpen = (e, item) => {
    e.preventDefault();
    setDelPartId(item);
    setDelModal(true);
  };

  const onDeleteModalClose = () => {
    setDelModal(false);
  };

  const onDestroyPartInventory = async (e) => {
    e.preventDefault();

    const isTrashView = params.record_show_type === 1;

    // Peça composta: antes de eliminar, perguntar se a acção também se
    // aplica às peças filho activas (cascade_children no backend).
    if (!isTrashView && Number(delPartId?.is_master_part) === 1) {
      setOutOfStockModel(false);
      setCascadeAction("delete");
      setCascadeModal(true);
      return;
    }

    await executeDestroyPartInventory(false);
  };

  const executeDestroyPartInventory = async (cascadeChildren) => {
    setIsDelButtonLoad(true);

    const isTrashView = params.record_show_type === 1;

    try {
      const payload = isTrashView
        ? { record_show_type: 1, part_id: delPartId.id }
        : {
            id: delPartId.id,
            ...(cascadeChildren ? { cascade_children: true } : {}),
          };

      const apiCall = isTrashView
        ? deletePartInventoryHard
        : deletePartInventory;

      const response = await apiCall(payload);

      // reset params to default shape
      setParams({ ...defaultParams });

      const actualFreeSearch =
        freeSearch || localStorage.getItem("freeSearch") || "";

      fetchPartInventory(
        {
          ...params,
          is_search_part_catalog: filterSearch?.is_search_part_catalog ?? 1,
          is_search_vehicle_catalog:
            filterSearch?.is_search_vehicle_catalog ?? 1,
          is_search_references_codes:
            filterSearch?.is_search_references_codes ?? 1,
          is_search_damages: filterSearch?.is_search_damages ?? 1,
          is_search_notes: filterSearch?.is_search_notes ?? 1,
          is_search_compatible_vehicles:
            filterSearch?.is_search_compatible_vehicles ?? 1,
        },
        actualFreeSearch,
      );
      setRecordStatus(0);

      toast.success(response.data.message);
      setDelPartId("");

      isTrashView ? setInStockModel(false) : setOutOfStockModel(false);
    } catch (err) {
      toast.error(Utils.getErrorMessage(err));
    } finally {
      setIsDelButtonLoad(false);
    }
  };

  const onOutStockPartInventory = (e) => {
    e.preventDefault();

    // Peça composta: antes de marcar como indisponível/sem stock,
    // perguntar se a acção também se aplica às peças filho activas
    // (cascade_children no backend).
    if (Number(delPartId?.is_master_part) === 1) {
      setOutOfStockModel(false);
      setCascadeAction("oos");
      setCascadeModal(true);
      return;
    }

    executeOutStockPartInventory(false);
  };

  const executeOutStockPartInventory = (cascadeChildren) => {
    setIsOutOfStockDelButtonLoad(true);
    let data = {
      id: delPartId.id,
      ...(cascadeChildren ? { cascade_children: true } : {}),
    };

    partInventoryOutOfStock(data)
      .then((response) => {
        setParams({ ...defaultParams });
        setRecordStatus(0);
        const actualFreeSearch =
          freeSearch || localStorage.getItem("freeSearch") || "";

        fetchPartInventory(
          {
            ...params,
            is_search_part_catalog: filterSearch?.is_search_part_catalog ?? 1,
            is_search_vehicle_catalog:
              filterSearch?.is_search_vehicle_catalog ?? 1,
            is_search_references_codes:
              filterSearch?.is_search_references_codes ?? 1,
            is_search_damages: filterSearch?.is_search_damages ?? 1,
            is_search_notes: filterSearch?.is_search_notes ?? 1,
            is_search_compatible_vehicles:
              filterSearch?.is_search_compatible_vehicles ?? 1,
          },
          actualFreeSearch,
        );
        toast.success(response.data.message);
        setDelPartId("");
        setOutOfStockModel(false);
        setIsOutOfStockDelButtonLoad(false);
      })
      .catch((err) => {
        setIsOutOfStockDelButtonLoad(false);
        toast.error(Utils.getErrorMessage(err));
      });
  };

  const inStockPartInventory = (e) => {
    e.preventDefault();
    setIsIntockDelButtonLoad(true);
    let data = { id: delPartId.id };

    partInventoryInStock(data)
      .then((response) => {
        setParams({ ...defaultParams });
        const actualFreeSearch =
          freeSearch || localStorage.getItem("freeSearch") || "";

        fetchPartInventory(
          {
            ...params,
            is_search_part_catalog: filterSearch?.is_search_part_catalog ?? 1,
            is_search_vehicle_catalog:
              filterSearch?.is_search_vehicle_catalog ?? 1,
            is_search_references_codes:
              filterSearch?.is_search_references_codes ?? 1,
            is_search_damages: filterSearch?.is_search_damages ?? 1,
            is_search_notes: filterSearch?.is_search_notes ?? 1,
            is_search_compatible_vehicles:
              filterSearch?.is_search_compatible_vehicles ?? 1,
          },
          actualFreeSearch,
        );
        setRecordStatus(0);

        toast.success(response.data.message);
        setDelPartId("");
        setInStockModel(false);
        setIsIntockDelButtonLoad(false);
      })
      .catch((err) => {
        setIsIntockDelButtonLoad(false);
        toast.error(Utils.getErrorMessage(err));
      });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Peça composta a passar a "Indisponível" (status 0): perguntar
    // primeiro se a mudança também se aplica às peças filho activas.
    if (
      Number(inventoryPartStatusChange) === 0 &&
      addedParts.some((part) => Number(part?.is_master_part) === 1)
    ) {
      setPartStatusChangeModal(false);
      setCascadeAction("status");
      setCascadeModal(true);
      return;
    }

    executeStatusUpdate(false);
  };

  const executeStatusUpdate = (cascadeChildren) => {
    setLoading(true);

    const partsCatalogId = addedParts?.map((item) => item.id);
    let ler_code_id;

    if (Number(inventoryPartStatusChange) === 3) {
      ler_code_id = partCatalogData?.ler_codes_id?.map((item) => ({
        id: item?.value,
        unit_value: item?.unit_value || "",
      }));
    }

    const payload = {
      part_ids: partsCatalogId,
      inventory_status: inventoryPartStatusChange,
      ler_code_id: Number(inventoryPartStatusChange) === 3 ? ler_code_id : "",
      wastege_value:
        Number(inventoryPartStatusChange) === 3 ? sumWastageValue : "",
      description: "",
      ...(cascadeChildren ? { cascade_children: true } : {}),
    };

    actionPartStatusUpdate(payload)
      .then((response) => {
        toast.success(response.data.message);
        setPartStatusChangeModal(false);
        setVehiclePartsData({
          ler_code_id: [],
          unit_value: [],
        });
        setAddedParts([]);
        setInventoryPartStatusChange("");
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // Resposta do popup de peça composta — executa a acção pendente com ou
  // sem replicação nas peças filho.
  const onCascadeConfirm = (cascadeChildren) => {
    setCascadeModal(false);

    if (cascadeAction === "delete") {
      executeDestroyPartInventory(cascadeChildren);
    } else if (cascadeAction === "status") {
      executeStatusUpdate(cascadeChildren);
    } else if (cascadeAction === "oos") {
      executeOutStockPartInventory(cascadeChildren);
    }

    setCascadeAction("");
  };

  const handleSubmitDeleteWaste = (e) => {
    e.preventDefault();

    if (delPartId?.ler_code_id == null) {
      toast.error(
        "This part does not have any assign LER code please go to LER part and add the LER code",
      );
      setDelModal(false);
    } else {
      const payload = {
        part_ids: [delPartId?.id],
        inventory_status: 3,
        ler_code_id: [delPartId?.ler_code_id],
        wastege_value: delPartId?.unit_value,
        description: "",
      };

      actionPartStatusUpdate(payload)
        .then((response) => {
          toast.success(response.data.message);
          setDelModal(false);
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
        });
    }
  };

  const handleSubmitPdfAll = (e) => {
    e.preventDefault();
    navigate("/part/export/list");
  };

  const handleSubmitReplicateParts = (e) => {
    e.preventDefault();
    const payload = {
      copy_photo: replicatePartsData?.copy_photo
        ? replicatePartsData?.copy_photo
        : 0,
      copy_video: replicatePartsData?.copy_video
        ? replicatePartsData?.copy_video
        : 0,
      copy_reference: replicatePartsData?.copy_reference
        ? replicatePartsData?.copy_reference
        : 0,
      copy_damage: replicatePartsData?.copy_damage
        ? replicatePartsData?.copy_damage
        : 0,
      copy_compatiable_vehicles: replicatePartsData?.copy_compatiable_vehicles
        ? replicatePartsData?.copy_compatiable_vehicles
        : 0,
      part_id: PartsDataList?.id,
    };

    if (partAddDetails?.vehicle_id) {
      setModifyVehiclereplica(true);
      setModifyReplicateParts(false);
    } else {
      createReplicatePart(payload)
        .then((response) => {
          toast.success(response.data.message);
          setModifyReplicateParts(false);
          setReplicatePartsData({
            copy_photo: "",
            copy_video: "",
            copy_reference: "",
            copy_damage: "",
            copy_compatiable_vehicles: "",
          });
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
        })
        .finally(() => {
          // Reset button state to "close"
          setLoading(false);
        });
    }
  };

  const handleSubmitVehicleReplicateParts = (e) => {
    e.preventDefault();

    if (!replicatePartsData?.replicate_type) {
      toast.error(t("toast_replicate_type_required"));
      return;
    }

    const payload = {
      copy_photo: replicatePartsData?.copy_photo,
      copy_video: replicatePartsData?.copy_video,
      copy_reference: replicatePartsData?.copy_reference,
      copy_damage: replicatePartsData?.copy_damage,
      copy_compatiable_vehicles: replicatePartsData?.copy_compatiable_vehicles,
      part_id: PartsDataList?.id,
      replicate_type: replicatePartsData?.replicate_type,
      vehicle_id: partAddDetails?.vehicle_id,
      new_vehicle_id: replicatePartsData
        ? replicatePartsData.new_vehicle_id
        : "",
    };

    createReplicatePart(payload)
      .then((response) => {
        toast.success(response.data.message);
        setModifyReplicateParts(false);
        setModifyVehiclereplica(false);
        setReplicatePartsData({
          copy_photo: "",
          copy_video: "",
          copy_reference: "",
          copy_damage: "",
          copy_compatiable_vehicles: "",
        });
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      })
      .finally(() => {
        // Reset button state to "close"
        setLoading(false);
      });
  };

  const handleSubmitReservesParts = (e) => {
    e.preventDefault();

    const payload = {
      id: PartsDataList?.id,
    };

    createReservesPart(payload)
      .then((response) => {
        toast.success(response.data.message);
        setModifyReservesParts(false);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      })
      .finally(() => {
        // Reset button state to "close"
        setLoading(false);
      });
  };

  const handleImportGroup = (e) => {
    e.preventDefault();
    let error = false;
    let errorObjImport = { ...errorsObjImport };
    if (!file) {
      errorObjImport.file = `File is required.`;
      error = true;
    }

    setErrorsImport(errorObjImport);
    if (error) return;
    setIsModifyButtonLoad(true);
    const formData = new FormData();
    formData.append("files", file);

    getImportPartCSVPrice(formData)
      .then((response) => {
        toast.success(response.data.message);

        setModifyImportModal(false);
        setIsModifyButtonLoad(false);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
        setIsModifyButtonLoad(false);
      });
  };

  const handleExport = () => {
    setIsLoadingExport(true);
    let data = { ...params };

    getExportPartInvenrotyList(data)
      .then((response) => {
        // const worksheet = XLSX.utils.json_to_sheet(response.data.data);
        // const csv = XLSX.utils.sheet_to_csv(worksheet);

        // const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
        // const link = document.createElement("a");
        // const url = URL.createObjectURL(blob);
        // link.setAttribute("href", url);
        // link.setAttribute("download", "partsInventory.csv");
        // link.style.visibility = "hidden";

        // document.body.appendChild(link);
        // link.click();
        // document.body.removeChild(link);
        // URL.revokeObjectURL(url);
        toast.success(response?.data?.message);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      })
      .finally(() => {
        setIsLoadingExport(false);
      });
  };

  const handleSubmitReserves = (e) => {
    e.preventDefault();

    if (!selectedParts.length > 0) {
      toast.error(t("pi_toast_at_least_qty_assign"));
      return;
    }

    const allPricesSelected = selectedParts.every(
      (item) =>
        selectedPrices[item.id] !== undefined &&
        selectedPrices[item.id] !== null,
    );

    if (!allPricesSelected) {
      toast.error(t("toast_invalid_price_all_parts"));
      return;
    }

    const partListData = [];

    selectedParts?.forEach((item) => {
      const partsId = item.parts_id;

      let partGroup = partListData.find((entry) => entry.parts_id === partsId);
      if (!partGroup) {
        partGroup = { parts_id: partsId, part_qty_list: [] };
        partListData.push(partGroup);
      }

      partGroup.part_qty_list.push({
        reserve_price: selectedPrices[item.id] ?? 0,
        reserve_vat_price: 0,
        part_qty_id: item.id,
        location_id: selectedEntitiesRes[item?.id],
        reservation_order_notes:
          resOrderData.reservation_order_notes[item.id] || "",
      });
    });

    let data = {
      part_list: partListData,
      part_id: PartsDataList?.id,
      reservation_id: reservesData?.reservation_id,
    };

    AddReservesSendPart(data)
      .then((response) => {
        toast.success(response.data.message);
        navigate("/show-reserves-list");

        setSelectedParts([]);
        setReservesData({
          reservation_id: "",
        });
        setReservesPenList([]);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  };

  const handleRepairAddClick = (
    id,
    parts_internal_id,
    namePartPT,
    vehicle_model_name,
    vehicle_make_name,
    vehicle_year,
    inventory_status_name,
  ) => {
    const isAdded = addedRepairsParts.some((part) => part.id === id);

    if (isAdded) {
      setAddedRepairsParts((prev) => prev.filter((part) => part.id !== id));
    } else {
      setAddedRepairsParts((prev) => [
        ...prev,
        {
          id,
          parts_internal_id,
          namePartPT,
          vehicle_model_name,
          vehicle_make_name,
          vehicle_year,
          inventory_status_name,
        },
      ]);
    }
  };

  const filteredRepairList = repairsPartsList?.filter(
    (item) => !addedRepairsParts.some((addedPart) => addedPart.id === item.id),
  );

  const handleSubmitRepairPart = (e) => {
    e.preventDefault();
    setloadingRepairs(true);

    const partsCatalogId = addedRepairsParts?.map((item) => item.id);
    const payload = {
      part_list: partsCatalogId,
    };

    createRepairPartInventory(payload)
      .then((response) => {
        toast.success(response.data.message);
        setRepairsPartsModal(false);
        setRepairFilterData({
          catalog_name: "",
          internal_id: "",
        });
        setAddedRepairsParts([]);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      })
      .finally(() => {
        setloadingRepairs(false);
      });
  };

  const handleSubmitRepairSinglePart = (e) => {
    e.preventDefault();
    setloadingRepairs(true);

    const payload = {
      part_list: [repairsPartsData],
    };

    createRepairPartInventory(payload)
      .then((response) => {
        toast.success(response.data.message);
        setRepairsPartsSingleModal(false);
        setRepairsPartsData("");
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      })
      .finally(() => {
        setloadingRepairs(false);
      });
  };

  const handleSubmitPrintServer = (e) => {
    e.preventDefault();
    setisLoadingprintPart(true);

    // Use the template-aware endpoint so the desktop receives full
    // template layout (resolved from company default / system fallback)
    // instead of the legacy hardcoded PrintManager layout.
    printPartLabel({ part_id: printPartId })
      .then((response) => {
        toast.success(tConst(response.data.message, t));
        setPrintPart(false);
        setisLoadingprintPart(false);
      })
      .catch((err) => {
        setisLoadingprintPart(false);
        toast.error(Utils.getErrorMessage(err));
      });
  };

  const handleUpdatePrice = (e) => {
    e.preventDefault();
    setLoadingPrice(true);

    const payload = {
      uuid: priceList?.uuid,
      part_price: priceData?.part_price,
      part_original_price: priceData?.part_original_price,
      part_cost_price: priceData?.sponsor_price,
    };

    updatePartInventoryPrice(payload)
      .then((response) => {
        toast.success(response.data.message);
        setModifyPriceModal(false);
        setPriceData({
          part_price: "",
          sponsor_price: "",
          part_original_price: "",
        });
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      })
      .finally(() => {
        setLoadingPrice(false);
      });
  };

  const handleSubmitCart = (e) => {
    e.preventDefault();
    setLoadingCart(true);

    if (!selectedPartDetails?.length > 0) {
      toast.error(t("pi_toast_please_select_qty"));
      return;
    }

    const payload = {
      parts_list: selectedPartDetails?.reduce((acc, curr) => {
        const existing = acc.find(
          (item) => item.part_internal_id === curr.parts_id,
        );

        if (existing) {
          existing.quantities.push(curr.qty);
        } else {
          acc.push({
            part_internal_id: curr.parts_id,
            quantities: [curr.qty],
          });
        }

        return acc;
      }, []),
    };

    generateShoppingCartLink(payload)
      .then((response) => {
        toast.success(response.data.message);
        setCartModal(false);
        setSaveCartList(response.data.data);
        setSelectedPartDetails([]);
        setSavedPartIdsByCart({});
        setSelectedRowsByCart({});
        setSaveCartModal(true);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      })
      .finally(() => {
        setLoadingCart(false);
      });
  };

  const getColumnValue = (item, key) => {
    switch (key) {
      case "is_master_part":
        return item[key] === "1" ? "Yes" : "No";

      // Nome da peça com badges "Sob encomenda" / "Rascunho" quando a row
      // tem on_order / is_draft activos (PG devolve true/false).
      case "part_name": {
        const baseValue = item[key] ?? "-";
        const onOrderFlag =
          item?.on_order === true ||
          item?.on_order === 1 ||
          item?.on_order === "1";
        const draftFlag =
          item?.is_draft === true ||
          item?.is_draft === 1 ||
          item?.is_draft === "1";

        if (!onOrderFlag && !draftFlag) return baseValue;

        return (
          <>
            {baseValue}
            {onOrderFlag && (
              <span
                className="badge ms-1"
                style={{
                  backgroundColor: "#fd7e14",
                  color: "#fff",
                  fontSize: "10px",
                  verticalAlign: "middle",
                }}
              >
                {t("pi_on_order")}
              </span>
            )}
            {draftFlag && (
              <span
                className="badge ms-1"
                style={{
                  backgroundColor: "#6f42c1",
                  color: "#fff",
                  fontSize: "10px",
                  verticalAlign: "middle",
                }}
              >
                {t("pi_draft")}
              </span>
            )}
          </>
        );
      }

      case "parts_photos":
        return item.part_image?.length > 0
          ? item.part_image[0].image_url
          : null;

      case "vehicle_make":
        return item.vehicle_make_name;

      case "vehicle_model":
        return item.vehicle_model_name;

      case "inventory_status":
        return tConst(item.inventory_status_name, t);

      case "vehicle_type_id":
        return item.vehicle_type_name;

      case "condition_id":
        return tConst(item.condition_name, t);

      case "state_id":
        return item.state_name;

      case "brand_id":
        return item.brand_name;

      default:
        return item[key] ?? "-";
    }
  };

  const handleInoviceSyncProduct = (e) => {
    e.preventDefault();
    setLoadingSync(true);

    let errorObj = {};
    let hasError = false;

    if (syncButtonType === 2) {
      if (!syncFormData?.date) {
        errorObj.date = "Date is required.";
        hasError = true;
      }

      if (!syncFormData?.document_set_id) {
        errorObj.document_set_id = "Document Set is required.";
        hasError = true;
      }

      if (!syncFormData?.customer_id) {
        errorObj.customer_id = "Customer is required.";
        hasError = true;
      }

      if (!syncFormData?.expiration_date) {
        errorObj.expiration_date = "Expiration Date is required.";
        hasError = true;
      } else if (syncFormData?.date) {
        const start = new Date(syncFormData.date);
        const end = new Date(syncFormData.expiration_date);

        if (end < start) {
          errorObj.expiration_date = "Expiration Date must be after Date.";
          hasError = true;
        }
      }

      if (!syncFormData?.your_reference) {
        errorObj.your_reference = "Your Reference is required.";
        hasError = true;
      }

      if (!syncFormData?.our_reference) {
        errorObj.our_reference = "Our Reference is required.";
        hasError = true;
      }
      if (!syncFormData?.exemption_reason) {
        errorObj.exemption_reason = "Exemption Reason is required.";
        hasError = true;
      }

      setErrors(errorObj);
      Utils.focusError();

      if (hasError) {
        setLoadingSync(false);
        return;
      }
    }

    if (
      !Array.isArray(syncFormData?.selected_ids) ||
      syncFormData.selected_ids.length === 0
    ) {
      toast.error(t("toast_at_least_one_qty_assigned"));
      setLoadingSync(false);
      return;
    }

    let payload = {
      part_id: syncAllID?.id,
      button_type: syncButtonType,
      parts_internal_id: syncAllID?.parts_internal_id,
    };

    if (syncButtonType === 1) {
      payload = {
        ...payload,
        price: syncFormData?.price_value,
        quantity: syncFormData?.selected_ids,
        exemption_reason: syncFormData?.exemption_reason,
      };
    } else {
      payload = {
        ...payload,
        date: syncFormData?.date,
        expiration_date: syncFormData?.expiration_date,
        document_set_id: syncFormData?.document_set_id,
        customer_id: syncFormData?.customer_id,
        our_reference: syncFormData?.our_reference,
        your_reference: syncFormData?.your_reference,
        notes: syncFormData?.notes,
        total_value_packaging: syncFormData?.total_value_packaging,
        total_value_other_parcel: syncFormData?.total_value_other_parcel,
        total_value_shipping: syncFormData?.total_value_shipping,
        exemption_vat_products: syncFormData?.exemption_vat_products,
        exemption_vat_shipping: syncFormData?.exemption_vat_shipping,
        exemption_vat_packaging: syncFormData?.exemption_vat_packaging,
        quantity: syncFormData?.selected_ids,
        price: syncFormData?.price_value,
        exemption_reason: syncFormData?.exemption_reason,
      };
    }

    createSyncInvoiceProduct(payload)
      .then((response) => {
        toast.success(response.data.message);
        setSyncAllModal(false);
        setSyncFormData({
          price_value: "",
          selected_ids: [],
        });
        setLoadingSync(false);
        const actualFreeSearch =
          freeSearch || localStorage.getItem("freeSearch") || "";

        fetchPartInventory(
          {
            ...params,
            is_search_part_catalog: filterSearch?.is_search_part_catalog ?? 1,
            is_search_vehicle_catalog:
              filterSearch?.is_search_vehicle_catalog ?? 1,
            is_search_references_codes:
              filterSearch?.is_search_references_codes ?? 1,
            is_search_damages: filterSearch?.is_search_damages ?? 1,
            is_search_notes: filterSearch?.is_search_notes ?? 1,
            is_search_compatible_vehicles:
              filterSearch?.is_search_compatible_vehicles ?? 1,
          },
          actualFreeSearch,
        );
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
        setLoadingSync(false);
      })
      .finally(() => {
        setLoadingSync(false);
      });
  };

  return (
    <div>
      <div>
        <section className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">{/* <h1>Parts Inventory</h1> */}</div>
              <div className="col-sm-6"></div>
            </div>
          </div>
          {/* /.container-fluid */}
        </section>

        {imageShow ? (
          <>
            <section className="content">
              <div className="container-fluid">
                <div className="card fuelCard">
                  <div className="cardHeader card-header card-header-custom">
                    <div className="row mb-2">
                      <div className="col-sm-6">
                        <p>Part Pictures</p>
                      </div>
                      <div className="col-sm-6">
                        <div className="d-flex  justify-content-end">
                          <button
                            type="button"
                            className="next-button btn btn-secondary"
                            onClick={() => setImageShow(false)}
                          >
                            <i className="bi bi-arrow-left"></i> {t("back")}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="card-body">
                    <div className="vehicleThBg table-responsive table-responsive-vehicle">
                      <div className="col-md-12">
                        <div className="row">
                          <PhotoProvider>
                            {vehicleImageDetails &&
                            vehicleImageDetails?.length > 0 ? (
                              vehicleImageDetails?.map((item, index) => (
                                <React.Fragment key={index}>
                                  <div className="col-md-4">
                                    {item?.image_url ? (
                                      <PhotoView src={item.image_url}>
                                        <img
                                          src={item.image_url}
                                          alt="vehicle"
                                          style={{
                                            width: "60%",
                                            cursor: "pointer",
                                          }}
                                        />
                                      </PhotoView>
                                    ) : (
                                      <p>{t("pi_no_image_found")}</p>
                                    )}
                                  </div>
                                </React.Fragment>
                              ))
                            ) : (
                              <p>{t("pi_no_image_found")}</p>
                            )}
                          </PhotoProvider>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </>
        ) : (
          <>
            <section className="content">
              <div className="container-fluid container-custom-height-new">
                <div className="row">
                  <div className="col-md-12">
                    <div className="card fuelCard">
                      <div className="card-header card-header-inventory">
                        {show && (
                          <div
                            className="offcanvas-backdrop show"
                            onClick={(e) => e.stopPropagation()}
                          ></div>
                        )}

                        <div className="card-title m-0 float-right fuelCT rightBtn">
                          <i
                            className="bi bi-arrow-repeat"
                            style={{
                              padding: "7px",
                              display: "inline-block",
                              background: "rgb(254 64 64)",
                              borderRadius: "0",
                              borderTopLeftRadius: "4px",
                              borderBottomLeftRadius: "4px",
                              cursor: "pointer",
                            }}
                            onClick={ResetModal}
                          ></i>
                          <span className="ms-2"></span>
                          <button
                            type="button"
                            className="btn-icon-text mr-2 mr-2"
                            onClick={handleSelectedCartModalOpen}
                          >
                            <i className="bi bi-cart-check"></i>{" "}
                            <span className="ms-2">{t("cart")}</span>
                          </button>

                          <button
                            type="button"
                            className="btn-icon-text mr-2 mr-2"
                            onClick={handleRepairsPartOpen}
                          >
                            <i className="bi bi-tools"></i>{" "}
                            <span className="ms-2">{t("repairs_parts")}</span>
                          </button>
                          <button
                            type="button"
                            className="btn-icon-text mr-2 mr-2"
                            onClick={handleExport}
                            disabled={isLoadingExport}
                          >
                            <i className="bi bi-file-earmark-excel-fill"></i>
                            <span className="ms-2">
                              {isLoadingExport ? (
                                <>
                                  <span
                                    className="spinner-border spinner-border-sm me-1"
                                    role="status"
                                    aria-hidden="true"
                                  ></span>
                                  {t("pi_exporting")}
                                </>
                              ) : (
                                t("export")
                              )}
                            </span>
                          </button>
                          <button
                            type="button"
                            className="btn-icon-text mr-2 mr-2"
                            onClick={handleImportModal}
                          >
                            <i className="bi bi-file-earmark-excel-fill"></i>
                            <span className="ms-2">{t("pi_btn_import_part_price")}</span>
                          </button>
                          <button
                            type="button"
                            className="btn-icon-text mr-2 mr-2"
                            onClick={handleSubmitPdfAll}
                          >
                            <i className="bi bi-plus-lg"></i>
                            <span className="ms-2">{t("pi_btn_export_pdf")}</span>
                          </button>
                          <button
                            type="button"
                            className="btn-icon-text mr-2 mr-2"
                            onClick={onPartStatusChangeOpen}
                          >
                            <i className="bi bi-tools"></i>
                            <span className="ms-2">{t("pi_btn_part_status")}</span>
                          </button>

                          {RolePermission?.findIndex(
                            (e) => e.permission_name === "add_part_inventory",
                          ) > -1 && (
                            <button
                              type="button"
                              className="btn-icon-text mr-2 mr-2"
                              onClick={handlePartsInventory}
                            >
                              <i className="bi bi-plus-lg"></i>
                              <span className="ms-2">{t("pi_btn_add_for_vehicle")}</span>
                            </button>
                          )}
                          {RolePermission?.findIndex(
                            (e) => e.permission_name === "add_part_inventory",
                          ) > -1 && (
                            <button
                              type="button"
                              className="btn-icon-text mr-2"
                              onClick={() =>
                                navigate("/parts-inventory-addparts")
                              }
                            >
                              <i className="bi bi-plus-lg"></i>
                              <span className="ms-2">{t("pi_btn_add_for_parts")}</span>
                            </button>
                          )}
                          {RolePermission?.findIndex(
                            (e) => e.permission_name === "add_part_inventory",
                          ) > -1 && (
                            <button
                              type="button"
                              className="btn-icon-text mr-2"
                              onClick={openLotPicker}
                              title={t("add_for_lot", { defaultValue: "Adicionar a Lote" })}
                            >
                              <i className="bi bi-archive-fill"></i>
                              <span className="ms-2">
                                {t("add_for_lot", { defaultValue: "Adicionar a Lote" })}
                              </span>
                            </button>
                          )}
                          <button
                            type="button"
                            className="btn-icon-text "
                            onClick={handleShowOpen}
                          >
                            <i className="bi bi-funnel"></i>{t("pi_btn_filter")}
                          </button>
                        </div>
                      </div>
                      <div
                        className="card-title p-2 mt-2"
                        style={{ width: "68%", marginBottom: "-30px" }}
                      >
                        <input
                          type="text"
                          className="form-control"
                          value={freeSearch}
                          onChange={(e) => {
                            setFreeSearch(e.target.value);
                            debouncedFetch(e.target.value); //  debounce call
                          }}
                          placeholder={t("pi_free_search_placeholder")}
                        />

                        <div className="row">
                          <div className="col-sm-6 mt-2">
                            <div className="form-check">
                              <input
                                className="my-checkbox-1 form-check-input"
                                type="checkbox"
                                checked={
                                  filterSearch.is_search_part_catalog === 1
                                }
                                onChange={(e) =>
                                  setFilterSearch({
                                    ...filterSearch,
                                    is_search_part_catalog: e.target.checked
                                      ? 1
                                      : 0,
                                  })
                                }
                                id="is_search_part_catalog"
                              />

                              <label
                                className="form-check-label pl-6"
                                htmlFor="is_search_part_catalog"
                              >
                                {t("pi_qs_part_catalog")}
                              </label>
                            </div>
                          </div>

                          <div className="col-sm-6 mt-2">
                            <div className="form-check">
                              <input
                                className="my-checkbox-1 form-check-input"
                                type="checkbox"
                                checked={
                                  filterSearch.is_search_vehicle_catalog === 1
                                }
                                onChange={(e) =>
                                  setFilterSearch({
                                    ...filterSearch,
                                    is_search_vehicle_catalog: e.target.checked
                                      ? 1
                                      : 0,
                                  })
                                }
                                id="is_search_vehicle_catalog"
                              />

                              <label
                                className="form-check-label pl-6"
                                htmlFor="is_search_vehicle_catalog"
                              >
                                {t("pi_qs_vehicle_catalog")}
                              </label>
                            </div>
                          </div>

                          <div className="col-sm-6 mt-2">
                            <div className="form-check">
                              <input
                                className="my-checkbox-1 form-check-input"
                                type="checkbox"
                                checked={
                                  filterSearch.is_search_references_codes === 1
                                }
                                onChange={(e) =>
                                  setFilterSearch({
                                    ...filterSearch,
                                    is_search_references_codes: e.target.checked
                                      ? 1
                                      : 0,
                                  })
                                }
                                id="is_search_references_codes"
                              />

                              <label
                                className="form-check-label pl-6"
                                htmlFor="is_search_references_codes"
                              >
                                {t("pi_qs_references_codes")}
                              </label>
                            </div>
                          </div>

                          <div className="col-sm-6 mt-2">
                            <div className="form-check">
                              <input
                                className="my-checkbox-1 form-check-input"
                                type="checkbox"
                                checked={filterSearch.is_search_damages === 1}
                                onChange={(e) =>
                                  setFilterSearch({
                                    ...filterSearch,
                                    is_search_damages: e.target.checked ? 1 : 0,
                                  })
                                }
                                id="is_search_damages"
                              />

                              <label
                                className="form-check-label pl-6"
                                htmlFor="is_search_damages"
                              >
                                {t("pi_qs_damages")}
                              </label>
                            </div>
                          </div>

                          <div className="col-sm-6 mt-2">
                            <div className="form-check">
                              <input
                                className="my-checkbox-1 form-check-input"
                                type="checkbox"
                                checked={filterSearch.is_search_notes === 1}
                                onChange={(e) =>
                                  setFilterSearch({
                                    ...filterSearch,
                                    is_search_notes: e.target.checked ? 1 : 0,
                                  })
                                }
                                id="is_search_notes"
                              />

                              <label
                                className="form-check-label pl-6"
                                htmlFor="is_search_notes"
                              >
                                {t("pi_qs_notes")}
                              </label>
                            </div>
                          </div>

                          <div className="col-sm-6 mt-2">
                            <div className="form-check">
                              <input
                                className="my-checkbox-1 form-check-input"
                                type="checkbox"
                                checked={
                                  filterSearch.is_search_compatible_vehicles ===
                                  1
                                }
                                onChange={(e) =>
                                  setFilterSearch({
                                    ...filterSearch,
                                    is_search_compatible_vehicles: e.target
                                      .checked
                                      ? 1
                                      : 0,
                                  })
                                }
                                id="is_search_compatible_vehicles"
                              />

                              <label
                                className="form-check-label pl-6"
                                htmlFor="is_search_compatible_vehicles"
                              >
                                {t("pi_qs_compatible_vehicles")}
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="p-2 mt-3 justify-content-end me-2">
                        {activeTab === "Vehicle-tab" &&
                          (filterData?.vehicle_year_id ||
                            filterData?.make_id ||
                            filterData?.variants_id ||
                            filterData?.model_id ||
                            filterData?.vehicle_fuel ||
                            filterData?.vehicle_doors ||
                            filterData?.vehicle_type ||
                            filterData?.motorization) && (
                            <>
                              <i className="bi bi-car-front me-2" />
                              <span>
                                you have{" "}
                                <span
                                  style={{
                                    color: "blue",
                                    fontWeight: "bold",
                                    cursor: "pointer",
                                  }}
                                  onClick={() =>
                                    handleShowVehicles(storeCount?.vehicleIds)
                                  }
                                >
                                  {storeCount?.totalVehiclePark} Vehicles
                                </span>{" "}
                                in park according to the search
                              </span>
                            </>
                          )}

                        {activeTab === "Part-tab" &&
                          (filterData?.part_name ||
                            filterData?.catalog_name ||
                            filterData?.part_type ||
                            filterData?.part_location ||
                            filterData?.part_group ||
                            filterData?.part_side ||
                            filterData?.condition_id ||
                            filterData?.state_id ||
                            filterData?.type_damage_id ||
                            filterData?.location_damage_id ||
                            filterData?.brand ||
                            partsName) && (
                            <>
                              {/* In Stock */}
                              <div className="row mb-2">
                                <div className="d-flex align-items-center">
                                  <i className="bi bi-car-front me-2" />
                                  <span>
                                    you have{" "}
                                    <span
                                      style={{
                                        color: "blue",
                                        fontWeight: "bold",
                                        cursor: "pointer",
                                      }}
                                      onClick={() =>
                                        handleShowVehicles(
                                          storeCount?.partsInStockVehicleIds,
                                        )
                                      }
                                    >
                                      {storeCount?.totalInStockVehicle ?? 0}{" "}
                                      Vehicles
                                    </span>{" "}
                                    with that parts{" "}
                                    <span
                                      style={{
                                        color: "rgb(38 117 164)",
                                        fontWeight: "bold",
                                      }}
                                    >
                                      in stock
                                    </span>
                                  </span>
                                </div>
                              </div>

                              {/* Verified */}
                              <div className="row mb-2">
                                <div className="d-flex align-items-center">
                                  <i className="bi bi-car-front me-2" />
                                  <span>
                                    you have{" "}
                                    <span
                                      style={{
                                        color: "blue",
                                        fontWeight: "bold",
                                        cursor: "pointer",
                                      }}
                                      onClick={() =>
                                        handleShowVehicles(
                                          storeCount?.partsVerifiedVehicleIds,
                                        )
                                      }
                                    >
                                      {storeCount?.totalVerifiedVehicle ?? 0}{" "}
                                      Vehicles
                                    </span>{" "}
                                    with that parts{" "}
                                    <span
                                      style={{
                                        color: "green",
                                        fontWeight: "bold",
                                      }}
                                    >
                                      parts verified
                                    </span>
                                  </span>
                                </div>
                              </div>

                              {/* To Be Verified */}
                              <div className="row mb-2">
                                <div className="d-flex align-items-center">
                                  <i className="bi bi-car-front me-2" />
                                  <span>
                                    you have{" "}
                                    <span
                                      style={{
                                        color: "blue",
                                        fontWeight: "bold",
                                        cursor: "pointer",
                                      }}
                                      onClick={() =>
                                        handleShowVehicles(
                                          storeCount?.partsTobeVerifiedVehicleIds,
                                        )
                                      }
                                    >
                                      {storeCount?.totalTobeVerifiedVehicle ??
                                        0}{" "}
                                      Vehicles
                                    </span>{" "}
                                    with that parts{" "}
                                    <span
                                      style={{
                                        color: "rgb(220 90 40 / 87%)",
                                        fontWeight: "bold",
                                      }}
                                    >
                                      parts to be verified
                                    </span>
                                  </span>
                                </div>
                              </div>
                            </>
                          )}
                      </div>

                      {isLoading ? (
                        <div className="text-center pageLoader">
                          <div className="spinner-border" role="status">
                            <span className="visually-hidden">{t("loading")}</span>
                          </div>
                        </div>
                      ) : (
                        <div className="card-body fuelCardB ">
                          <div className="v(ehicleThBg table-responsive inventory_table">
                            <table className="table table-bordered rounded-table table table-striped table-hover">
                              <thead>
                                <tr>
                                  {columnNames?.map((col, index) => {
                                    // Tabela dinâmica: o nome de coluna vem do
                                    // settings da empresa em inglês. Tentamos
                                    // i18n por columnKey (ex: pi_dyncol_brand_id).
                                    // Se não houver tradução, mostra o original.
                                    const ck = columnKeys?.[index];
                                    const label = ck
                                      ? t(`pi_dyncol_${ck}`, { defaultValue: col })
                                      : col;
                                    return (
                                      <th key={index} className="Label-my">
                                        {label}
                                      </th>
                                    );
                                  })}

                                  <th className="Label-my">{t("action")}</th>
                                </tr>
                              </thead>

                              <tbody>
                                {loading && (
                                  <tr>
                                    <td
                                      colSpan={columnNames?.length + 2}
                                      className="text-center py-4"
                                    >
                                      <div
                                        className="spinner-border text-primary"
                                        role="status"
                                      >
                                        <span className="visually-hidden">
                                          Loading...
                                        </span>
                                      </div>
                                    </td>
                                  </tr>
                                )}
                                {!loading &&
                                  partsInventoryList?.length === 0 && (
                                    <tr>
                                      <td
                                        colSpan={columnNames?.length + 2}
                                        className="text-center py-3"
                                      >
                                        No record found
                                      </td>
                                    </tr>
                                  )}
                                {!loading &&
                                  partsInventoryList?.length > 0 &&
                                  partsInventoryList?.map((item) => {
                                    // Setting "distinguir peças armazenadas":
                                    // peças com pelo menos uma quantidade
                                    // associada a uma localização ficam com
                                    // fundo distinto.
                                    const partHasLocation =
                                      Array.isArray(item?.part_qty_list) &&
                                      item.part_qty_list.some((q) => {
                                        const loc = q?.location_ids;
                                        const s =
                                          loc != null ? String(loc).trim() : "";
                                        return s !== "" && s !== "0";
                                      });
                                    const highlightStored =
                                      settingCompanyDetails?.distinguish_stored_parts ===
                                        1 && partHasLocation;
                                    return (
                                      <>
                                        <tr
                                          key={item.id}
                                          style={
                                            highlightStored
                                              ? {
                                                  backgroundColor:
                                                    "rgba(132, 192, 67, 0.12)",
                                                }
                                              : undefined
                                          }
                                        >
                                          {columnKeys?.map((key, index) => {
                                            const value = getColumnValue(
                                              item,
                                              key,
                                            );

                                            // Image column
                                            if (key === "parts_photos") {
                                              return (
                                                <td
                                                  key={index}
                                                  onClick={(e) =>
                                                    // navigate(
                                                    //   `/parts-images/${item.id}`,
                                                    //   { state: item }
                                                    // )
                                                    handleImageOpen(e, item)
                                                  }
                                                  style={{ cursor: "pointer" }}
                                                >
                                                  {value ? (
                                                    <img
                                                      src={value}
                                                      className="img-fluid"
                                                      alt="Part"
                                                      style={{
                                                        width: "37px",
                                                        height: "30px",
                                                        borderRadius: "100px",
                                                      }}
                                                    />
                                                  ) : (
                                                    "-"
                                                  )}
                                                </td>
                                              );
                                            }

                                            //part damage
                                            if (key === "parts_damage") {
                                              return (
                                                <td
                                                  key={index}
                                                  style={{ cursor: "pointer" }}
                                                >
                                                  {item?.damage_flag ? (
                                                    <i
                                                      className="bi bi-check2 edit-btn cursor-pointer"
                                                      onClick={(e) =>
                                                        handleDamageModalOpen(
                                                          e,
                                                          item,
                                                        )
                                                      }
                                                    ></i>
                                                  ) : (
                                                    <i
                                                      className="bi bi-x-lg"
                                                      style={{
                                                        backgroundColor:
                                                          "#ea7e89",
                                                        borderColor: "#dc3545",
                                                        padding: "6px 6px",
                                                        borderRadius: "30px",
                                                      }}
                                                    ></i>
                                                  )}
                                                </td>
                                              );
                                            }

                                            return <td key={index}>{value}</td>;
                                          })}

                                          <td className="d-flex">
                                            <Dropdown
                                              className="iconDropdown"
                                              onToggle={(isOpen) => {
                                                if (isOpen) {
                                                  const tableResponsive =
                                                    document.querySelector(
                                                      ".inventory_table",
                                                    );
                                                  if (
                                                    window.innerWidth <= 767
                                                  ) {
                                                    if (tableResponsive) {
                                                      tableResponsive.style.overflowX =
                                                        "auto !important";
                                                      tableResponsive.style.overflowY =
                                                        "auto !important";
                                                    }
                                                  } else {
                                                    if (tableResponsive) {
                                                      tableResponsive.style.overflowX =
                                                        "inherit !important";
                                                      tableResponsive.style.overflowY =
                                                        "inherit !important";
                                                    }
                                                  }
                                                }
                                              }}
                                            >
                                              <Dropdown.Toggle
                                                variant="success"
                                                id="dropdown-basic"
                                                className="iconToggle"
                                              >
                                                <i className="bi bi-three-dots-vertical"></i>
                                              </Dropdown.Toggle>

                                              <Dropdown.Menu>
                                                {params.record_show_type !==
                                                  1 && (
                                                  <Dropdown.Item
                                                    href="#/action-1"
                                                    className="d-flex"
                                                    onClick={() => {
                                                      navigate(
                                                        `/parts-inventory/AddParts/${item.id}`,
                                                      );
                                                    }}
                                                  >
                                                    {RolePermission?.findIndex(
                                                      (e) =>
                                                        e.permission_name ===
                                                        "modify_part_inventory",
                                                    ) > -1 && (
                                                      <a
                                                        className="edit-btn"
                                                        href="#"
                                                      >
                                                        <i className="bi bi-pencil"></i>
                                                      </a>
                                                    )}
                                                    <span>{t("edit")}</span>
                                                  </Dropdown.Item>
                                                )}

                                                <Dropdown.Item
                                                  href="#/action-2"
                                                  className="d-flex"
                                                >
                                                  {RolePermission?.findIndex(
                                                    (e) =>
                                                      e.permission_name ===
                                                      "delete_part_inventory",
                                                  ) > -1 && (
                                                    <>
                                                      {params.record_show_type ===
                                                      1 ? (
                                                        <>
                                                          <div className="trash-btn">
                                                            <a
                                                              className="delete-btn"
                                                              href="#"
                                                              onClick={(e) =>
                                                                onDeleteModalOpen(
                                                                  e,
                                                                  item,
                                                                )
                                                              }
                                                            >
                                                              <i className="bi bi-arrow-clockwise"></i>
                                                            </a>
                                                          </div>
                                                        </>
                                                      ) : (
                                                        <div className="trash-btn">
                                                          <a
                                                            className="delete-btn"
                                                            href="#"
                                                            onClick={(e) =>
                                                              onDeleteModalOpen(
                                                                e,
                                                                item,
                                                              )
                                                            }
                                                          >
                                                            <i className="bi bi-trash3"></i>
                                                          </a>
                                                        </div>
                                                      )}
                                                    </>
                                                  )}
                                                  {params.record_show_type ===
                                                  1 ? (
                                                    <span
                                                      onClick={(e) =>
                                                        onDeleteModalOpen(
                                                          e,
                                                          item,
                                                        )
                                                      }
                                                    >
                                                      {t("restore")}
                                                    </span>
                                                  ) : (
                                                    <span
                                                      onClick={(e) =>
                                                        onDeleteModalOpen(
                                                          e,
                                                          item,
                                                        )
                                                      }
                                                    >
                                                      {t("delete")}
                                                    </span>
                                                  )}
                                                </Dropdown.Item>
                                                <Dropdown.Item
                                                  href="#/action-3"
                                                  className="d-flex"
                                                  onClick={(e) => {
                                                    e.preventDefault();
                                                    if (item) {
                                                      navigate(
                                                        `/part/details/inven/${item.id}`,
                                                        {
                                                          state: item,
                                                        },
                                                      );
                                                    }
                                                  }}
                                                >
                                                  <div
                                                    style={{
                                                      width: "30px",
                                                      height: "30px",
                                                      borderRadius: "50px",
                                                      display: "flex",
                                                      justifyContent: "center",
                                                      alignItems: "center",
                                                    }}
                                                  >
                                                    <a
                                                      className="edit-btn"
                                                      href="#"
                                                    >
                                                      <i className="bi bi-eye-fill"></i>
                                                    </a>
                                                  </div>
                                                  <span>{t("pi_action_view_part")}</span>
                                                </Dropdown.Item>
                                                {item?.vehicle_id && (
                                                  <Dropdown.Item
                                                    className="d-flex"
                                                    onClick={(e) => {
                                                      e.preventDefault();
                                                      if (item) {
                                                        navigate(
                                                          `/vehicle/details/part/${item.uuid}`,
                                                          {
                                                            state: item,
                                                          },
                                                        );
                                                      }
                                                    }}
                                                  >
                                                    <button
                                                      className="edit-btn"
                                                      onClick={(e) =>
                                                        e.preventDefault()
                                                      }
                                                    >
                                                      <i className="bi bi-pencil"></i>
                                                    </button>
                                                    <span>{t("vehicle_details")}</span>
                                                  </Dropdown.Item>
                                                )}
                                                <Dropdown.Item
                                                  href="#/action-4"
                                                  className="d-flex"
                                                  onClick={(e) => {
                                                    ontpartHistoryQtyDetailsOpen(
                                                      e,
                                                      item,
                                                    );
                                                  }}
                                                >
                                                  <a
                                                    className="edit-btn"
                                                    href="#"
                                                  >
                                                    <i className="bi bi-tools"></i>
                                                  </a>

                                                  <span>
                                                    {t("pi_action_part_qty_history")}
                                                  </span>
                                                </Dropdown.Item>

                                                <Dropdown.Item
                                                  href="#/action-4"
                                                  className="d-flex"
                                                  onClick={(e) => {
                                                    e.preventDefault();
                                                    navigate(
                                                      `/parts-inventory/details/${item.id}`,
                                                      { state: params },
                                                    );
                                                  }}
                                                >
                                                  <a
                                                    className="edit-btn"
                                                    href="#"
                                                  >
                                                    <i className="bi bi-qr-code-scan"></i>
                                                  </a>

                                                  <span>{t("pi_action_entity_assign_qr")}</span>
                                                </Dropdown.Item>

                                                <Dropdown.Item
                                                  href="#/action-4"
                                                  className="d-flex"
                                                  onClick={(e) =>
                                                    handleReplicateOpen(e, item)
                                                  }
                                                >
                                                  <a
                                                    className="edit-btn"
                                                    href="#"
                                                  >
                                                    <i className="bi bi-repeat"></i>{" "}
                                                  </a>

                                                  <span>{t("pi_action_replicate_parts")}</span>
                                                </Dropdown.Item>
                                                {item.inventory_status === 1 &&
                                                  item.quantity >= 1 && (
                                                    <Dropdown.Item
                                                      href="#/action-4"
                                                      className="d-flex"
                                                      onClick={(e) =>
                                                        handleReservesOpen(
                                                          e,
                                                          item,
                                                        )
                                                      }
                                                    >
                                                      <a
                                                        className="edit-btn"
                                                        href="#"
                                                      >
                                                        <i className="bi bi-life-preserver"></i>{" "}
                                                      </a>

                                                      <span>
                                                        {t("pi_action_reserves_parts")}
                                                      </span>
                                                    </Dropdown.Item>
                                                  )}

                                                <Dropdown.Item
                                                  href="#/action-4"
                                                  className="d-flex"
                                                  onClick={(e) =>
                                                    handleRepairModalOpen(
                                                      e,
                                                      item,
                                                    )
                                                  }
                                                >
                                                  <a
                                                    className="edit-btn"
                                                    href="#"
                                                  >
                                                    <i className="bi bi-tools"></i>{" "}
                                                  </a>

                                                  <span>
                                                    {t("repairs_parts")}
                                                  </span>
                                                </Dropdown.Item>

                                                {(companyId?.default_user ===
                                                  1 ||
                                                  companyId?.role_id ===
                                                    "1") && (
                                                  <Dropdown.Item
                                                    href="#/action-4"
                                                    className="d-flex"
                                                    onClick={(e) =>
                                                      handlePriceModalOpen(
                                                        e,
                                                        item,
                                                      )
                                                    }
                                                  >
                                                    <a
                                                      className="edit-btn"
                                                      href="#"
                                                    >
                                                      <i className="bi bi-tag"></i>{" "}
                                                    </a>

                                                    <span>{t("pi_action_change_price")}</span>
                                                  </Dropdown.Item>
                                                )}

                                                <Dropdown.Item
                                                  href="#/action-4"
                                                  className="d-flex"
                                                  onClick={(e) =>
                                                    handleCartModalOpen(e, item)
                                                  }
                                                >
                                                  <a
                                                    className="edit-btn"
                                                    href="#"
                                                  >
                                                    <i className="bi bi-cart-check"></i>{" "}
                                                  </a>
                                                  <span>{t("pi_action_add_to_cart")}</span>
                                                </Dropdown.Item>

                                                <Dropdown.Item
                                                  href="#/action-1"
                                                  className="d-flex"
                                                  onClick={(e) => {
                                                    handlePrintOpen(e, item);
                                                  }}
                                                >
                                                  {RolePermission?.findIndex(
                                                    (e) =>
                                                      e.permission_name ===
                                                      "modify_part_inventory",
                                                  ) > -1 && (
                                                    <a
                                                      className="edit-btn"
                                                      href="#"
                                                    >
                                                      <i className="bi bi-hdd"></i>{" "}
                                                    </a>
                                                  )}
                                                  <span>{t("pi_action_print_server")}</span>
                                                </Dropdown.Item>

                                                {Number(item.inventory_status) >
                                                  0 && (
                                                  <>
                                                    <Dropdown.Item
                                                      href="#/action-3"
                                                      className="d-flex"
                                                      onClick={(e) =>
                                                        handleSyncModalOpen(
                                                          e,
                                                          item,
                                                          1,
                                                        )
                                                      }
                                                    >
                                                      <div
                                                        style={{
                                                          width: "30px",
                                                          height: "30px",
                                                          borderRadius: "50px",
                                                          display: "flex",
                                                          justifyContent:
                                                            "center",
                                                          alignItems: "center",
                                                        }}
                                                      >
                                                        <a
                                                          className="edit-btn"
                                                          href="#"
                                                        >
                                                          <i className="bi bi-receipt"></i>{" "}
                                                        </a>
                                                      </div>
                                                      <span>
                                                        {t("pi_action_sync_invoicing")}
                                                      </span>
                                                    </Dropdown.Item>

                                                    <Dropdown.Item
                                                      href="#/action-3"
                                                      className="d-flex"
                                                      onClick={(e) =>
                                                        handleSyncModalOpen(
                                                          e,
                                                          item,
                                                          2,
                                                        )
                                                      }
                                                    >
                                                      <div
                                                        style={{
                                                          width: "30px",
                                                          height: "30px",
                                                          borderRadius: "50px",
                                                          display: "flex",
                                                          justifyContent:
                                                            "center",
                                                          alignItems: "center",
                                                        }}
                                                      >
                                                        <a
                                                          className="edit-btn"
                                                          href="#"
                                                        >
                                                          <i className="bi bi-receipt"></i>{" "}
                                                        </a>
                                                      </div>
                                                      <span>
                                                        {t("pi_action_invoice_product")}
                                                      </span>
                                                    </Dropdown.Item>
                                                  </>
                                                )}
                                              </Dropdown.Menu>
                                            </Dropdown>
                                          </td>
                                        </tr>
                                      </>
                                    );
                                  })}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      )}
                      {/* /.card-body */}
                    </div>
                  </div>
                </div>
              </div>
              <div className="fuelCF">
                <div className="pagination pagination-sm m-0 float-right card-footer-part">
                  <ReactPaginate
                    previousLabel={
                      <i className="bi bi-chevron-double-left"></i>
                    }
                    nextLabel={<i className="bi bi-chevron-double-right"></i>}
                    breakLabel={"..."}
                    pageCount={Math.ceil(totalRecords / params.limit)}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={5}
                    onPageChange={(e) => handleParams(e, "pagination")}
                    forcePage={params.page - 1}
                    containerClassName={"pagination"}
                    activeClassName={"active"}
                    pageClassName={"page-item"}
                    pageLinkClassName={"page-link"}
                  />
                </div>
              </div>
            </section>
          </>
        )}
      </div>

      <Modal isOpen={delModal}>
        <ModalHeader>{t("pi_modal_delete_inventory_part")}</ModalHeader>
        <ModalBody>
          <p className={`mb-0`}>{t("confirm_restore_inventory_part")}</p>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-block btn-primary"
            disabled={isDelButtonLoad}
            onClick={onDeleteModalClose}
            style={{ width: "100px", marginTop: "10px" }}
          >
            {t("close")} <i className="bi bi-x-lg"></i>
          </button>

          {!isDelButtonLoad && params.record_show_type === 1 ? (
            <>
              <button
                type="button"
                className="btn btn-block bg-red"
                style={{ width: "100px" }}
                // onClick={onDestroyPartInventory}

                onClick={() => {
                  setInStockModel(true);
                  setDelModal(false);
                }}
              >
                {t("restore")} <i className="bi bi-arrow-repeat"></i>
              </button>
            </>
          ) : (
            <>
              <button
                type="button"
                className="btn btn-block bg-red"
                style={{ width: "100px" }}
                // onClick={onDestroyPartInventory}

                onClick={() => {
                  setOutOfStockModel(true);
                  setDelModal(false);
                }}
              >
                {t("delete")} <i className="bi bi-trash3"></i>
              </button>
              {delPartId.inventory_status !== 3 && (
                <button
                  type="button"
                  className="btn btn-block btn-primary"
                  style={{ width: "148px" }}
                  onClick={handleSubmitDeleteWaste}
                >
                  {t("pi_btn_send_to_waste")} <i className="bi bi-arrow-repeat"></i>
                </button>
              )}
            </>
          )}

          {isDelButtonLoad && (
            <button
              color="secondary"
              type={`button`}
              disabled={true}
              className={`btn-square`}
            >
              <i className="fa fa-circle-o-notch fa-spin"></i> {t("loading")}
            </button>
          )}
        </ModalFooter>
      </Modal>

      <Modal isOpen={outOfStockModel}>
        <ModalHeader>{t("pi_modal_inventory_part")}</ModalHeader>
        <ModalBody>
          <p className={`mb-0`}>{t("pi_confirm_out_of_stock")}</p>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-block btn-primary"
            disabled={isOutOfStockDelButtonLoad}
            onClick={() => setOutOfStockModel(false)}
            style={{ width: "100px", marginTop: "6px" }}
          >
            {t("close")} <i className="bi bi-x-lg"></i>
          </button>
          <button
            type="button"
            className="btn btn-block btn-primary"
            disabled={isOutOfStockDelButtonLoad}
            onClick={onOutStockPartInventory}
            style={{ width: "147px", marginTop: "6px" }}
          >
            {t("pi_btn_out_of_stock")} <i className="bi bi-x-lg"></i>
          </button>

          <>
            <button
              type="button"
              className="btn btn-block bg-red"
              style={{ width: "100px" }}
              onClick={onDestroyPartInventory}
            >
              {isDelButtonLoad ? (
                <>
                  <i className="fa fa-circle-o-notch fa-spin"></i> {t("loading")}
                </>
              ) : (
                <>
                  {t("delete")} <i className="bi bi-trash3"></i>
                </>
              )}
            </button>
          </>
        </ModalFooter>
      </Modal>

      <Modal isOpen={inStockModel}>
        <ModalHeader>{t("pi_modal_inventory_part")}</ModalHeader>
        <ModalBody>
          <p className={`mb-0`}>{t("pi_confirm_in_stock")}</p>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-block btn-primary"
            disabled={isInStockDelButtonLoad}
            onClick={() => setInStockModel(false)}
            style={{ width: "100px", marginTop: "6px" }}
          >
            {t("close")} <i className="bi bi-x-lg"></i>
          </button>
          <button
            type="button"
            className="btn btn-block btn-primary"
            disabled={isInStockDelButtonLoad}
            onClick={inStockPartInventory}
            style={{ width: "147px", marginTop: "6px" }}
          >
            {t("pi_btn_in_stock")} <i className="bi bi-x-lg"></i>
          </button>

          <>
            <button
              type="button"
              className="btn btn-block bg-red"
              style={{ width: "100px" }}
              onClick={onDestroyPartInventory}
            >
              {isDelButtonLoad ? (
                <>
                  <i className="fa fa-circle-o-notch fa-spin"></i> {t("loading")}
                </>
              ) : (
                <>
                  {t("restore")} <i className="bi bi-trash3"></i>
                </>
              )}
            </button>
          </>
        </ModalFooter>
      </Modal>

      <Modal isOpen={cascadeModal}>
        <ModalHeader>{t("pi_cascade_children_title")}</ModalHeader>
        <ModalBody>
          <p className={`mb-0`}>
            {cascadeAction === "delete"
              ? t("pi_cascade_children_delete_text")
              : cascadeAction === "oos"
                ? t("pi_cascade_children_oos_text")
                : t("pi_cascade_children_status_text")}
          </p>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-block btn-primary"
            style={{ marginTop: "10px" }}
            onClick={() => onCascadeConfirm(false)}
          >
            {t("pi_cascade_children_no")}
          </button>
          <button
            type="button"
            className="btn btn-block bg-red"
            style={{ marginTop: "10px" }}
            onClick={() => onCascadeConfirm(true)}
          >
            {t("pi_cascade_children_yes")}
          </button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={vehiclePartDetailsModal} size="lg">
        <ModalHeader>{t("vehicle_details")}</ModalHeader>
        <ModalBody>
          <div className="row">
            <div className="col-md-12">
              <div className="vehicleThBg table-responsive">
                <table className="rounded-table table table-striped table-bordered table-hover">
                  <thead>
                    <tr>
                      <th>{t("registration")}</th>
                      <th>{t("pi_col_booklet_model")}</th>
                      <th>{t("pi_col_external_ref")}</th>
                      <th>{t("model")}</th>
                      <th>{t("pi_col_model_name")}</th>
                      <th>{t("year")}</th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr>
                      <td>{vehiclePartDetails.registration}</td>
                      <td>{vehiclePartDetails.vehicle_booklet_model}</td>
                      <td>{vehiclePartDetails.vehicle_external_ref}</td>
                      <td>{vehiclePartDetails.vehicle_model}</td>
                      <td>{vehiclePartDetails.vehicle_model_name}</td>
                      <td>{vehiclePartDetails.vehicle_year}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-block btn-primary"
            onClick={onvehiclePartDetailsClose}
            style={{ width: "100px", marginTop: "10px" }}
          >
            {t("close")} <i className="bi bi-x-lg"></i>
          </button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={qrDetails}>
        <ModalHeader>
          {t("pi_modal_qr_details")}
          <button
            type="button"
            className="button-Close d-none"
            onClick={handleQrDetailsClose}
          >
            <i className="bi bi-x-lg"></i>
          </button>
        </ModalHeader>
        <ModalBody>
          <div className="row">
            {filteredParts?.length > 0 ? (
              filteredParts.map((item) => {
                const randomString = `${item.parts_id}-${item.parts_internal_id}`;
                return (
                  <>
                    <div className="col-md-6">
                      <Label>Part Code</Label>
                      <div className="svg-barshelf">
                        <Barcode value={randomString} width={2} height={100} />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <Label>Location</Label>
                      <div className="svg-barpart">
                        <Barcode value={`${item.warehouse_name}`} />
                      </div>
                    </div>
                  </>
                );
              })
            ) : (
              <div>{t("pi_no_qr_found")}</div>
            )}
          </div>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-block btn-primary"
            disabled={isDelButtonLoad}
            onClick={handleQrDetailsClose}
            style={{ width: "100px", marginTop: "10px" }}
          >
            {t("close")} <i className="bi bi-x-lg"></i>
          </button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={partHistoryQtyModal} size="lg">
        <ModalHeader>
          {t("pi_modal_part_history")}
          <button
            type="button"
            className="button-Close d-none"
            onClick={onpartHistoryQtyDetailsClose}
          >
            <i className="bi bi-x-lg"></i>
          </button>
        </ModalHeader>
        <ModalBody>
          <div className="row">
            <div className="">
              <div className="row" style={{ marginTop: "15px" }}>
                <ul className="nav nav-tabs mb-3">
                  <li className="nav-item">
                    <button
                      className={`nav-link ${
                        activeHistoryTab === "qty" ? "active" : ""
                      }`}
                      onClick={() => setActiveHistoryTab("qty")}
                      type="button"
                    >
                      Part Qty History
                    </button>
                  </li>

                  <li className="nav-item">
                    <button
                      className={`nav-link ${
                        activeHistoryTab === "inventory" ? "active" : ""
                      }`}
                      onClick={() => setActiveHistoryTab("inventory")}
                      type="button"
                    >
                      Part Inventory History
                    </button>
                  </li>
                </ul>
              </div>
              {activeHistoryTab === "qty" && (
                <div>
                  <div className="col-md-12">
                    <select
                      className="form-select mt-2 input-search"
                      type="select"
                      value={partQtyStatusId}
                      onChange={(e) => {
                        setpartQtyStatusId(e.target.value);
                      }}
                      style={{ width: "100%" }}
                    >
                      <option value="0">All</option>

                      {allPartQtyList?.map((item) => (
                        <option key={item.value} value={item.value}>
                          {item.label}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="vehicleThBg table-responsive mt-2">
                    <table className="rounded-table table table-striped table-bordered table-hover">
                      <thead>
                        <tr>
                          <th>{t("pi_col_user")}</th>
                          <th>{t("pi_col_location")}</th>
                          <th>{t("pi_col_date")}</th>
                          {partHistoryQtyDetails?.some(
                            (item) => item.deleted_at,
                          ) && <th>{t("pi_col_delete_date")}</th>}
                        </tr>
                      </thead>

                      <tbody>
                        {partHistoryQtyDetails?.map((item) => {
                          return (
                            <tr key={item.id}>
                              <td>{item.user_name}</td>
                              <td>{item.location_names || "-"}</td>
                              <td>
                                {moment(item.last_created_at).format(
                                  "DD/MM/YYYY HH:mm",
                                )}
                              </td>
                              {item?.deleted_at && (
                                <td>
                                  {moment(item.deleted_at).format(
                                    "DD/MM/YYYY HH:mm",
                                  )}
                                </td>
                              )}
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {activeHistoryTab === "inventory" && (
                <>
                  <div className="vehicleThBg table-responsive mt-2">
                    <table className="rounded-table table table-striped table-bordered table-hover">
                      <thead>
                        <tr>
                          <th>{t("date")}</th>
                          <th>{t("user_name")}</th>

                          <th>{t("log")}</th>
                        </tr>
                      </thead>

                      <tbody>
                        {partInventoryHistoryList?.length > 0 ? (
                          partInventoryHistoryList.map((item, index) => (
                            <tr key={index}>
                              <td>
                                {moment(item.created_at).format(
                                  "DD/MM/YYYY HH:mm:ss",
                                )}
                              </td>
                              <td>{item.user_name}</td>
                              <td>
                                <MessageCell message={item.message} />
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="5" className="text-center text-muted">
                              No inventory history available
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>

                  <div className="card-footer clearfix card-footer-part">
                    <div className="pagination pagination-sm m-0  paginationRight">
                      <ReactPaginate
                        previousLabel={
                          <i className="bi bi-chevron-double-left"></i>
                        }
                        nextLabel={
                          <i className="bi bi-chevron-double-right"></i>
                        }
                        breakLabel={"..."}
                        pageCount={Math.ceil(totalPartInven / partLimit)}
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={5}
                        onPageChange={(e) => setPartPage(e.selected + 1)} // 0-based index
                        forcePage={partPage - 1} // keep UI synced
                        containerClassName={"pagination"}
                        activeClassName={"active"}
                        pageClassName={"page-item"}
                        pageLinkClassName={"page-link"}
                      />
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-block btn-primary"
            onClick={onpartHistoryQtyDetailsClose}
            style={{ width: "100px", marginTop: "10px" }}
          >
            {t("close")} <i className="bi bi-x-lg"></i>
          </button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={partStatusChangeModal} size="xl">
        <ModalHeader>
          {`Part Status Change`}
          <button
            type="button"
            className="button-Close d-none"
            onClick={onPartStatusChangeClose}
          >
            <i className="bi bi-x-lg"></i>
          </button>
        </ModalHeader>

        <Form method={`post`} onSubmit={handleSubmit}>
          <ModalBody>
            <div className="row">
              <div className="col-lg-6">
                <Label
                  className="col-form-label ml-2 Label-my form-label form-label"
                  style={{ paddingLeft: "13px" }}
                >
                  {"Part Status "}
                </Label>
                <select
                  className="form-select  input-search"
                  type="select"
                  value={inventoryPartStatusChange}
                  onChange={(e) => {
                    setInventoryPartStatusChange(e.target.value);
                  }}
                  style={{
                    width: "95%",
                    marginLeft: "19px",
                    marginBottom: "13px",
                  }}
                >
                  {inventoryList?.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-lg-6">
                {Number(inventoryPartStatusChange) === 3 && (
                  <>
                    <div className="row">
                      <div className="col-md-6">
                        <FormGroup>
                          <Label className="col-form-label ml-2 Label-my form-label form-label">
                            {"Select LER Catalog"}
                          </Label>
                          <div className="">
                            <div className="input-div">
                              <Select
                                className="my-Select"
                                options={LerCatalogList}
                                value={LerCatalogList.filter((item) =>
                                  vehiclePartsData.ler_code_id.includes(
                                    item.value,
                                  ),
                                )}
                                onChange={handleSelectLERChange}
                                placeholder={"Select LER catalog"}
                                isSearchable={true}
                                onInputChange={handleInputChangeLER}
                                inputValue={inputValueLer}
                                isClearable={true}
                                isMulti
                              />
                            </div>
                          </div>
                        </FormGroup>
                      </div>

                      <div className="col-md-6" style={{ marginTop: "44px" }}>
                        {vehiclePartsData.ler_code_id.length > 0 && (
                          <div className="">
                            <p className="wastage">
                              wastage Value : {sumWastageValue}
                            </p>
                          </div>
                        )}
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
            <div className="row">
              <div className="row">
                <div className="col-md-6">
                  <div className="vehicleThBg table-responsive tableScroll table-scroll-modal min-height-0">
                    <table className="rounded-table table table-striped table-bordered table-hover">
                      <thead>
                        <tr>
                          <th style={{}}>{t("catalog")}</th>
                          <th style={{}}>{t("pi_f_model")}</th>
                          <th style={{}}>{t("pi_f_year")}</th>
                          <th style={{}}>{t("pi_f_inventory_status")}</th>
                          <th style={{}}>{t("action")}</th>
                        </tr>
                      </thead>

                      <tbody>
                        {filteredPartAssignList?.length > 0 ? (
                          filteredPartAssignList?.map((item, index) => (
                            <tr key={index}>
                              <td>{item?.namePartPT}</td>
                              <td>{item.vehicle_model}</td>
                              <td>{item.vehicle_year}</td>
                              <td>{tConst(item.inventory_status_name, t)}</td>

                              <td>
                                <Button
                                  className="addBtn"
                                  onClick={() =>
                                    handleAddClick(
                                      item.id,
                                      item.namePartPT,
                                      item.vehicle_model,
                                      item.vehicle_year,
                                      item.inventory_status_name,
                                      item.is_master_part,
                                    )
                                  }
                                  style={{
                                    backgroundColor: addedParts.some(
                                      (part) => part.id === item.id,
                                    )
                                      ? "red"
                                      : "green",
                                    color: "white",
                                    cursor: "pointer",
                                  }}
                                >
                                  <i className="bi bi-plus-lg"></i>{" "}
                                </Button>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr className="scrollBrdr">
                            <td colSpan="100%">{t("pi_no_results_found")}</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                  <div className="card-footer clearfix card-footer-part">
                    <div className="pagination pagination-sm m-0  paginationRight">
                      <Pagination
                        activePage={params.page}
                        itemsCountPerPage={parseInt(params.limit)}
                        totalItemsCount={parseInt(totalRecords)}
                        pageRangeDisplayed={5}
                        itemClass={`page-item`}
                        linkClass={`page-link`}
                        onChange={(e) => handleParams(e, "pagination")}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="vehicleThBg table-responsive tableScroll table-scroll-modal min-height-0">
                    <table className="rounded-table table table-striped table-bordered table-hover">
                      <thead>
                        <tr>
                          <th style={{ width: "10%" }}>{t("catalog")}</th>
                          <th style={{ width: "10%" }}>{t("pi_f_model")}</th>
                          <th style={{ width: "10%" }}>{t("pi_f_year")}</th>
                          <th style={{ width: "10%" }}>{t("pi_f_inventory_status")}</th>
                          <th style={{ width: "0%" }}>{t("action")}</th>
                        </tr>
                      </thead>

                      <tbody>
                        {addedParts?.length > 0 ? (
                          addedParts?.map((item, index) => (
                            <tr key={index}>
                              <td>{item?.namePartPT}</td>
                              <td>{item.vehicle_model}</td>
                              <td>{item.vehicle_year}</td>
                              <td>{tConst(item.inventory_status_name, t)}</td>

                              <td className="">
                                <a
                                  className="btn-danger-delete"
                                  href="#"
                                  onClick={() =>
                                    handleAddClick(item.id, item.registration)
                                  }
                                >
                                  <i className="bi bi-trash3"></i>
                                </a>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr className="scrollBrdr">
                            <td colSpan="100%">{t("pi_no_results_found")}</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <button
              type="button"
              className="btn btn-block btn-primary"
              onClick={onPartStatusChangeClose}
              style={{ width: "100px", marginTop: "10px" }}
            >
              {t("close")} <i className="bi bi-x-lg"></i>
            </button>
            {loading ? (
              <button
                type="submit"
                className="btn btn-block btn-primary"
                style={{ width: "100px", marginTop: "10px" }}
              >
                loading...
              </button>
            ) : (
              <button
                type="submit"
                className="btn btn-block btn-primary"
                style={{ width: "100px", marginTop: "10px" }}
              >
                Submit <i className="bi bi-check2"></i>
              </button>
            )}
          </ModalFooter>
        </Form>
      </Modal>

      <Modal isOpen={modifyQrSearchModal}>
        <ModalHeader>{t("pi_modal_search_warehouse")}</ModalHeader>
        <ModalBody>
          <div className="row">
            <div className="col-md-12">
              <Label>Warehouse</Label>

              <select
                className="form-select"
                value={selectedEntities.value || ""}
                onChange={handleSelectChange}
              >
                <option value="">Select</option>
                {renderOptions(entityList)}{" "}
              </select>
            </div>
            <div className="col-md-12 mt-3">
              <Label>Warehouse Barcode</Label>

              <input
                className="form-control  input-search"
                type="text"
                value={selectBarcodeValue}
                onChange={(e) => {
                  const value = e.target.value;
                  setSelectBarcodeValue(value);

                  setParams((prevParams) => ({
                    ...prevParams,
                    search_warehouse_barcode: value,
                  }));

                  setmodifyQrSearchModal(false);
                }}
                maxLength={50}
                placeholder={t("pi_search_warehouse_barcode")}
                onClick={(e) => e.stopPropagation()}
              />
            </div>

            {selectedEntities.name && (
              <div className="col-md-12 mt-3">
                <span
                  className="badge bg-primary"
                  style={{
                    width: "100px",
                    height: "28px",
                  }}
                >
                  <span
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      marginTop: "5px",
                    }}
                  >
                    Warehouse : {selectedEntities?.name}
                  </span>
                </span>
              </div>
            )}

            {selectBarcodeValue && (
              <div className="col-md-12 mt-3">
                <span
                  className="badge bg-primary"
                  style={{
                    width: "100px",
                    height: "28px",
                  }}
                >
                  <span
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      marginTop: "5px",
                    }}
                  >
                    Warehouse : {selectBarcodeValue}
                  </span>
                </span>
              </div>
            )}
          </div>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-block btn-primary"
            onClick={handleQrSerachClose}
            style={{ width: "100px", marginTop: "10px" }}
          >
            {t("close")} <i className="bi bi-x-lg"></i>
          </button>

          <button
            type="button"
            className="btn btn-block btn-primary"
            onClick={handleResetQRSerach}
            style={{ width: "100px", marginTop: "10px" }}
          >
            Reset <i className="bi bi-x-lg"></i>
          </button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={qrPartDetails}>
        <ModalHeader>
          {`QR Part Details`}
          <button
            type="button"
            className="button-Close d-none"
            onClick={handleQrPartDetailsClose}
          >
            <i className="bi bi-x-lg"></i>
          </button>
        </ModalHeader>
        <ModalBody>
          <div className="row">
            <>
              <div className="col-md-12">
                <div className="svg-barshelf">
                  <Barcode
                    value={DelPartInternalQRId?.parts_internal_id}
                    width={6}
                    height={100}
                  />
                </div>
              </div>
            </>
          </div>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-block btn-primary"
            disabled={isDelButtonLoad}
            onClick={handleQrPartDetailsClose}
            style={{ width: "100px", marginTop: "10px" }}
          >
            {t("close")} <i className="bi bi-x-lg"></i>
          </button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={modifyReplicateParts} size="xl">
        <ModalHeader>
          {t("pi_modal_replicate_parts")}
          <button
            type="button"
            className="button-Close d-none"
            onClick={handleReplicateClose}
          >
            <i className="bi bi-x-lg"></i>
          </button>
        </ModalHeader>

        <Form method={`post`} onSubmit={handleSubmitReplicateParts}>
          <ModalBody>
            <div className="row">
              <table className="fuelTable">
                <tbody className="row">
                  <tr className="col-md-8">
                    <td>{t("pi_f_part_name")}</td>
                    <td>:</td>
                    <td>{partAddDetails?.namePartPT}</td>
                  </tr>

                  <tr className="col-md-4">
                    <td>{t("pi_f_year")}</td>
                    <td>:</td>
                    <td>{partAddDetails?.vehicle_year}</td>
                  </tr>

                  <tr className="col-md-8">
                    <td>{t("pi_f_make")}</td>
                    <td>:</td>
                    <td>{partAddDetails?.vehicle_make_name}</td>
                  </tr>

                  <tr className="col-md-4">
                    <td>{t("pi_f_model")}</td>
                    <td>:</td>
                    <td>{partAddDetails?.vehicle_model_name}</td>
                  </tr>

                  <tr className="col-md-8">
                    <td>{t("pi_f_variant")}</td>
                    <td>:</td>
                    <td>{partAddDetails?.vehicle_variant_name}</td>
                  </tr>
                  <tr className="col-md-4"></tr>
                </tbody>
              </table>
            </div>

            <div className="row mt-4">
              <div className="col-lg-6">
                <div className="input-div mb-2">
                  <div className="form-check">
                    <input
                      className="my-checkbox-1 form-check-input"
                      type="checkbox"
                      checked={
                        replicatePartsData.copy_compatiable_vehicles === 1
                      }
                      onChange={handleCheckboxChangeCompatibleVehicle}
                    />
                    <label className="form-check-label pl-6">
                      Copy Compatible Vehicles (
                      {partAddDetails?.parts_associate?.length ?? 0})
                    </label>
                  </div>
                </div>
              </div>

              <div className="col-lg-6">
                <div className="input-div mb-2">
                  <div className="form-check">
                    <input
                      className="my-checkbox-1 form-check-input"
                      type="checkbox"
                      checked={replicatePartsData.copy_photo === 1}
                      onChange={handleCheckboxChangeCopyPhoto}
                    />
                    <label className="form-check-label pl-6">
                      Copy Photo ({partAddDetails?.image_list?.length ?? 0})
                    </label>
                  </div>
                </div>
              </div>

              <div className="col-lg-6">
                <div className="input-div mb-2">
                  <div className="form-check">
                    <input
                      className="form-check-input my-checkbox-1 form-check-input"
                      type="checkbox"
                      checked={replicatePartsData.copy_video === 1}
                      onChange={handleCheckboxChangeCopyVideo}
                    />
                    <label className="form-check-label pl-6">
                      Copy Video ({partAddDetails?.video_list?.length ?? 0})
                    </label>
                  </div>
                </div>
              </div>

              <div className="col-lg-6">
                <div className="input-div mb-2">
                  <div className="form-check">
                    <input
                      className="my-checkbox-1 form-check-input"
                      type="checkbox"
                      checked={replicatePartsData.copy_reference === 1}
                      onChange={handleCheckboxChangeCopyRef}
                    />
                    <label className="form-check-label pl-6">
                      Copy Reference (
                      {partAddDetails?.parts_reference?.length ?? 0})
                    </label>
                  </div>
                </div>
              </div>

              <div className="col-lg-6">
                <div className="input-div">
                  <div className="form-check">
                    <input
                      className="my-checkbox-1 form-check-input"
                      type="checkbox"
                      checked={replicatePartsData.copy_damage === 1}
                      onChange={handleCheckboxChangeCopyDamage}
                    />
                    <label className="form-check-label pl-6">
                      Copy Damage ({partAddDetails?.parts_damage?.length ?? 0})
                    </label>
                  </div>
                </div>
              </div>
              <div className="col-lg-6"></div>
            </div>
          </ModalBody>
          <ModalFooter>
            <button
              type="button"
              className="btn btn-block btn-primary"
              onClick={handleReplicateClose}
              style={{ width: "100px", marginTop: "0px" }}
            >
              {t("close")} <i className="bi bi-x-lg"></i>
            </button>
            {loading ? (
              <button
                type="submit"
                className="btn btn-block btn-primary"
                style={{ width: "100px", marginTop: "0px" }}
              >
                loading...
              </button>
            ) : (
              <button
                type="submit"
                className="btn btn-block btn-primary"
                style={{ width: "100px", marginTop: "0px" }}
              >
                Submit <i className="bi bi-check2"></i>
              </button>
            )}
          </ModalFooter>
        </Form>
      </Modal>

      <Modal isOpen={modifyVehiclereplica}>
        <ModalHeader>Vehicle Part</ModalHeader>
        <ModalBody>
          <p
            className={`mb-0`}
          >{`Part is already available in vehicle do you still wants to replicate a part?`}</p>

          <div
            className="row"
            style={{
              marginTop: "13px",
            }}
          >
            <div className="col-md-12">
              <div className="Label-my">
                Replicate Type{" "}
                <Select
                  className="my-select-v"
                  options={replicateVehicleList}
                  value={
                    replicateVehicleList.find(
                      (item) => item.value == replicatePartsData.replicate_type,
                    ) || null
                  }
                  onChange={(selectedOption) =>
                    setReplicatePartsData({
                      ...replicatePartsData,
                      replicate_type: selectedOption
                        ? selectedOption.value
                        : "",
                    })
                  }
                  isSearchable={true}
                  isClearable={true}
                  placeholder={t("pi_fp_replicate_type")}
                />
              </div>
            </div>

            {(replicatePartsData?.replicate_type === 1 ||
              replicatePartsData?.replicate_type === 2) && (
              <div className="col-md-12">
                <div className="Label-my">
                  Vehicle{" "}
                  <Select
                    className="my-select-v"
                    options={VehicleModelAllList}
                    value={
                      VehicleModelAllList.find(
                        (item) =>
                          item.value == replicatePartsData.new_vehicle_id,
                      ) || null
                    }
                    onChange={(selectedOption) =>
                      setReplicatePartsData({
                        ...replicatePartsData,
                        new_vehicle_id: selectedOption
                          ? selectedOption.value
                          : "",
                      })
                    }
                    isSearchable={true}
                    isClearable={true}
                    placeholder={t("pi_fp_vehicle")}
                  />
                </div>
              </div>
            )}
          </div>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-block btn-primary"
            onClick={handleVehiclereplicaOpen}
            style={{ width: "100px", marginTop: "10px" }}
          >
            No <i className="bi bi-x-lg"></i>
          </button>

          <button
            type="button"
            className="btn btn-block btn-primary"
            style={{ width: "100px" }}
            onClick={handleSubmitVehicleReplicateParts}
          >
            Yes <i className="bi bi-check2"></i>
          </button>
        </ModalFooter>
      </Modal>

      <div
        className={`offcanvas offcanvas-end offcanvas-custom ${
          show ? "show" : ""
        }`}
        tabIndex="-1"
        id="staticBackdrop"
        aria-labelledby="staticBackdropLabel"
        style={{ visibility: show ? "visible" : "hidden" }}
      >
        <div className="offcanvas-header">
          <h5 className="offcanvas-title" id="staticBackdropLabel">
            Filter
          </h5>

          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={handleShowClose}
          ></button>
        </div>

        <div className="offcanvas-body offcanvas-body-custom">
          <Tabs
            activeKey={activeTab}
            onSelect={(k) => setActiveTab(k)}
            // defaultActiveKey="location-tab"
            id="fill-tab-example"
            className="mb-3 canvas-tabs-custom"
            fill
          >
            <Tab eventKey="Location-tab" title={t("pi_tab_location")}>
              <div className="tab-content-canvas">
                <div className="row">
                  <div className="col-sm-6">
                    <div className="Label-my">
                      {t("pi_f_warehouse")}
                      <select
                        className="form-select mt-2"
                        value={selectedEntities.value || ""}
                        onChange={handleSelectWareHouseChange}
                      >
                        <option value="">{t("select")}</option>
                        {renderOptions(entityList)}{" "}
                      </select>
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div className="Label-my">
                      {t("pi_f_warehouse_barcode")}
                      <input
                        className="form-control mt-2 input-search"
                        type="text"
                        value={selectBarcodeValue}
                        onChange={(e) => {
                          const value = e.target.value;
                          setSelectBarcodeValue(value);
                        }}
                        maxLength={50}
                        placeholder={t("pi_search_warehouse_barcode")}
                        onClick={(e) => e.stopPropagation()}
                      />
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div className="Label-my">
                      {t("pi_f_internal_id")}
                      <input
                        className="form-control mt-2 input-search"
                        type="text"
                        value={filterData?.internal_id}
                        onChange={(e) =>
                          setFilterData({
                            ...filterData,
                            internal_id: e.target.value,
                          })
                        }
                        maxLength={50}
                        placeholder={t("internal_id")}
                        onClick={(e) => e.stopPropagation()}
                      />
                    </div>
                  </div>
                  <div className="col-sm-6"></div>

                  <div className="col-md-12">
                    {selectedEntities?.name && (
                      <div className="col-md-12 mt-3">
                        <span
                          className="badge bg-primary"
                          style={{
                            width: "100px",
                            height: "28px",
                          }}
                        >
                          <span
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              marginTop: "5px",
                            }}
                          >
                            {t("pi_f_warehouse")}: {selectedEntities?.name}
                          </span>
                        </span>
                      </div>
                    )}

                    {selectBarcodeValue && (
                      <div className="col-md-12 mt-3">
                        <span
                          className="badge bg-primary"
                          style={{
                            width: "100px",
                            height: "28px",
                          }}
                        >
                          <span
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              marginTop: "5px",
                            }}
                          >
                            {t("pi_f_warehouse")}: {selectBarcodeValue}
                          </span>
                        </span>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </Tab>
            <Tab eventKey="Part-tab" title={t("pi_tab_part")}>
              <div className="tab-content-canvas">
                <div className="row">
                  {settingCompanyDetails?.is_free_search === 1 ? (
                    <>
                      <div className="col-sm-6">
                        <div className="Label-my">
                          {t("pi_f_part_name")}
                          <input
                            className="form-control mt-2 input-search"
                            type="text"
                            value={partsName}
                            onChange={(e) => {
                              setPartsName(e.target.value);
                            }}
                            maxLength={50}
                            placeholder={t("part_name")}
                            onClick={(e) => e.stopPropagation()}
                          />
                        </div>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="col-sm-6">
                        <div className="Label-my">
                          {t("pi_f_part_name")}
                          <Select
                            className="my-select-v mt-2"
                            options={catelogList}
                            value={
                              catelogList.find(
                                (option) =>
                                  option.value === filterData.catalog_name,
                              ) || null
                            }
                            onChange={(selectedOption) => {
                              setFilterData({
                                ...filterData,
                                catalog_name: selectedOption
                                  ? selectedOption.value
                                  : "",
                              });

                              if (!selectedOption) {
                                // Reset search & page if cleared
                                setCatelogPage(1);

                                const payload = {
                                  limit: 20,
                                  page: 1,
                                  search: "",
                                  is_reload: true,
                                };

                                fetchVehicleCatalogList(payload);
                              }
                            }}
                            onInputChange={(inputValue, { action }) => {
                              if (action === "input-change") {
                                debouncedVehicleCatalog(inputValue); // call debounced API
                              }
                            }}
                            isSearchable={true}
                            isClearable={true}
                            placeholder={t("pi_fp_part_name")}
                            isLoading={catelogLoading}
                            onMenuScrollToBottom={() => {
                              if (catelogList?.length < catelogTotal) {
                                const nextPage = catelogPage + 1;
                                setCatelogPage(nextPage);
                                const payload = {
                                  limit: 20,
                                  page: nextPage,
                                  search: "",
                                  is_reload: true,
                                  is_Filter: 1,
                                };

                                fetchVehicleCatalogList(payload);
                              }
                            }}
                          />
                        </div>
                      </div>
                    </>
                  )}

                  <div className="col-sm-6">
                    <div className="Label-my">
                      {t("pi_f_part_type")}{" "}
                      <Select
                        className="my-select-v mt-2"
                        options={partTypeList}
                        value={
                          partTypeList.find(
                            (item) => item.value == filterData.part_type,
                          ) || null
                        }
                        onChange={(selectedOption) =>
                          setFilterData({
                            ...filterData,
                            part_type: selectedOption
                              ? selectedOption.value
                              : "",
                          })
                        }
                        isSearchable={true}
                        isClearable={true}
                        placeholder={t("pi_fp_part_type")}
                      />
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div className="Label-my">
                      {t("pi_f_part_location")}{" "}
                      <Select
                        className="my-select-v mt-2"
                        options={partLocationList}
                        value={
                          partLocationList.find(
                            (item) => item.value == filterData.part_location,
                          ) || null
                        }
                        onChange={(selectedOption) =>
                          setFilterData({
                            ...filterData,
                            part_location: selectedOption
                              ? selectedOption.value
                              : "",
                          })
                        }
                        isSearchable={true}
                        isClearable={true}
                        placeholder={t("pi_fp_part_location")}
                      />
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div className="Label-my">
                      {t("pi_f_part_group")}{" "}
                      <Select
                        className="my-select-v mt-2"
                        options={partGroupList}
                        value={
                          partGroupList.find(
                            (item) => item.value == filterData.part_group,
                          ) || null
                        }
                        onChange={(selectedOption) =>
                          setFilterData({
                            ...filterData,
                            part_group: selectedOption
                              ? selectedOption.value
                              : "",
                          })
                        }
                        isSearchable={true}
                        isClearable={true}
                        placeholder={t("pi_fp_part_group")}
                        menuPortalTarget={document.body}
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        }}
                      />
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div className="Label-my">
                      {t("pi_f_part_side")}{" "}
                      <Select
                        className="my-select-v mt-2"
                        options={partSideList}
                        value={
                          partSideList.find(
                            (item) => item.value == filterData.part_side,
                          ) || null
                        }
                        onChange={(selectedOption) =>
                          setFilterData({
                            ...filterData,
                            part_side: selectedOption
                              ? selectedOption.value
                              : "",
                          })
                        }
                        isSearchable={true}
                        isClearable={true}
                        placeholder={t("pi_fp_part_side")}
                        menuPortalTarget={document.body}
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        }}
                      />
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div className="Label-my">
                      {t("pi_f_part_brand")}
                      <Select
                        className="my-select-v mt-2"
                        options={allBrandList}
                        value={
                          allBrandList.find(
                            (item) => item.value === filterData.brand_id,
                          ) || null
                        }
                        onChange={(selectedOption) =>
                          setFilterData({
                            ...filterData,
                            brand_id: selectedOption
                              ? selectedOption.value
                              : "",
                            brand_name: selectedOption
                              ? selectedOption.label
                              : "",
                          })
                        }
                        isSearchable={true}
                        isClearable={true}
                        placeholder={t("pi_fp_part_brand")}
                        menuPortalTarget={document.body}
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        }}
                        inputValue={inputSelectedBrand}
                        onInputChange={(inputValue) => {
                          setInputSelectedBrand(inputValue);
                          handleInputSelectedChangeBrandList(inputValue);
                        }}
                      />
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div className="Label-my">
                      {t("pi_f_condition")}{" "}
                      <Select
                        className="my-select-v mt-2"
                        options={conditionList}
                        value={
                          conditionList.find(
                            (item) => item.value == filterData.condition_id,
                          ) || null
                        }
                        onChange={(selectedOption) =>
                          setFilterData({
                            ...filterData,
                            condition_id: selectedOption
                              ? selectedOption.value
                              : "",
                          })
                        }
                        isSearchable={true}
                        isClearable={true}
                        placeholder={t("pi_fp_condition")}
                        menuPortalTarget={document.body}
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        }}
                      />
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div className="Label-my">
                      {t("pi_f_state")}{" "}
                      <Select
                        className="my-select-v mt-2"
                        options={stateList}
                        value={
                          stateList.find(
                            (item) => item.value == filterData.state_id,
                          ) || null
                        }
                        onChange={(selectedOption) =>
                          setFilterData({
                            ...filterData,
                            state_id: selectedOption
                              ? selectedOption.value
                              : "",
                          })
                        }
                        isSearchable={true}
                        isClearable={true}
                        placeholder={t("pi_fp_state")}
                        menuPortalTarget={document.body}
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        }}
                      />
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div className="Label-my">
                      {t("pi_f_type_damage")}{" "}
                      <Select
                        className="my-select-v mt-2"
                        options={typeDamageList}
                        value={
                          typeDamageList.find(
                            (item) => item.value == filterData.type_damage_id,
                          ) || null
                        }
                        onChange={(selectedOption) =>
                          setFilterData({
                            ...filterData,
                            type_damage_id: selectedOption
                              ? selectedOption.value
                              : "",
                          })
                        }
                        isSearchable={true}
                        isClearable={true}
                        placeholder={t("pi_fp_type_damage")}
                        menuPortalTarget={document.body}
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        }}
                      />
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div className="Label-my">
                      {t("pi_f_location_damage")}{" "}
                      <Select
                        className="my-select-v mt-2"
                        options={locationDamageList}
                        value={
                          locationDamageList.find(
                            (item) =>
                              item.value == filterData.location_damage_id,
                          ) || null
                        }
                        onChange={(selectedOption) =>
                          setFilterData({
                            ...filterData,
                            location_damage_id: selectedOption
                              ? selectedOption.value
                              : "",
                          })
                        }
                        isSearchable={true}
                        isClearable={true}
                        placeholder={t("pi_fp_location_damage")}
                        menuPortalTarget={document.body}
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        }}
                      />
                    </div>
                  </div>

                  <div className="col-sm-6"></div>
                </div>
              </div>
            </Tab>
            <Tab eventKey="Vehicle-tab" title={t("pi_tab_vehicle")}>
              <div className="tab-content-canvas">
                <div className="row">
                  <div className="col-sm-6">
                    <div href="#/action-2">
                      <div className="Label-my">
                        {t("pi_f_vehicle")}{" "}
                        <Select
                          className="my-select-v mt-2"
                          options={vehicleList}
                          value={
                            vehicleList.find(
                              (option) =>
                                option.value === filterData.vehicle_id,
                            ) || null
                          }
                          onChange={(selectedOption) => {
                            setFilterData({
                              ...filterData,
                              vehicle_id: selectedOption
                                ? selectedOption.value
                                : "",
                            });

                            if (!selectedOption) {
                              // Reset search & page if cleared
                              setVehiclePage(1);
                              fetchVehicleList("", 1);
                            }
                          }}
                          onInputChange={(inputValue, { action }) => {
                            if (action === "input-change") {
                              debouncedVehicle(inputValue); // call debounced API
                            }
                          }}
                          isSearchable={true}
                          isClearable={true}
                          placeholder={t("pi_fp_vehicle")}
                          isLoading={vehicleLoading}
                          onMenuScrollToBottom={() => {
                            if (vehicleList.length < vehicleTotal) {
                              const nextPage = vehiclePage + 1;
                              setVehiclePage(nextPage);
                              fetchVehicleList("", nextPage);
                            }
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div href="#/action-2">
                      <div className="Label-my">
                        {t("pi_f_vehicle_type")}{" "}
                        <Select
                          className="my-select-v mt-2"
                          options={VehicleTypeList}
                          value={
                            VehicleTypeList.find(
                              (option) =>
                                option.value === filterData.vehicle_type,
                            ) || null
                          }
                          onChange={(selectedOption) =>
                            setFilterData({
                              ...filterData,
                              vehicle_type: selectedOption
                                ? selectedOption.value
                                : "",
                            })
                          }
                          isSearchable={true}
                          isClearable={true}
                          placeholder={t("pi_fp_vehicle_types")}
                        />
                      </div>
                    </div>
                  </div>

                  {settingCompanyDetails?.is_free_search === 1 ? (
                    <>
                      <div className="col-sm-6">
                        <div className="Label-my">
                          {t("pi_f_year")}
                          <Select
                            className="my-select-v mt-2"
                            options={VehicleYearList}
                            value={VehicleYearList.find(
                              (item) =>
                                item.value == filterData.vehicle_year_id,
                            )}
                            onChange={(selectedOption) => {
                              setFilterData((prev) => ({
                                ...prev,
                                vehicle_year_id: selectedOption
                                  ? selectedOption.value
                                  : "",
                                make_id: "",
                                vehicle_model_id: "",
                                variants_id: "",
                              }));
                              setVehicleMakeList([]);
                              setVehicleModalList([]);
                              setVehicleVariantList([]);
                            }}
                            placeholder={t("pi_fp_vehicle_year")}
                            isClearable={true}
                            onInputChange={handleInputSelectedChangeYearList}
                            inputSelctedValue={inputSelctedeYearValue}
                          />
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="Label-my">
                          {t("pi_f_make")}
                          <input
                            className="form-control mt-2 input-search"
                            type="text"
                            value={make}
                            onChange={(e) => {
                              SetMake(e.target.value);
                            }}
                            maxLength={50}
                            placeholder={t("make")}
                            onClick={(e) => e.stopPropagation()}
                          />
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="Label-my">
                          {t("pi_f_model")}
                          <input
                            className="form-control mt-2 input-search"
                            type="text"
                            value={model}
                            onChange={(e) => {
                              setModel(e.target.value);
                            }}
                            maxLength={50}
                            placeholder={t("model")}
                            onClick={(e) => e.stopPropagation()}
                          />
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="Label-my">
                          {t("pi_f_variant")}
                          <input
                            className="form-control mt-2 input-search"
                            type="text"
                            value={variant}
                            onChange={(e) => {
                              SetVariant(e.target.value);
                            }}
                            maxLength={50}
                            placeholder="variant"
                            onClick={(e) => e.stopPropagation()}
                          />
                        </div>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="col-sm-6">
                        <div className="Label-my">
                          {t("pi_f_year")}
                          <Select
                            className="my-select-v mt-2"
                            options={VehicleYearList}
                            value={VehicleYearList.find(
                              (item) =>
                                item.value == filterData.vehicle_year_id,
                            )}
                            onChange={(selectedOption) => {
                              setFilterData((prev) => ({
                                ...prev,
                                vehicle_year_id: selectedOption
                                  ? selectedOption.value
                                  : "",
                                make_id: "",
                                vehicle_model_id: "",
                                variants_id: "",
                              }));
                              setVehicleMakeList([]);
                              setVehicleModalList([]);
                              setVehicleVariantList([]);
                            }}
                            placeholder={t("pi_fp_vehicle_year")}
                            onInputChange={handleInputSelectedChangeYearList}
                            isClearable={true}
                            inputSelctedValue={inputSelctedeYearValue}
                          />
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="Label-my">
                          {t("pi_f_make")}
                          <Select
                            className="my-select-v mt-2"
                            options={VehicleMakeList}
                            value={
                              VehicleMakeList.find(
                                (option) => option.value === filterData.make_id,
                              ) || null
                            }
                            onChange={(selectedOption) => {
                              setFilterData({
                                ...filterData,
                                make_id: selectedOption
                                  ? selectedOption.value
                                  : "",
                              });

                              if (!selectedOption) {
                                // Reset search & page if cleared
                                setVehicleMakePage(1);

                                const payload = {
                                  limit: 20,
                                  page: 1,
                                  search: "",
                                  is_reload: true,
                                  is_Filter: 1,
                                  ...(filterData?.vehicle_year_id && {
                                    year: filterData.vehicle_year_id,
                                  }),
                                  ...(filterData?.vehicle_type && {
                                    vehicle_type_id: filterData.vehicle_type,
                                  }),
                                };

                                fetchVehicleMakeList(payload);
                              }
                            }}
                            onInputChange={(inputValue, { action }) => {
                              if (action === "input-change") {
                                debouncedVehicleMake(inputValue); // call debounced API
                              }
                            }}
                            isSearchable={true}
                            isClearable={true}
                            placeholder={t("pi_fp_vehicle_make")}
                            isLoading={vehicleMakeLoading}
                            onMenuScrollToBottom={() => {
                              if (VehicleMakeList?.length < vehicleMakeTotal) {
                                const nextPage = vehicleMakePage + 1;
                                setVehicleMakePage(nextPage);
                                const payload = {
                                  limit: 20,
                                  page: nextPage,
                                  search: "",
                                  is_reload: true,
                                  is_Filter: 1,
                                  ...(filterData?.vehicle_year_id && {
                                    year: filterData.vehicle_year_id,
                                  }),
                                  ...(filterData?.vehicle_type && {
                                    vehicle_type_id: filterData.vehicle_type,
                                  }),
                                };

                                fetchVehicleMakeList(payload);
                              }
                            }}
                          />
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="Label-my">
                          {t("pi_f_model")}
                          <Select
                            className="my-select-v mt-2"
                            options={VehicleModalList}
                            value={
                              VehicleModalList.find(
                                (option) =>
                                  option.value === filterData.model_id,
                              ) || null
                            }
                            onChange={(selectedOption) => {
                              setFilterData({
                                ...filterData,
                                model_id: selectedOption
                                  ? selectedOption.value
                                  : "",
                              });

                              if (!selectedOption) {
                                // Reset search & page if cleared
                                setVehicleModelPage(1);

                                const payload = {
                                  limit: 20,
                                  page: 1,
                                  search: "",
                                  is_reload: true,

                                  ...(filterData?.vehicle_year_id && {
                                    vehicle_year: filterData.vehicle_year_id,
                                  }),
                                  ...(filterData?.vehicle_type && {
                                    vehicle_type_id: filterData.vehicle_type,
                                  }),
                                  ...(filterData?.make_id && {
                                    make_id: filterData.make_id,
                                  }),
                                };

                                fetchVehicleModelist(payload);
                              }
                            }}
                            onInputChange={(inputValue, { action }) => {
                              if (action === "input-change") {
                                debouncedVehicleModel(inputValue); // call debounced API
                              }
                            }}
                            isSearchable={true}
                            isClearable={true}
                            placeholder={t("pi_fp_vehicle_model")}
                            isLoading={vehicleModelLoading}
                            onMenuScrollToBottom={() => {
                              if (
                                VehicleModalList?.length < vehicleModelTotal
                              ) {
                                const nextPage = vehicleModelPage + 1;
                                setVehicleModelPage(nextPage);
                                const payload = {
                                  limit: 20,
                                  page: nextPage,
                                  search: "",
                                  is_reload: true,
                                  is_Filter: 1,
                                  ...(filterData?.vehicle_year_id && {
                                    vehicle_year: filterData.vehicle_year_id,
                                  }),
                                  ...(filterData?.vehicle_type && {
                                    vehicle_type_id: filterData.vehicle_type,
                                  }),
                                  ...(filterData?.make_id && {
                                    make_id: filterData.make_id,
                                  }),
                                };

                                fetchVehicleModelist(payload);
                              }
                            }}
                          />
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="Label-my">
                          {t("pi_f_variant")}
                          <Select
                            className="my-select-v mt-2"
                            options={VehicleVariantList}
                            value={
                              VehicleVariantList.find(
                                (option) =>
                                  option.value === filterData.variants_id,
                              ) || null
                            }
                            onChange={(selectedOption) => {
                              setFilterData({
                                ...filterData,
                                variants_id: selectedOption
                                  ? selectedOption.value
                                  : "",
                              });

                              if (!selectedOption) {
                                // Reset search & page if cleared
                                setVehicleModelPage(1);

                                const payload = {
                                  limit: 20,
                                  page: 1,
                                  search: "",
                                  is_reload: true,

                                  ...(filterData?.vehicle_year_id && {
                                    vehicle_year: filterData.vehicle_year_id,
                                  }),
                                  ...(filterData?.vehicle_type && {
                                    vehicle_type_id: filterData.vehicle_type,
                                  }),
                                  ...(filterData?.model_id && {
                                    model_id: filterData.model_id,
                                  }),
                                };

                                fetchVehicleVariantsList(payload);
                              }
                            }}
                            onInputChange={(inputValue, { action }) => {
                              if (action === "input-change") {
                                debouncedVehicleVariants(inputValue); // call debounced API
                              }
                            }}
                            isSearchable={true}
                            isClearable={true}
                            placeholder={t("pi_fp_vehicle_variants")}
                            isLoading={vehicleVariantsLoading}
                            onMenuScrollToBottom={() => {
                              if (
                                VehicleVariantList?.length <
                                vehicleVariantsTotal
                              ) {
                                const nextPage = vehicleVariantsPage + 1;
                                setVehicleVariantsPage(nextPage);
                                const payload = {
                                  limit: 20,
                                  page: nextPage,
                                  search: "",
                                  is_reload: true,
                                  is_Filter: 1,
                                  ...(filterData?.vehicle_year_id && {
                                    vehicle_year: filterData.vehicle_year_id,
                                  }),
                                  ...(filterData?.vehicle_type && {
                                    vehicle_type_id: filterData.vehicle_type,
                                  }),
                                  ...(filterData?.model_id && {
                                    model_id: filterData.model_id,
                                  }),
                                };

                                fetchVehicleVariantsList(payload);
                              }
                            }}
                          />
                        </div>
                      </div>
                    </>
                  )}

                  <div className="col-sm-6">
                    <div className="Label-my">
                      {t("pi_f_fuel")}
                      <Select
                        className="my-select-v mt-2"
                        options={VehicleFuelList}
                        value={
                          VehicleFuelList.find(
                            (item) => item.value == filterData.vehicle_fuel,
                          ) || null
                        }
                        onChange={(selectedOption) =>
                          setFilterData({
                            ...filterData,
                            vehicle_fuel: selectedOption
                              ? selectedOption.value
                              : "",
                          })
                        }
                        isSearchable={true}
                        isClearable={true}
                        placeholder={"Select Fuel"}
                      />
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div className="Label-my">
                      {t("pi_f_vehicle_door")}
                      <Select
                        className="my-select-v mt-2"
                        options={vehicleDoorList}
                        value={
                          vehicleDoorList.find(
                            (item) => item.value == filterData.vehicle_doors,
                          ) || null
                        }
                        onChange={(selectedOption) =>
                          setFilterData({
                            ...filterData,
                            vehicle_doors: selectedOption
                              ? selectedOption.value
                              : "",
                          })
                        }
                        isSearchable={true}
                        isClearable={true}
                        placeholder={t("pi_fp_vehicle_door")}
                        menuPortalTarget={document.body}
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        }}
                      />
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div className="Label-my">
                      {t("pi_f_motorization")}{" "}
                      <input
                        className="form-control mt-2 input-search"
                        type="text"
                        value={filterData?.motorization}
                        onChange={(e) =>
                          setFilterData({
                            ...filterData,
                            motorization: e.target.value,
                          })
                        }
                        maxLength={50}
                        placeholder={t("motorization")}
                        onClick={(e) => e.stopPropagation()}
                      />
                    </div>
                  </div>
                  <div className="col-sm-6"></div>
                  <div className="col-sm-6">
                    <div className="Label-my">
                      {t("pi_f_manufacturer_engine")}{" "}
                      <Select
                        className="my-select-v mt-2"
                        options={manufacturerEngineList}
                        value={
                          manufacturerEngineList.find(
                            (option) =>
                              option.value === filterData.manufacturer_engine,
                          ) || null
                        }
                        onChange={(selectedOption) => {
                          setFilterData({
                            ...filterData,
                            manufacturer_engine: selectedOption
                              ? selectedOption.value
                              : "",
                          });

                          if (!selectedOption) {
                            setEngineMotorCodeList([]);
                          }
                        }}
                        isSearchable={true}
                        isClearable={true}
                        placeholder={t("pi_f_manufacturer_engine")}
                      />
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div className="Label-my">
                      {t("pi_f_engine_code")}{" "}
                      <Select
                        className="my-select-v mt-2"
                        options={engineMotorCodeList}
                        value={
                          engineMotorCodeList.find(
                            (option) =>
                              option.value === filterData.vehicle_engine_code,
                          ) || null
                        }
                        onChange={(selectedOption) =>
                          setFilterData({
                            ...filterData,
                            vehicle_engine_code: selectedOption
                              ? selectedOption.value
                              : "",
                          })
                        }
                        isSearchable={true}
                        isClearable={true}
                        placeholder={t("pi_f_engine_code")}
                        onInputChange={handleMotorCodeEngineSearch}
                        isDisabled={!filterData?.manufacturer_engine}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </Tab>
            <Tab eventKey="General-tab" title={t("pi_tab_general")}>
              <div className="tab-content-canvas">
                <div className="row">
                  <div className="col-sm-6">
                    <div className="Label-my">
                      {t("pi_search_parts")}
                      <input
                        className="form-control mt-2"
                        type="text"
                        name="serach"
                        value={filterData.serach}
                        onChange={(e) =>
                          setFilterData({
                            ...filterData,
                            serach: e.target.value,
                          })
                        }
                        placeholder={t("search")}
                      />
                    </div>
                  </div>

                  {settingCompanyDetails?.is_free_search === 1 ? (
                    <div className="col-sm-6">
                      <div className="Label-my">
                        {t("pi_f_references_search")}
                        <input
                          className="form-control mt-2"
                          type="text"
                          name="serach"
                          value={filterData.reference_name}
                          onChange={(e) =>
                            setFilterData({
                              ...filterData,
                              reference_name: e.target.value,
                            })
                          }
                          placeholder={t("reference_code")}
                        />
                      </div>
                    </div>
                  ) : (
                    <>
                      <div className="col-sm-6">
                        <div
                          className="Label-my"
                          style={{
                            whiteSpace: "nowrap",
                            paddingTop: "0px",
                          }}
                        >
                          {t("pi_f_references_search")}{" "}
                          <Select
                            className="my-select-v mt-2"
                            options={refNameList}
                            value={
                              refNameList.find(
                                (item) =>
                                  item.value == filterData.reference_name,
                              ) || null
                            }
                            onChange={(selectedOption) =>
                              setFilterData({
                                ...filterData,
                                reference_name: selectedOption
                                  ? selectedOption.value
                                  : "",

                                reference_name_type: selectedOption
                                  ? selectedOption.label
                                  : "",
                              })
                            }
                            isClearable={true}
                            isSearchable={true}
                            placeholder={t("pi_fp_references_search")}
                          />
                        </div>
                      </div>
                    </>
                  )}

                  <div className="col-sm-6">
                    <div
                      className="Label-my"
                      style={{
                        whiteSpace: "nowrap",
                        paddingTop: "0px",
                      }}
                    >
                      {t("pi_f_inventory_status")}
                      <select
                        className="form-select mt-2 input-search"
                        type="select"
                        value={inventoryStatus}
                        onChange={(e) => {
                          setInventoryStatus(e.target.value);
                        }}
                        onClick={(e) => e.stopPropagation()}
                      >
                        <option value="">All</option>

                        {inventoryList?.map((item) => (
                          <option key={item.id} value={item.id}>
                            {item.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div href="#/action-2">
                      <div className="Label-my">
                        {t("pi_f_restore_data")}
                        <select
                          className="form-select mt-2 input-search"
                          value={recordStatus}
                          onChange={(e) => setRecordStatus(e.target.value)}
                        >
                          {InvoiceDeleteData.map((item) => (
                            <option key={item.id} value={item.id}>
                              {t(item.value)}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div href="#/action-2">
                      <div className="Label-my">
                        {t("pi_f_price_range")}
                        <div style={{ marginTop: "10px" }}>
                          <Range
                            step={1}
                            min={0}
                            max={5000}
                            values={priceValues}
                            onChange={setPriceValues}
                            renderTrack={({ props, children }) => (
                              <div
                                {...props}
                                style={{
                                  ...props.style,
                                  height: "6px",
                                  width: "100%",
                                  backgroundColor: "#ccc",
                                }}
                              >
                                {children}
                              </div>
                            )}
                            renderThumb={({ props }) => (
                              <div
                                {...props}
                                style={{
                                  ...props.style,
                                  height: "25px",
                                  width: "25px",
                                  backgroundColor: "#999",
                                  marginTop: "1px",
                                  borderRadius: "100px",
                                }}
                              />
                            )}
                          />
                        </div>
                        <div style={{ marginTop: "0.5rem" }}>
                          From: €{priceValues[0]} &nbsp;&nbsp; To: €
                          {priceValues[1]}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div href="#/action-2">
                      <div className="Label-my">
                        {t("pi_f_rating_range")}
                        <div style={{ marginTop: "10px", marginLeft: "22px" }}>
                          <Range
                            step={0.1}
                            min={0}
                            max={5}
                            values={ratingValues}
                            onChange={setRatingValues}
                            renderTrack={({ props, children }) => (
                              <div
                                {...props}
                                style={{
                                  ...props.style,
                                  height: "6px",
                                  width: "100%",
                                  backgroundColor: "#ccc",
                                }}
                              >
                                {children}
                              </div>
                            )}
                            renderThumb={({ props }) => (
                              <div
                                {...props}
                                style={{
                                  ...props.style,
                                  height: "25px",
                                  width: "25px",
                                  backgroundColor: "#ffa500",
                                  marginTop: "1px",
                                  borderRadius: "100px",
                                }}
                              />
                            )}
                          />
                        </div>
                        <div style={{ marginTop: "0.5rem" }}>
                          From: {ratingValues[0]} ★ &nbsp;&nbsp; To:{" "}
                          {ratingValues[1]} ★
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div
                      className="Label-my"
                      style={{
                        whiteSpace: "nowrap",
                        paddingTop: "0px",
                      }}
                    >
                      {t("pi_f_part_with_price")}{" "}
                      <Select
                        className="my-select-v mt-2"
                        options={partWithPriceList}
                        getOptionLabel={(opt) => t(opt.label)}
                        value={
                          partWithPriceList.find(
                            (item) => item.value == filterData.part_with_price,
                          ) || null
                        }
                        onChange={(selectedOption) =>
                          setFilterData({
                            ...filterData,
                            part_with_price: selectedOption
                              ? selectedOption.value
                              : "",
                          })
                        }
                        isSearchable={true}
                        isClearable={true}
                        placeholder={t("pi_fp_part_with_price")}
                      />
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div
                      className="Label-my"
                      style={{
                        whiteSpace: "nowrap",
                        paddingTop: "0px",
                      }}
                    >
                      {t("pi_f_part_with_photo")}{" "}
                      <Select
                        className="my-select-v mt-2"
                        options={partWithPhotoList}
                        getOptionLabel={(opt) => t(opt.label)}
                        value={
                          partWithPhotoList.find(
                            (item) => item.value == filterData.part_with_photo,
                          ) || null
                        }
                        onChange={(selectedOption) =>
                          setFilterData({
                            ...filterData,
                            part_with_photo: selectedOption
                              ? selectedOption.value
                              : "",
                          })
                        }
                        isSearchable={true}
                        isClearable={true}
                        placeholder={t("pi_fp_part_with_photo")}
                      />
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div
                      className="Label-my"
                      style={{
                        whiteSpace: "nowrap",
                        paddingTop: "0px",
                      }}
                    >
                      {t("pi_f_part_with_reference")}{" "}
                      <Select
                        className="my-select-v mt-2"
                        options={partWithReferenceList}
                        getOptionLabel={(opt) => t(opt.label)}
                        value={
                          partWithReferenceList.find(
                            (item) =>
                              item.value == filterData.part_with_reference,
                          ) || null
                        }
                        onChange={(selectedOption) =>
                          setFilterData({
                            ...filterData,
                            part_with_reference: selectedOption
                              ? selectedOption.value
                              : "",
                          })
                        }
                        isSearchable={true}
                        isClearable={true}
                        placeholder={t("pi_fp_part_with_reference")}
                        menuPortalTarget={document.body}
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        }}
                      />
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div
                      className="Label-my"
                      style={{
                        whiteSpace: "nowrap",
                        paddingTop: "0px",
                      }}
                    >
                      {t("pi_f_part_with_damage")}{" "}
                      <Select
                        className="my-select-v mt-2"
                        options={partWithDamageList}
                        getOptionLabel={(opt) => t(opt.label)}
                        value={
                          partWithDamageList.find(
                            (item) => item.value == filterData.part_with_damage,
                          ) || null
                        }
                        onChange={(selectedOption) =>
                          setFilterData({
                            ...filterData,
                            part_with_damage: selectedOption
                              ? selectedOption.value
                              : "",
                          })
                        }
                        isSearchable={true}
                        isClearable={true}
                        placeholder={t("pi_fp_part_with_damage")}
                        menuPortalTarget={document.body}
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        }}
                      />
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div
                      className="Label-my"
                      style={{
                        whiteSpace: "nowrap",
                        paddingTop: "0px",
                      }}
                    >
                      {t("pi_filter_with_location_label")}{" "}
                      <Select
                        className="my-select-v mt-2"
                        options={partWithLocationList}
                        getOptionLabel={(opt) => t(opt.label)}
                        value={
                          partWithLocationList.find(
                            (item) =>
                              item.value == filterData.part_with_location,
                          ) || null
                        }
                        onChange={(selectedOption) =>
                          setFilterData({
                            ...filterData,
                            part_with_location: selectedOption
                              ? selectedOption.value
                              : "",
                          })
                        }
                        isSearchable={true}
                        isClearable={true}
                        placeholder={t("pi_filter_with_location_placeholder")}
                        menuPortalTarget={document.body}
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        }}
                      />
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div
                      className="Label-my"
                      style={{
                        whiteSpace: "nowrap",
                        paddingTop: "0px",
                      }}
                    >
                      <div className="input-div">
                        <div className="form-check">
                          <input
                            className="my-checkbox-1 form-check-input"
                            type="checkbox"
                            checked={filterData.is_compatible_search === 1}
                            onChange={handleCheckboxChangeCompatible}
                          />
                          <label clasetLoadingssName="form-check-label pl-6">
                            {t("pi_f_compatible_search")}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div
                      className="Label-my"
                      style={{
                        whiteSpace: "nowrap",
                        paddingTop: "0px",
                      }}
                    >
                      <div className="input-div">
                        <div className="form-check">
                          <input
                            className="my-checkbox-1 form-check-input"
                            type="checkbox"
                            checked={filterData.is_master_part === 1}
                            onChange={handleCheckboxChangeMasterPart}
                          />
                          <label className="form-check-label pl-6">
                            {t("is_master_part")}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>

                  {settingCompanyDetails?.is_free_search === 1 ? (
                    <>
                      <div className="col-sm-6">
                        <div className="Label-my">
                          {t("pi_f_brand")}
                          <input
                            className="form-control mt-2 input-search"
                            type="text"
                            value={brandName}
                            onChange={(e) => {
                              setBrandName(e.target.value);
                            }}
                            maxLength={50}
                            placeholder={t("brand")}
                            onClick={(e) => e.stopPropagation()}
                          />
                        </div>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="col-sm-6">
                        <div className="Label-my">
                          {t("pi_f_brand")}
                          <Select
                            className="my-select-v mt-2"
                            options={brandList}
                            value={brandList.find(
                              (item) => item.value === filterData.brand,
                            )}
                            onChange={(selectedOption) => {
                              setFilterData((prev) => ({
                                ...prev,
                                brand: selectedOption
                                  ? selectedOption.value
                                  : "",
                              }));
                            }}
                            placeholder={t("select_brand") || t("brand")}
                            isClearable={true}
                            inputValue={inputSelectedBrand}
                            onInputChange={(inputValue) => {
                              setInputSelectedBrand(inputValue);
                              handleInputSelectedChangeBrandList(inputValue);
                            }}
                          />
                        </div>
                      </div>
                    </>
                  )}

                  {settingCompanyDetails?.is_free_search === 1 ? (
                    <>
                      <div className="col-sm-6">
                        <div className="Label-my">
                          {t("pi_f_manufacter")}
                          <input
                            className="form-control mt-2 input-search"
                            type="text"
                            value={manufacterName}
                            onChange={(e) => {
                              setManufacterName(e.target.value);
                            }}
                            maxLength={50}
                            placeholder={t("manufacter")}
                            onClick={(e) => e.stopPropagation()}
                          />
                        </div>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="col-sm-6">
                        <div className="Label-my">
                          {t("pi_f_manufacter")}
                          <Select
                            className="my-select-v mt-2"
                            options={manufacterList}
                            value={manufacterList.find(
                              (item) => item.value === filterData.manufacter,
                            )}
                            onChange={(selectedOption) => {
                              setFilterData((prev) => ({
                                ...prev,
                                manufacter: selectedOption
                                  ? selectedOption.value
                                  : "",
                              }));
                            }}
                            placeholder={t("manufacter")}
                            isClearable={true}
                          />
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </Tab>
            <Tab eventKey="Order By-tab" title={t("pi_tab_order_by")}>
              <div className="tab-content-canvas">
                <div className="row">
                  <div className="col-sm-6">
                    <div className="Label-my">
                      {t("pi_f_sort_field")}{" "}
                      <Select
                        className="my-select-v mt-2"
                        options={sortList}
                        value={
                          sortList.find(
                            (item) => item.value == filterData.order_field,
                          ) || null
                        }
                        onChange={(selectedOption) =>
                          setFilterData({
                            ...filterData,
                            order_field: selectedOption
                              ? selectedOption.value
                              : "",
                          })
                        }
                        isSearchable={true}
                        isClearable={true}
                        placeholder={t("pi_fp_sort_field")}
                      />
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div className="Label-my">
                      {t("pi_f_sort_type")}{" "}
                      <Select
                        className="my-select-v mt-2"
                        options={sortTypeData}
                        getOptionLabel={(opt) => t(opt.label)}
                        value={
                          sortTypeData.find(
                            (item) => item.value == filterData.order_type,
                          ) || null
                        }
                        onChange={(selectedOption) =>
                          setFilterData({
                            ...filterData,
                            order_type: selectedOption
                              ? selectedOption.value
                              : "",
                          })
                        }
                        isSearchable={true}
                        isClearable={true}
                        placeholder={t("pi_fp_sort_type")}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </Tab>
            <Tab eventKey="Others" title={t("pi_tab_others")}>
              <div className="row">
                <div className="col-sm-6">
                  <div className="Label-my">
                    {t("parts_height")}
                    <input
                      className="form-control mt-2 input-search"
                      type="number"
                      value={filterData?.parts_height}
                      onChange={(e) => {
                        setFilterData({
                          ...filterData,
                          parts_height: e.target.value,
                        });
                      }}
                      maxLength={50}
                      placeholder={t("parts_height")}
                      onClick={(e) => e.stopPropagation()}
                    />
                  </div>
                </div>

                <div className="col-sm-6">
                  <div className="Label-my">
                    {t("parts_weight")}
                    <input
                      className="form-control mt-2 input-search"
                      type="number"
                      value={filterData?.parts_weight}
                      onChange={(e) => {
                        setFilterData({
                          ...filterData,
                          parts_weight: e.target.value,
                        });
                      }}
                      maxLength={50}
                      placeholder={t("parts_weight")}
                      onClick={(e) => e.stopPropagation()}
                    />
                  </div>
                </div>

                <div className="col-sm-6">
                  <div className="Label-my">
                    {t("parts_width")}
                    <input
                      className="form-control mt-2 input-search"
                      type="number"
                      value={filterData?.parts_width}
                      onChange={(e) => {
                        setFilterData({
                          ...filterData,
                          parts_width: e.target.value,
                        });
                      }}
                      maxLength={50}
                      placeholder={t("parts_width")}
                      onClick={(e) => e.stopPropagation()}
                    />
                  </div>
                </div>

                <div className="col-sm-6">
                  <div className="Label-my">
                    {t("parts_length")}
                    <input
                      className="form-control mt-2 input-search"
                      type="number"
                      value={filterData?.parts_length}
                      onChange={(e) => {
                        setFilterData({
                          ...filterData,
                          parts_length: e.target.value,
                        });
                      }}
                      maxLength={50}
                      placeholder={t("parts_length")}
                      onClick={(e) => e.stopPropagation()}
                    />
                  </div>
                </div>

                <div className="col-sm-6">
                  <div className="Label-my">
                    {t("cv")}
                    <input
                      className="form-control mt-2 input-search"
                      type="text"
                      value={filterData?.cv}
                      onChange={(e) => {
                        setFilterData({
                          ...filterData,
                          cv: e.target.value,
                        });
                      }}
                      maxLength={50}
                      placeholder="CV"
                      onClick={(e) => e.stopPropagation()}
                    />
                  </div>
                </div>

                <div className="col-sm-6">
                  <div className="Label-my">
                    {t("cc")}
                    <input
                      className="form-control mt-2 input-search"
                      type="text"
                      value={filterData?.cc}
                      onChange={(e) => {
                        setFilterData({
                          ...filterData,
                          cc: e.target.value,
                        });
                      }}
                      maxLength={50}
                      placeholder="CC"
                      onClick={(e) => e.stopPropagation()}
                    />
                  </div>
                </div>

                <div className="col-sm-6">
                  <div className="Label-my">
                    {t("kw")}
                    <input
                      className="form-control mt-2 input-search"
                      type="text"
                      value={filterData?.kw}
                      onChange={(e) => {
                        setFilterData({
                          ...filterData,
                          kw: e.target.value,
                        });
                      }}
                      maxLength={50}
                      placeholder="KW"
                      onClick={(e) => e.stopPropagation()}
                    />
                  </div>
                </div>

                <div className="col-sm-6">
                  <div className="Label-my">
                    {t("pi_f_on_order")}
                    <select
                      className="form-select mt-2 input-search"
                      value={Number(filterData?.part_on_order) || 0}
                      onChange={(e) =>
                        setFilterData({
                          ...filterData,
                          part_on_order: Number(e.target.value),
                        })
                      }
                      onClick={(e) => e.stopPropagation()}
                    >
                      <option value={0}>{t("pi_f_on_order_all")}</option>
                      <option value={1}>{t("pi_f_on_order_only")}</option>
                      <option value={2}>{t("pi_f_on_order_exclude")}</option>
                    </select>
                  </div>
                </div>

                <div className="col-sm-6">
                  <div className="Label-my">
                    {t("pi_f_drafts")}
                    <select
                      className="form-select mt-2 input-search"
                      value={Number(filterData?.part_draft) || 0}
                      onChange={(e) =>
                        setFilterData({
                          ...filterData,
                          part_draft: Number(e.target.value),
                        })
                      }
                      onClick={(e) => e.stopPropagation()}
                    >
                      <option value={0}>{t("pi_f_drafts_hide")}</option>
                      <option value={1}>{t("pi_f_drafts_only")}</option>
                      <option value={2}>{t("pi_f_drafts_all")}</option>
                    </select>
                  </div>
                </div>

                <div className="col-sm-6 mt-2">
                  <div className="form-check">
                    <input
                      className="my-checkbox-1 form-check-input"
                      type="checkbox"
                      checked={filterData.print_label === 1}
                      onChange={handleCheckboxChangePrintLabel}
                    />
                    <label className="form-check-label pl-6">Print Label</label>
                  </div>
                </div>

                <div className="col-sm-6 mt-2">
                  <div className="form-check">
                    <input
                      className="my-checkbox-1 form-check-input"
                      type="checkbox"
                      checked={filterData.vat_included === 1}
                      onChange={handleCheckboxChangeVatIncluded}
                    />
                    <label className="form-check-label pl-6">
                      Vat Included
                    </label>
                  </div>
                </div>
              </div>
            </Tab>
          </Tabs>
        </div>
        <div className="offcanvas-footer">
          <div className="d-flex justify-content-around">
            <button
              style={{ marginTop: "9px", display: "flex" }}
              type="button"
              className="btn  btn-primary btn-filter"
              onClick={(e) => handleParams(e)}
            >
              <span className="ms-1">{t("search")}</span>
            </button>
            <button
              style={{ marginTop: "9px", display: "flex" }}
              type="button"
              className="btn  btn-primary ms-1 btn-filter"
              onClick={ResetModal}
            >
              <span className="ms-1 ">{t("pi_btn_reset")}</span>
            </button>
          </div>
        </div>
      </div>

      <Modal isOpen={modifyReservesParts} size="lg">
        <ModalHeader>{t("pi_modal_reserves_part")}</ModalHeader>
        <ModalBody>
          <div className="row">
            <div className="col-lg-6 addPartField">
              <label className="partsLabel">{t("pi_reserves_name")}</label>

              <Select
                className="my-select-v mt-2"
                options={reservesSerachList}
                value={
                  reservesSerachList.find(
                    (item) => item.value == reservesData.reservation_id,
                  ) || null
                }
                onChange={(selectedOption) =>
                  setReservesData({
                    ...reservesData,
                    reservation_id: selectedOption ? selectedOption.value : "",
                  })
                }
                isSearchable={true}
                isClearable={true}
                placeholder={t("pi_fp_reserves")}
              />
            </div>

            <div className="col-lg-6 addPartField"></div>
          </div>

          <div className="row">
            <div className="col-md-12">
              <div
                className="row"
                style={{
                  overflowX: "auto",
                  maxHeight: "250px",
                }}
              >
                <div className="card-body">
                  <div className="vehicleThBg table-responsive table-responsive-vehicle">
                    <table className="table table-bordered rounded-table table table-striped table-hover">
                      <thead>
                        <tr>
                          <th
                            className="col-form-label ml-2 Label-my form-label"
                            style={{ width: "10%" }}
                          ></th>
                          <th
                            className="col-form-label ml-2 Label-my form-label"
                            style={{ width: "10%" }}
                          >
                            {t("pi_col_quantity")}
                          </th>

                          <th
                            className="col-form-label ml-2 Label-my form-label"
                            style={{ width: "10%" }}
                          >
                            {t("pi_col_entity")}
                          </th>
                          <th
                            className="col-form-label ml-2 Label-my form-label"
                            style={{ width: "10%" }}
                          >
                            {t("pi_col_price")}
                          </th>

                          <th
                            className="col-form-label ml-2 Label-my form-label"
                            style={{ width: "10%" }}
                          >
                            {t("pi_col_notes")}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {reservesPenList[0]?.part_qty_list?.length > 0 ? (
                          reservesPenList[0]?.part_qty_list?.map(
                            (part, index) => (
                              <tr style={{ cursor: "pointer" }} key={index}>
                                <td>
                                  <input
                                    type="checkbox"
                                    className="my-checkbox-1 form-check-input"
                                    checked={selectedParts.some(
                                      (item) => item.id === part.id,
                                    )}
                                    onChange={() =>
                                      handleCheckboxChange(
                                        part.parts_id,
                                        part.id,
                                      )
                                    }
                                    style={{ marginLeft: "100px" }}
                                  />
                                </td>
                                <td>{part.qty}</td>

                                <td>
                                  <select
                                    className="form-select"
                                    value={
                                      selectedEntitiesRes[part.id] ||
                                      part.location_ids ||
                                      ""
                                    }
                                    onChange={(e) =>
                                      handleSelectChangeRes(e, part)
                                    }
                                  >
                                    <option value="" disabled>
                                      Select
                                    </option>
                                    {renderOptions(entityList)}
                                  </select>
                                </td>
                                <td>
                                  <div>
                                    <label>
                                      Price 1: {PartsDataList.part_price}
                                    </label>
                                  </div>

                                  <div>
                                    <label>
                                      Price 2:{" "}
                                      {PartsDataList.part_original_price}
                                    </label>
                                  </div>

                                  <div>
                                    <label>
                                      Price 2: {PartsDataList.part_cost_price}
                                    </label>
                                  </div>

                                  <div>
                                    <label>
                                      Manual:
                                      <input
                                        type="number"
                                        value={selectedPrices[part.id] || ""}
                                        onChange={(e) =>
                                          handleManualInput(
                                            part.id,
                                            e.target.value,
                                          )
                                        }
                                        placeholder={t("pi_enter_manual_price")}
                                        style={{
                                          marginLeft: "10px",
                                          width: "100px",
                                        }}
                                      />
                                    </label>
                                  </div>
                                </td>

                                <td>
                                  <div className="input-div">
                                    <textarea
                                      className="form-control"
                                      value={
                                        resOrderData.reservation_order_notes[
                                          part.id
                                        ] || ""
                                      }
                                      onChange={(e) =>
                                        setResOrderData((prev) => ({
                                          ...prev,
                                          reservation_order_notes: {
                                            ...prev.reservation_order_notes,
                                            [part.id]: e.target.value,
                                          },
                                        }))
                                      }
                                      name={`reservation_order_notes_${part.id}`}
                                      placeholder={t("notes")}
                                      rows={3}
                                    />
                                  </div>
                                </td>
                              </tr>
                            ),
                          )
                        ) : (
                          <tr>
                            <td colSpan="5" style={{ textAlign: "center" }}>
                              No data found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-block btn-primary"
            onClick={handleReservesClose}
            style={{ width: "100px", marginTop: "10px" }}
          >
            No <i className="bi bi-x-lg"></i>
          </button>

          <button
            type="button"
            className="btn btn-block btn-primary"
            style={{ width: "100px" }}
            onClick={handleSubmitReserves}
          >
            Yes <i className="bi bi-check2"></i>
          </button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={modifyImportModal}>
        <Form method={`post`} onSubmit={handleImportGroup}>
          <ModalHeader>{t("import_part_price")}</ModalHeader>
          <ModalBody>
            <div
              className="mt-2"
              style={{
                width: "200px",
              }}
            >
              <a
                href="/ImportPartPrice_Sample.csv"
                download
                className="btn btn-block btn-primary"
              >
                <i className="fa fa-download me-1"></i> {t("pi_download_sample_file")}
              </a>
            </div>
            <div className="row">
              <div className="col-md-12">
                <FormGroup>
                  <Label className="col-form-label">{t("select_file")}</Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control"
                        type="file"
                        onChange={(e) => setFile(e.target.files[0])}
                        name="file"
                        accept=".csv,.xlsx" // adjust file types as needed
                      />
                    </div>
                    {errorsImport.file && (
                      <span className="input-error">{errorsImport.file}</span>
                    )}
                  </div>
                </FormGroup>
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <button
              type="button"
              className="btn btn-block btn-secondary"
              disabled={isModifyButtonLoad}
              onClick={handleImportCloseModal}
              style={{ width: "100px", marginTop: "10px" }}
            >
              {t("close")}
            </button>
            {!isModifyButtonLoad && (
              <button
                type="submit"
                className="btn btn-block btn-primary"
                style={{ width: "100px", marginTop: "10px" }}
              >
                {t("import")}
              </button>
            )}
            {isModifyButtonLoad && (
              <Button
                color="success"
                type={`button`}
                disabled={true}
                className={`btn-square`}
              >
                <i className="fa fa-circle-o-notch fa-spin"></i> {t("loading")}
              </Button>
            )}
          </ModalFooter>
        </Form>
      </Modal>

      <Modal isOpen={repairsPartsModal} size="xl">
        <ModalHeader>
          {t("repairs_parts")}
          <button
            type="button"
            className="button-Close d-none"
            onClick={handleRepairsPartClose}
          >
            <i className="bi bi-x-lg"></i>
          </button>
        </ModalHeader>

        <Form method={`post`} onSubmit={handleSubmitRepairPart}>
          <ModalBody>
            <div className="row">
              <div className="col-md-4">
                <div className="Label-my">
                  Serach
                  <input
                    className="form-control mt-2"
                    type="text"
                    name="serach"
                    value={serachRepair}
                    onChange={(e) => setSerachRepair(e.target.value)}
                    placeholder={t("search")}
                  />
                </div>
              </div>
              <div
                className="col-md-4"
                style={{
                  marginTop: "25px",
                }}
              >
                <input
                  className="form-control mt-2 input-search"
                  type="text"
                  value={repairFilterData?.catalog_name || ""}
                  onChange={(e) => {
                    setRepairFilterData((prev) => ({
                      ...prev,
                      catalog_name: e.target.value,
                    }));
                  }}
                  placeholder={t("pi_catalog_name")}
                  onClick={(e) => e.stopPropagation()}
                />
              </div>
              <div
                className="col-md-4"
                style={{
                  marginTop: "25px",
                }}
              >
                <input
                  className="form-control mt-2 input-search"
                  type="number"
                  value={repairFilterData?.internal_id || ""}
                  onChange={(e) => {
                    setRepairFilterData((prev) => ({
                      ...prev,
                      internal_id: e.target.value,
                    }));
                  }}
                  placeholder={t("internal_id")}
                  onClick={(e) => e.stopPropagation()}
                />
              </div>
            </div>
            <div className="row">
              <div className="row">
                <div className="col-md-7">
                  <div className="vehicleThBg table-responsive tableScroll table-scroll-modal min-height-0">
                    <table className="rounded-table table table-striped table-bordered table-hover">
                      <thead>
                        <tr>
                          <th>{t("internal_id")}</th>
                          <th>{t("catalog")}</th>
                          <th>{t("make")}</th>
                          <th>{t("Model")}</th>
                          <th>{t("year")}</th>
                          <th>{t("inventory_status")}</th>
                          <th>{t("action")}</th>
                        </tr>
                      </thead>

                      <tbody>
                        {filteredRepairList?.length > 0 ? (
                          filteredRepairList?.map((item, index) => (
                            <tr key={index}>
                              <td>{item?.parts_internal_id}</td>

                              <td>{item?.namePartPT}</td>
                              <td>{item.vehicle_model_name}</td>
                              <td>{item.vehicle_make_name}</td>
                              <td>{item.vehicle_year}</td>
                              <td>{tConst(item.inventory_status_name, t)}</td>

                              <td>
                                <Button
                                  className="addBtn"
                                  onClick={() =>
                                    handleRepairAddClick(
                                      item.id,
                                      item.parts_internal_id,
                                      item.namePartPT,
                                      item.vehicle_model_name,
                                      item.vehicle_make_name,
                                      item.vehicle_year,
                                      item.inventory_status_name,
                                    )
                                  }
                                  style={{
                                    backgroundColor: addedRepairsParts.some(
                                      (part) => part.id === item.id,
                                    )
                                      ? "red"
                                      : "green",
                                    color: "white",
                                    cursor: "pointer",
                                  }}
                                >
                                  <i className="bi bi-plus-lg"></i>{" "}
                                </Button>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr className="scrollBrdr">
                            <td colSpan="100%">{t("pi_no_results_found")}</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                  <div className="card-footer clearfix card-footer-part">
                    <div className="pagination pagination-sm m-0  paginationRight">
                      <ReactPaginate
                        pageCount={Math.ceil(repairsTotal / 10)}
                        onPageChange={handlePageChange}
                        forcePage={currentPage}
                        containerClassName={"pagination"}
                        pageClassName={"page-item"}
                        pageLinkClassName={"page-link"}
                        activeClassName={"active"}
                        previousLabel={"<"}
                        nextLabel={">"}
                        breakLabel={"..."}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-5">
                  <div className="vehicleThBg table-responsive tableScroll table-scroll-modal min-height-0">
                    <table className="rounded-table table table-striped table-bordered table-hover">
                      <thead>
                        <tr>
                          <th style={{ width: "10%" }}>{t("internal_id")}</th>
                          <th style={{ width: "10%" }}>{t("catalog")}</th>
                          <th style={{ width: "10%" }}>{t("make")}</th>
                          <th style={{ width: "10%" }}>{t("Model")}</th>
                          <th style={{ width: "10%" }}>{t("year")}</th>
                          <th style={{ width: "10%" }}>
                            {t("inventory_status")}
                          </th>
                          <th style={{ width: "0%" }}>{t("action")}</th>
                        </tr>
                      </thead>

                      <tbody>
                        {addedRepairsParts?.length > 0 ? (
                          addedRepairsParts?.map((item, index) => (
                            <tr key={index}>
                              <td>{item?.parts_internal_id}</td>
                              <td>{item?.namePartPT}</td>
                              <td>{item.vehicle_model_name}</td>
                              <td>{item.vehicle_make_name}</td>
                              <td>{item.vehicle_year}</td>
                              <td>{tConst(item.inventory_status_name, t)}</td>

                              <td className="">
                                <a
                                  className="btn-danger-delete"
                                  href="#"
                                  onClick={() =>
                                    handleRepairAddClick(
                                      item.id,
                                      item.parts_internal_id,
                                      item.namePartPT,
                                      item.vehicle_model_name,
                                      item.vehicle_make_name,
                                      item.vehicle_year,
                                      item.inventory_status_name,
                                    )
                                  }
                                >
                                  <i className="bi bi-trash3"></i>
                                </a>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr className="scrollBrdr">
                            <td colSpan="100%">{t("pi_no_results_found")}</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <button
              type="button"
              className="btn btn-block btn-primary"
              onClick={handleRepairsPartClose}
              style={{ width: "100px", marginTop: "10px" }}
            >
              {t("close")} <i className="bi bi-x-lg"></i>
            </button>
            {loadingRepairs ? (
              <button
                type="submit"
                className="btn btn-block btn-primary"
                style={{ width: "100px", marginTop: "10px" }}
              >
                loading...
              </button>
            ) : (
              <button
                type="submit"
                className="btn btn-block btn-primary"
                style={{ width: "100px", marginTop: "10px" }}
              >
                Submit <i className="bi bi-check2"></i>
              </button>
            )}
          </ModalFooter>
        </Form>
      </Modal>

      <Modal isOpen={repairsPartsSingleModal}>
        <ModalHeader>{t("repairs_parts")}</ModalHeader>
        <ModalBody>
          <p className={`mb-0`}>
            {t("are_you_sure_you_want_to_repair_this_part")}
          </p>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-block btn-primary"
            disabled={loadingRepairs}
            onClick={handleRepairsSinglePartClose}
            style={{ width: "100px", marginTop: "10px" }}
          >
            {t("close")} <i className="bi bi-x-lg"></i>
          </button>

          <>
            <button
              type="button"
              className="btn btn-block btn-primary"
              style={{ width: "100px" }}
              onClick={handleSubmitRepairSinglePart}
            >
              Submit <i className="bi bi-x-lg"></i>
            </button>
          </>

          {loadingRepairs && (
            <button
              color="secondary"
              type={`button`}
              disabled={true}
              className={`btn-square`}
            >
              <i className="fa fa-circle-o-notch fa-spin"></i> {t("loading")}
            </button>
          )}
        </ModalFooter>
      </Modal>

      <Modal isOpen={modifyPriceModal} size="lg">
        <ModalHeader>Edit Price</ModalHeader>
        <Form method={`post`} onSubmit={handleUpdatePrice}>
          <ModalBody>
            <div className="row">
              <div className="col-lg-4 addPartField">
                <label className="partsLabel">Price 1 €</label>
                <input
                  className="form-control mt-2"
                  type="number"
                  name="part_original_price"
                  value={priceData.part_original_price}
                  onChange={handlePriceChange}
                  placeholder="0"
                  min="0"
                />
              </div>
              <div className="col-lg-4 addPartField">
                <label className="partsLabel">
                  Price 2 ({settingDetails?.discount_percentage}% discount) €
                </label>
                <input
                  className="form-control mt-2"
                  type="text"
                  name="part_price"
                  value={priceData.part_price}
                  onChange={handlePriceChange}
                  placeholder="0"
                  min="0"
                />
              </div>
              <div className="col-lg-4 addPartField">
                <label className="partsLabel">Part Cost Price €</label>
                <input
                  className="form-control mt-2"
                  type="number"
                  name="sponsor_price"
                  value={priceData.sponsor_price}
                  onChange={handlePriceChange}
                  placeholder={t("part_price")}
                  min="0"
                />
              </div>
            </div>

            {priceList?.reference_list?.length > 0 && (
              <>
                <div className="row">
                  <p className="fw-medium fs-17 mt-2">{t("partDetails")}</p>
                  <table className="table table-bordered table-striped align-middle">
                    <thead className="table-dark">
                      <tr>
                        <th>Ref Code</th>
                        <th>Price1 Min</th>
                        <th>Price1 Avg</th>
                        <th>Price1 Max</th>
                        <th>Price2 Min</th>
                        <th>Price2 Avg</th>
                        <th>Price2 Max</th>
                      </tr>
                    </thead>
                    <tbody>
                      {refCodeConditionDataList?.partsList?.length > 0 ? (
                        refCodeConditionDataList.partsList.map(
                          (part, index) => (
                            <tr key={index}>
                              <td>
                                <strong>{part.ref_code}</strong>
                              </td>
                              <td>€ {part?.prices?.price1_min || 0}</td>
                              <td>€ {part?.prices?.price1_avg || 0}</td>
                              <td>€ {part?.prices?.price1_max || 0}</td>
                              <td>€ {part?.prices?.price2_min || 0}</td>
                              <td>€ {part?.prices?.price2_price_avg || 0}</td>
                              <td>€ {part?.prices?.price2_price_max || 0}</td>
                            </tr>
                          ),
                        )
                      ) : (
                        <tr>
                          <td
                            colSpan="7"
                            className="text-center py-3 fw-medium"
                          >
                            No data found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

                <div className="row">
                  <p className="fw-medium fs-17 mt-2">{t("estimatePrice")}</p>
                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        <th>Reference</th>
                        <th>Reference Type</th>

                        <th>Price Avg</th>
                        <th>Price Max</th>
                        <th>Price Min</th>
                        <th>Quantity</th>
                      </tr>
                    </thead>
                    <tbody>
                      {estimatePricDataRefList?.stats?.stats_for_references?.map(
                        (item, index) => (
                          <tr key={index}>
                            <td>{item?.reference}</td>
                            <td>{item?.referenceType}</td>
                            <td>€ {item?.stats_reference?.price_avg}</td>
                            <td>€ {item?.stats_reference?.price_max}</td>
                            <td>€ {item?.stats_reference?.price_min}</td>
                            <td>{item?.stats_reference?.quantity}</td>
                          </tr>
                        ),
                      )}
                    </tbody>
                  </table>
                </div>
              </>
            )}
          </ModalBody>
          <ModalFooter>
            <button
              type="button"
              className="btn btn-block btn-primary"
              onClick={handlePriceModalClose}
              style={{ width: "100px", marginTop: "10px" }}
            >
              {t("close")} <i className="bi bi-x-lg"></i>
            </button>

            <button
              type="submit"
              className="btn btn-block btn-primary"
              style={{ width: "100px" }}
              disabled={loadingPrice}
            >
              {loadingPrice ? (
                <>
                  Loading...{" "}
                  <span className="spinner-border spinner-border-sm ms-1" />
                </>
              ) : (
                <>
                  Submit <i className="bi bi-check2" />
                </>
              )}
            </button>
          </ModalFooter>
        </Form>
      </Modal>

      <Modal isOpen={modifyCartModal} size="lg">
        <ModalHeader>
          {t("part_quantity")}
          <button
            type="button"
            className="button-Close d-none"
            onClick={handleCartModalClose}
          >
            <i className="bi bi-x-lg"></i>
          </button>
        </ModalHeader>
        <ModalBody>
          <div className="row">
            <div className="">
              <div className="vehicleThBg table-responsive mt-2">
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th>
                        <input
                          type="checkbox"
                          checked={
                            cartQtyList?.part_qty_list?.length > 0 &&
                            selectedRowsByCart[cartQtyList.id]?.length ===
                              cartQtyList.part_qty_list.length
                          }
                          onChange={() =>
                            handleCartSelectAll(
                              cartQtyList.id,
                              cartQtyList.part_qty_list,
                            )
                          }
                        />
                      </th>
                      <th>{t("part_name")}</th>
                      <th>{t("quantity")}</th>
                    </tr>
                  </thead>

                  <tbody>
                    {cartQtyList?.part_qty_list
                      ?.filter(
                        (item) =>
                          !savedPartIdsByCart[cartQtyList.parts_id]?.includes(
                            item.id,
                          ),
                      )
                      ?.map((item) => (
                        <tr key={item.id}>
                          <td>
                            <input
                              type="checkbox"
                              checked={
                                selectedRowsByCart[cartQtyList.id]?.includes(
                                  item.id,
                                ) || false
                              }
                              onChange={() =>
                                handleRowCartSelect(cartQtyList.id, item.id)
                              }
                            />
                          </td>
                          <td>{cartQtyList.namePartPT}</td>
                          <td>{item.qty || "-"}</td>
                        </tr>
                      ))}

                    {cartQtyList?.part_qty_list?.filter(
                      (item) =>
                        !savedPartIdsByCart[cartQtyList.parts_id]?.includes(
                          item.id,
                        ),
                    ).length === 0 && (
                      <tr>
                        <td colSpan="3" className="text-center text-muted">
                          {t("no_qantity_available_to_select")}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-block btn-primary"
            onClick={handleCartModalClose}
            style={{ width: "100px", marginTop: "10px" }}
          >
            {t("close")} <i className="bi bi-x-lg"></i>
          </button>

          <button
            type="button"
            className="btn btn-block btn-primary"
            style={{ width: "100px", marginTop: "10px" }}
            onClick={handleSaveSelectedParts}
          >
            Save <i className="bi bi-check2" />
          </button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={cartModal}>
        <ModalHeader>
          {t("cart_list")}
          <button
            type="button"
            className="button-Close d-none"
            onClick={handleSelectedCartClose}
          >
            <i className="bi bi-x-lg"></i>
          </button>
        </ModalHeader>

        <Form method={`post`} onSubmit={handleSubmitCart}>
          <ModalBody>
            <div className="row">
              <div className="col-md-12">
                <div className="vehicleThBg table-responsive tableScroll table-scroll-modal min-height-0">
                  <table className="rounded-table table table-striped table-bordered table-hover">
                    <thead>
                      <tr>
                        <th style={{ width: "10%" }}>{t("part_name")}</th>
                        <th style={{ width: "10%" }}>{t("quantity")}</th>
                        <th style={{ width: "0%" }}>{t("action")}</th>
                      </tr>
                    </thead>

                    <tbody>
                      {selectedPartDetails?.length > 0 ? (
                        selectedPartDetails?.map((item, index) => (
                          <tr key={index}>
                            <td>{item?.part_name}</td>
                            <td>{item.qty}</td>
                            <td className="">
                              <a
                                className="btn-danger-delete"
                                href="#"
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleDeleteSelectedPart(item);
                                }}
                              >
                                <i className="bi bi-trash3"></i>
                              </a>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr className="scrollBrdr">
                          <td colSpan="100%">No results found</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <button
              type="button"
              className="btn btn-block btn-primary"
              onClick={handleSelectedCartClose}
              style={{ width: "100px", marginTop: "10px" }}
            >
              {t("close")} <i className="bi bi-x-lg"></i>
            </button>
            {loadingCart ? (
              <button
                type="submit"
                className="btn btn-block btn-primary"
                style={{ width: "100px", marginTop: "10px" }}
              >
                loading...
              </button>
            ) : (
              <button
                type="submit"
                className="btn btn-block btn-primary"
                style={{ width: "100px", marginTop: "10px" }}
              >
                Submit <i className="bi bi-check2"></i>
              </button>
            )}
          </ModalFooter>
        </Form>
      </Modal>

      <Modal isOpen={saveCartModal}>
        <ModalHeader>
          {t("link")}
          <button
            type="button"
            className="button-Close d-none"
            onClick={handleSaveCartClose}
          >
            <i className="bi bi-x-lg"></i>
          </button>
        </ModalHeader>
        <ModalBody>
          <div className="row">
            <div className="col-md-12">{saveCartList?.link}</div>

            <div className="col-md-2 position-relative">
              <button
                type="button"
                className="btn btn-block btn-primary"
                style={{
                  width: "38px",
                  marginTop: "10px",
                  background: "#447a09",
                }}
                onClick={handleCopy}
              >
                <i className="bi bi-clipboard"></i>
              </button>

              {copied && (
                <div
                  className="position-absolute"
                  style={{
                    top: "50px",
                    left: "5px",
                    backgroundColor: "#000",
                    color: "#fff",
                    padding: "5px 10px",
                    borderRadius: "4px",
                    fontSize: "12px",
                    whiteSpace: "nowrap",
                  }}
                >
                  Copied!
                </div>
              )}
            </div>

            <div className="col-md-2" style={{ marginTop: "10px" }}>
              <a
                className="btn btn-email"
                href={`mailto:?subject=Check this link&body=${encodeURIComponent(
                  saveCartList?.link || "",
                )}`}
              >
                <i className="bi bi-envelope"></i>
              </a>
            </div>

            <div className="col-md-2" style={{ marginTop: "10px" }}>
              <a
                className="btn btn-success btn-whats"
                target="_blank"
                rel="noopener noreferrer"
                href={`https://wa.me/?text=${encodeURIComponent(
                  saveCartList?.link || "",
                )}`}
              >
                <i className="bi bi-whatsapp"></i>
              </a>
            </div>
            <div className="col-md-2"></div>
            <div className="col-md-2"></div>
            <div className="col-md-2"></div>
          </div>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-block btn-primary"
            disabled={isDelButtonLoad}
            onClick={handleSaveCartClose}
            style={{ width: "100px", marginTop: "10px" }}
          >
            {t("close")} <i className="bi bi-x-lg"></i>
          </button>
        </ModalFooter>
      </Modal>

      {/* Hidden trigger for the shared unit + target picker.
          The part id is driven by state so each row opens its own picker. */}
      <PartPrintButton
        ref={partPrintRef}
        partId={printPartId}
        hidden
      />

      <Modal isOpen={showPopup} size="xl">
        <ModalHeader>
          {t("vehicle")}
          <button
            type="button"
            className="button-Close d-none"
            onClick={handleShowPopup}
          >
            <i className="bi bi-x-lg"></i>
          </button>
        </ModalHeader>

        <ModalBody>
          <div className="row">
            <div className="col-md-12">
              <div className="vehicleThBg table-responsive tableScroll table-scroll-modal min-height-0">
                <table className="rounded-table table table-striped table-bordered table-hover">
                  <thead>
                    <tr>
                      <th style={{ width: "10%" }}>{t("internal_id")}</th>
                      <th style={{ width: "10%" }}>{t("registration_no")}</th>
                      <th style={{ width: "10%" }}>{t("modal")}</th>
                      <th style={{ width: "10%" }}>{t("year")}</th>
                      <th style={{ width: "10%" }}>{t("created_date")}</th>
                      <th style={{ width: "10%" }}>{t("expiry_date")}</th>
                      <th style={{ width: "0%" }}>{t("action")}</th>
                    </tr>
                  </thead>

                  <tbody>
                    {countVehicleList?.length > 0 ? (
                      countVehicleList?.map((item, index) => (
                        <tr key={index}>
                          <td>{item.vehicle_internal_id || "-"}</td>
                          <td>{item.registration || "-"}</td>
                          <td>{item.vehicle_model || "-"}</td>
                          <td>{item.vehicle_year || "-"}</td>
                          <td>{item.created_at || "-"}</td>

                          <td className="force-width">
                            <span className="btn btn-dangers">
                              {moment(item.vehicle_process_end_date).format(
                                "DD-MM-YYYY",
                              ) || "-"}
                            </span>
                          </td>
                          <td>
                            <button
                              className="edit-btn"
                              onClick={(e) => {
                                e.preventDefault();
                                if (item) {
                                  navigate(`/vehicle/${item.uuid}`, {
                                    state: item,
                                  });
                                }
                              }}
                            >
                              <i className="bi bi-pencil"></i>
                            </button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr className="scrollBrdr">
                        <td colSpan="100%">No results found</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>

            <div className="fuelCF">
              <div className="pagination pagination-sm m-0 float-right card-footer-part">
                <ReactPaginate
                  previousLabel={<i className="bi bi-chevron-double-left"></i>}
                  nextLabel={<i className="bi bi-chevron-double-right"></i>}
                  breakLabel={"..."}
                  pageCount={Math.ceil(totalVehicleList / popupLimit)}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={5}
                  onPageChange={handlePopupPageChange}
                  forcePage={popupPage - 1} // keep UI synced
                  containerClassName={"pagination"}
                  activeClassName={"active"}
                  pageClassName={"page-item"}
                  pageLinkClassName={"page-link"}
                />
              </div>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-block btn-primary"
            onClick={handleShowPopup}
            style={{ width: "100px", marginTop: "10px" }}
          >
            {t("close")} <i className="bi bi-x-lg"></i>
          </button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={damagesModal} size="lg">
        <ModalHeader>{t("damagePartList")}</ModalHeader>
        <Form method={`post`} onSubmit={handleUpdatePrice}>
          <ModalBody>
            {damagesList?.length > 0 && (
              <>
                <div className="row">
                  <table className="table table-bordered table-striped align-middle">
                    <thead className="table-dark">
                      <tr>
                        <th>{t("damage_description")}</th>
                        <th>{t("location_damage_name")}</th>
                        <th>{t("type_damage_name")}</th>
                        <th>{t("damage_rating")}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {damagesList?.length > 0 ? (
                        damagesList?.map((item, index) => (
                          <tr key={index}>
                            <td>{item?.damage_description}</td>
                            <td>{tConstStatic(item?.location_damage_name)}</td>
                            <td>{tConstStatic(item?.type_damage_name)}</td>
                            <td>{item?.damage_rating}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td
                            colSpan="7"
                            className="text-center py-3 fw-medium"
                          >
                            {t("no_data_found")}
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </>
            )}
          </ModalBody>
          <ModalFooter>
            <button
              type="button"
              className="btn btn-block btn-primary"
              onClick={handleDamageModalClose}
              style={{ width: "100px", marginTop: "10px" }}
            >
              {t("close")} <i className="bi bi-x-lg"></i>
            </button>
          </ModalFooter>
        </Form>
      </Modal>

      <Modal isOpen={syncAllModal} size="xl">
        <ModalHeader>
          {syncButtonType === 1
            ? "Sync Product For Invoicing"
            : "Invoice Product"}
        </ModalHeader>
        <Form method={`post`} onSubmit={handleInoviceSyncProduct}>
          <ModalBody>
            <div className="row">
              {syncButtonType === 1 ? (
                <>
                  <div className="col-md-4 mt-2">
                    <h4
                      style={{
                        fontSize: "20px",
                        fontWeight: "700",
                      }}
                    >
                      {"Choose Price"}
                    </h4>

                    <label className="ms-3">
                      <input
                        type="radio"
                        name="price_value"
                        value={syncAllID.part_price}
                        checked={
                          Number(syncFormData.price_value) ===
                          Number(syncAllID.part_price)
                        }
                        onChange={(e) =>
                          setSyncFormData((prev) => ({
                            ...prev,
                            price_value: Number(e.target.value),
                          }))
                        }
                      />
                      <span className="ms-1">
                        Price 1 ({syncAllID?.part_price})
                      </span>
                    </label>

                    <label className="me-3 ms-3">
                      <input
                        type="radio"
                        name="price_value"
                        value={syncAllID.part_original_price}
                        checked={
                          Number(syncFormData.price_value) ===
                          Number(syncAllID.part_original_price)
                        }
                        onChange={(e) =>
                          setSyncFormData((prev) => ({
                            ...prev,
                            price_value: Number(e.target.value),
                          }))
                        }
                      />
                      <span className="ms-1">
                        Price 2 ({syncAllID?.part_original_price})
                      </span>
                    </label>
                  </div>
                  <div className="col-md-4">
                    <FormGroup>
                      <Label className="col-form-label ml-2 Label-my form-label">
                        {"Exemption Reason"}
                      </Label>
                      <div className="col-xl-12">
                        <div className="input-div">
                          <Select
                            options={exemptionList}
                            value={exemptionList.find(
                              (option) =>
                                option.value === syncFormData.exemption_reason,
                            )}
                            onChange={(selectedOption) =>
                              setSyncFormData({
                                ...syncFormData,
                                exemption_reason: selectedOption
                                  ? selectedOption.value
                                  : "",
                              })
                            }
                            placeholder={"Select Exemption Reason"}
                            isClearable
                            isSearchable
                          />
                          {errors.exemption_reason && (
                            <span className="input-error">
                              {errors.exemption_reason}
                            </span>
                          )}
                        </div>
                      </div>
                    </FormGroup>
                  </div>
                  <div className="col-md-4" />

                  {syncAllID?.part_qty_list?.length > 0 && (
                    <>
                      <div className="row">
                        <h4
                          style={{
                            fontSize: "20px",
                            fontWeight: "700",
                            marginTop: "10px",
                          }}
                        >
                          {"Quntity assign"}
                        </h4>
                        <div style={{ maxHeight: "300px", overflow: "auto" }}>
                          <table className="table table-bordered table-striped align-middle">
                            <thead className="table-dark">
                              <tr>
                                <th>
                                  <input
                                    type="checkbox"
                                    checked={
                                      syncAllID?.part_qty_list?.length > 0 &&
                                      syncFormData.selected_ids.length ===
                                        syncAllID.part_qty_list.length
                                    }
                                    onChange={(e) => {
                                      const checked = e.target.checked;

                                      setSyncFormData((prev) => ({
                                        ...prev,
                                        selected_ids: checked
                                          ? syncAllID.part_qty_list?.map(
                                              (x) => x.id,
                                            )
                                          : [],
                                      }));
                                    }}
                                  />
                                </th>
                                <th>{t("location_name")}</th>
                                <th>{t("quntity")}</th>
                              </tr>
                            </thead>

                            <tbody>
                              {syncAllID?.part_qty_list?.length > 0 ? (
                                syncAllID?.part_qty_list
                                  ?.filter((item) => item.is_sold === 0)
                                  .map((item, index) => {
                                    const isChecked =
                                      syncFormData.selected_ids.includes(
                                        item.id,
                                      );

                                    return (
                                      <tr key={index}>
                                        <td>
                                          <input
                                            type="checkbox"
                                            checked={isChecked}
                                            onChange={(e) => {
                                              const checked = e.target.checked;

                                              setSyncFormData((prev) => {
                                                let updated = [
                                                  ...prev.selected_ids,
                                                ];

                                                if (checked) {
                                                  updated.push(item.id);
                                                } else {
                                                  updated = updated.filter(
                                                    (x) => x !== item.id,
                                                  );
                                                }

                                                return {
                                                  ...prev,
                                                  selected_ids: updated,
                                                };
                                              });
                                            }}
                                          />
                                        </td>

                                        <td>{item.location_name || "-"}</td>
                                        <td>{item.qty}</td>
                                      </tr>
                                    );
                                  })
                              ) : (
                                <tr>
                                  <td
                                    colSpan="7"
                                    className="text-center py-3 fw-medium"
                                  >
                                    {t("no_data_found")}
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </>
                  )}
                </>
              ) : (
                <>
                  <div className="col-md-4 mt-2">
                    <h4
                      style={{
                        fontSize: "20px",
                        fontWeight: "700",
                      }}
                    >
                      {"Choose Price"}
                    </h4>

                    <label className="ms-3">
                      <input
                        type="radio"
                        name="price_value"
                        value={syncAllID.part_price}
                        checked={
                          Number(syncFormData.price_value) ===
                          Number(syncAllID.part_price)
                        }
                        onChange={(e) =>
                          setSyncFormData((prev) => ({
                            ...prev,
                            price_value: Number(e.target.value),
                          }))
                        }
                      />
                      <span className="ms-1">
                        Price 1 ({syncAllID?.part_price})
                      </span>
                    </label>

                    <label className="me-3 ms-3">
                      <input
                        type="radio"
                        name="price_value"
                        value={syncAllID.part_original_price}
                        checked={
                          Number(syncFormData.price_value) ===
                          Number(syncAllID.part_original_price)
                        }
                        onChange={(e) =>
                          setSyncFormData((prev) => ({
                            ...prev,
                            price_value: Number(e.target.value),
                          }))
                        }
                      />
                      <span className="ms-1">
                        Price 2 ({syncAllID?.part_original_price})
                      </span>
                    </label>
                  </div>
                  <div className="col-md-4">
                    <FormGroup>
                      <Label className="col-form-label ml-2 Label-my form-label form-label">
                        {t("date")}
                      </Label>
                      <div className="col-xl-12">
                        <div className="input-div">
                          <input
                            className="form-control input-search"
                            type="date"
                            value={syncFormData.date}
                            onChange={(e) => {
                              setSyncFormData({
                                ...syncFormData,
                                date: e.target.value,
                              });
                            }}
                            name="date"
                            placeholder={t("pi_expiration_date")}
                          />
                        </div>
                        {errors.date && (
                          <span className="input-error">{errors.date}</span>
                        )}
                      </div>
                    </FormGroup>
                  </div>
                  <div className="col-md-4">
                    <FormGroup>
                      <Label className="col-form-label ml-2 Label-my form-label form-label">
                        {t("expirationDate")}
                      </Label>
                      <div className="col-xl-12">
                        <div className="input-div">
                          <input
                            className="form-control input-search"
                            type="date"
                            value={syncFormData.expiration_date}
                            onChange={(e) => {
                              setSyncFormData({
                                ...syncFormData,
                                expiration_date: e.target.value,
                              });
                            }}
                            name="expiration_date"
                            placeholder={t("pi_expiration_date")}
                          />
                        </div>
                        {errors.expiration_date && (
                          <span className="input-error">
                            {errors.expiration_date}
                          </span>
                        )}
                      </div>
                    </FormGroup>
                  </div>

                  <div className="col-md-4">
                    <FormGroup>
                      <Label className="col-form-label ml-2 Label-my form-label form-label">
                        {t("documentSet")}
                      </Label>
                      <div className="col-xl-12">
                        <div className="input-div">
                          <Select
                            className="my-select-v"
                            options={documentSetList}
                            value={documentSetList.find(
                              (item) =>
                                item.value === syncFormData.document_set_id,
                            )}
                            onChange={(selectedOption) => {
                              setSyncFormData({
                                ...syncFormData,
                                document_set_id: selectedOption
                                  ? selectedOption.value
                                  : "",
                              });
                            }}
                            isSearchable={true}
                            isClearable={true}
                            placeholder={"Select Document Set"}
                          />
                          {errors.document_set_id && (
                            <span className="input-error">
                              {errors.document_set_id}
                            </span>
                          )}
                        </div>
                      </div>
                    </FormGroup>
                  </div>

                  <div className="col-md-4">
                    <FormGroup>
                      <Label className="col-form-label ml-2 Label-my form-label form-label">
                        {t("customer")}
                      </Label>
                      <div className="col-xl-12">
                        <div className="input-div">
                          <Select
                            className="my-select-v"
                            options={customerList}
                            value={customerList.find(
                              (item) => item.value === syncFormData.customer_id,
                            )}
                            onChange={(selectedOption) => {
                              setSyncFormData({
                                ...syncFormData,
                                customer_id: selectedOption
                                  ? selectedOption.value
                                  : "",
                              });
                            }}
                            isSearchable={true}
                            isClearable={true}
                            placeholder={"Select Customer"}
                          />
                          {errors.customer_id && (
                            <span className="input-error">
                              {errors.customer_id}
                            </span>
                          )}
                        </div>
                      </div>
                    </FormGroup>
                  </div>

                  <div className="col-md-4">
                    <FormGroup>
                      <Label className="col-form-label ml-2 Label-my form-label form-label">
                        {t("our_reference")}
                      </Label>
                      <div className="col-xl-12">
                        <div className="input-div">
                          <input
                            className="form-control input-search"
                            type="text"
                            value={syncFormData.our_reference}
                            onChange={(e) => {
                              setSyncFormData({
                                ...syncFormData,
                                our_reference: e.target.value,
                              });
                            }}
                            name="our_reference"
                            placeholder={t("our_reference")}
                          />
                        </div>
                        {errors.our_reference && (
                          <span className="input-error">
                            {errors.our_reference}
                          </span>
                        )}
                      </div>
                    </FormGroup>
                  </div>

                  <div className="col-md-4">
                    <FormGroup>
                      <Label className="col-form-label ml-2 Label-my form-label form-label">
                        {t("your_reference")}
                      </Label>
                      <div className="col-xl-12">
                        <div className="input-div">
                          <input
                            className="form-control input-search"
                            type="text"
                            value={syncFormData.your_reference}
                            onChange={(e) => {
                              setSyncFormData({
                                ...syncFormData,
                                your_reference: e.target.value,
                              });
                            }}
                            name="your_reference"
                            placeholder={t("your_reference")}
                          />
                        </div>
                        {errors.your_reference && (
                          <span className="input-error">
                            {errors.your_reference}
                          </span>
                        )}
                      </div>
                    </FormGroup>
                  </div>

                  <div className="col-md-4">
                    <FormGroup>
                      <Label className="col-form-label ml-2 Label-my form-label form-label">
                        {t("notes")}
                      </Label>
                      <div className="col-xl-12">
                        <div className="input-div">
                          <input
                            className="form-control input-search"
                            type="text"
                            value={syncFormData.notes}
                            onChange={(e) => {
                              setSyncFormData({
                                ...syncFormData,
                                notes: e.target.value,
                              });
                            }}
                            name="notes"
                            placeholder={t("notes")}
                          />
                        </div>
                        {errors.notes && (
                          <span className="input-error">{errors.notes}</span>
                        )}
                      </div>
                    </FormGroup>
                  </div>

                  <div className="col-md-4">
                    <FormGroup>
                      <Label className="col-form-label ml-2 Label-my form-label form-label">
                        {t("total_value_packaging")}
                      </Label>
                      <div className="col-xl-12">
                        <div className="input-div">
                          <input
                            className="form-control input-search"
                            type="text"
                            value={syncFormData.total_value_packaging}
                            onChange={(e) => {
                              setSyncFormData({
                                ...syncFormData,
                                total_value_packaging: e.target.value,
                              });
                            }}
                            name="total_value_packaging"
                            placeholder={t("pi_total_value_packaging")}
                          />
                        </div>
                      </div>
                    </FormGroup>
                  </div>

                  <div className="col-md-4">
                    <FormGroup>
                      <Label className="col-form-label ml-2 Label-my form-label form-label">
                        {t("total_value_other_parcel")}
                      </Label>
                      <div className="col-xl-12">
                        <div className="input-div">
                          <input
                            className="form-control input-search"
                            type="text"
                            value={syncFormData.total_value_other_parcel}
                            onChange={(e) => {
                              setSyncFormData({
                                ...syncFormData,
                                total_value_other_parcel: e.target.value,
                              });
                            }}
                            name="total_value_other_parcel"
                            placeholder={t("pi_total_value_other_parcel")}
                          />
                        </div>
                      </div>
                    </FormGroup>
                  </div>

                  <div className="col-md-4">
                    <FormGroup>
                      <Label className="col-form-label ml-2 Label-my form-label form-label">
                        {t("total_value_shipping")}
                      </Label>
                      <div className="col-xl-12">
                        <div className="input-div">
                          <input
                            className="form-control input-search"
                            type="text"
                            value={syncFormData.total_value_shipping}
                            onChange={(e) => {
                              setSyncFormData({
                                ...syncFormData,
                                total_value_shipping: e.target.value,
                              });
                            }}
                            name="total_value_shipping"
                            placeholder={t("pi_total_value_shipping")}
                          />
                        </div>
                      </div>
                    </FormGroup>
                  </div>

                  <div className="col-md-4">
                    <FormGroup>
                      <Label className="col-form-label ml-2 Label-my form-label form-label">
                        {"Exemption Vat Other Parcel"}
                      </Label>
                      <div className="col-xl-12">
                        <div className="input-div ">
                          <Select
                            options={exemptionList}
                            value={
                              exemptionList.find(
                                (option) =>
                                  option.value ===
                                  syncFormData.exemption_vat_products,
                              ) || null
                            }
                            onChange={(selectedOption) =>
                              setSyncFormData({
                                ...syncFormData,
                                exemption_vat_products: selectedOption
                                  ? selectedOption.value
                                  : "",
                              })
                            }
                            placeholder={"Select Exemption Vat Other Parcel"}
                            isClearable
                            isSearchable
                          />
                        </div>
                      </div>
                    </FormGroup>
                  </div>

                  <div className="col-md-4">
                    <FormGroup>
                      <Label className="col-form-label ml-2 Label-my form-label">
                        {"Exemption Vat Shipping"}
                      </Label>
                      <div className="col-xl-12">
                        <div className="input-div">
                          <Select
                            options={exemptionList}
                            value={
                              exemptionList.find(
                                (option) =>
                                  option.value ===
                                  syncFormData.exemption_vat_shipping,
                              ) || null
                            }
                            onChange={(selectedOption) =>
                              setSyncFormData({
                                ...syncFormData,
                                exemption_vat_shipping: selectedOption
                                  ? selectedOption.value
                                  : "",
                              })
                            }
                            placeholder={"Select Exemption Vat Shipping"}
                            isClearable
                            isSearchable
                          />
                        </div>
                      </div>
                    </FormGroup>
                  </div>

                  <div className="col-md-4">
                    <FormGroup>
                      <Label className="col-form-label ml-2 Label-my form-label">
                        {"Exemption Vat Packaging"}
                      </Label>
                      <div className="col-xl-12">
                        <div className="input-div">
                          <Select
                            options={exemptionList}
                            value={exemptionList.find(
                              (option) =>
                                option.value ===
                                syncFormData.exemption_vat_packaging,
                            )}
                            onChange={(selectedOption) =>
                              setSyncFormData({
                                ...syncFormData,
                                exemption_vat_packaging: selectedOption
                                  ? selectedOption.value
                                  : "",
                              })
                            }
                            placeholder={"Select Exemption Vat Packaging"}
                            isClearable
                            isSearchable
                          />
                        </div>
                      </div>
                    </FormGroup>
                  </div>

                  <div className="col-md-4">
                    <FormGroup>
                      <Label className="col-form-label ml-2 Label-my form-label">
                        {"Exemption Reason"}
                      </Label>
                      <div className="col-xl-12">
                        <div className="input-div">
                          <Select
                            options={exemptionList}
                            value={exemptionList.find(
                              (option) =>
                                option.value === syncFormData.exemption_reason,
                            )}
                            onChange={(selectedOption) =>
                              setSyncFormData({
                                ...syncFormData,
                                exemption_reason: selectedOption
                                  ? selectedOption.value
                                  : "",
                              })
                            }
                            placeholder={"Select Exemption Reason"}
                            isClearable
                            isSearchable
                          />
                          {errors.exemption_reason && (
                            <span className="input-error">
                              {errors.exemption_reason}
                            </span>
                          )}
                        </div>
                      </div>
                    </FormGroup>
                  </div>
                  <div className="col-md-4"></div>

                  {syncAllID?.part_qty_list?.length > 0 && (
                    <>
                      <div className="row">
                        <h4
                          style={{
                            fontSize: "20px",
                            fontWeight: "700",
                            marginTop: "10px",
                          }}
                        >
                          {"Quntity assign"}
                        </h4>
                        <div style={{ maxHeight: "300px", overflow: "auto" }}>
                          <table className="table table-bordered table-striped align-middle">
                            <thead className="table-dark">
                              <tr>
                                <th>
                                  <input
                                    type="checkbox"
                                    checked={
                                      syncAllID?.part_qty_list?.length > 0 &&
                                      syncFormData.selected_ids.length ===
                                        syncAllID.part_qty_list.length
                                    }
                                    onChange={(e) => {
                                      const checked = e.target.checked;

                                      setSyncFormData((prev) => ({
                                        ...prev,
                                        selected_ids: checked
                                          ? syncAllID.part_qty_list?.map(
                                              (x) => x.id,
                                            )
                                          : [],
                                      }));
                                    }}
                                  />
                                </th>
                                <th>{t("location_name")}</th>
                                <th>{t("quntity")}</th>
                              </tr>
                            </thead>

                            <tbody>
                              {syncAllID?.part_qty_list?.length > 0 ? (
                                syncAllID?.part_qty_list
                                  ?.filter((item) => item.is_sold === 0)
                                  .map((item, index) => {
                                    const isChecked =
                                      syncFormData.selected_ids.includes(
                                        item.id,
                                      );

                                    return (
                                      <tr key={index}>
                                        <td>
                                          <input
                                            type="checkbox"
                                            checked={isChecked}
                                            onChange={(e) => {
                                              const checked = e.target.checked;

                                              setSyncFormData((prev) => {
                                                let updated = [
                                                  ...prev.selected_ids,
                                                ];

                                                if (checked) {
                                                  updated.push(item.id);
                                                } else {
                                                  updated = updated.filter(
                                                    (x) => x !== item.id,
                                                  );
                                                }

                                                return {
                                                  ...prev,
                                                  selected_ids: updated,
                                                };
                                              });
                                            }}
                                          />
                                        </td>

                                        <td>{item.location_name || "-"}</td>
                                        <td>{item.qty}</td>
                                      </tr>
                                    );
                                  })
                              ) : (
                                <tr>
                                  <td
                                    colSpan="7"
                                    className="text-center py-3 fw-medium"
                                  >
                                    {t("no_data_found")}
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </>
                  )}
                </>
              )}
            </div>
          </ModalBody>
          <ModalFooter>
            <button
              type="button"
              className="btn btn-block btn-primary"
              disabled={loadingSync}
              onClick={handleSyncModalClose}
              style={{ width: "100px", marginTop: "10px" }}
            >
              {t("close")} <i className="bi bi-x-lg"></i>
            </button>

            <>
              <button
                type="submit"
                className="btn btn-block btn-primary"
                style={{ width: "100px" }}
              >
                Submit <i className="bi bi-x-lg"></i>
              </button>
            </>

            {loadingSync && (
              <button
                color="secondary"
                type={`button`}
                disabled={true}
                className={`btn-square`}
              >
                <i className="fa fa-circle-o-notch fa-spin"></i> {t("loading")}
              </button>
            )}
          </ModalFooter>
        </Form>
      </Modal>

      {/* Modal "Adicionar a Lote" — paridade com mobile addForLotScreen.dart */}
      <Modal
        isOpen={lotPickerOpen}
        toggle={() => setLotPickerOpen(false)}
        centered
        size="md"
      >
        <ModalHeader toggle={() => setLotPickerOpen(false)}>
          {t("add_for_lot", { defaultValue: "Adicionar a Lote" })}
        </ModalHeader>
        <ModalBody>
          <p className="text-muted" style={{ fontSize: 13 }}>
            {t("select_lot_to_add_parts", {
              defaultValue: "Seleciona o lote ao qual queres associar as peças.",
            })}
          </p>
          <input
            type="text"
            className="form-control mb-2"
            placeholder={t("search", { defaultValue: "Pesquisar..." })}
            value={lotPickerSearch}
            onChange={(e) => setLotPickerSearch(e.target.value)}
            autoFocus
          />
          <div style={{ maxHeight: 380, overflowY: "auto" }}>
            {lotPickerLoading && (
              <div className="text-center text-muted py-3">
                <i className="bi bi-arrow-clockwise" /> ...
              </div>
            )}
            {!lotPickerLoading && filteredLotPickerList.length === 0 && (
              <div className="text-center text-muted py-3">
                {t("no_data_found", { defaultValue: "Sem resultados" })}
              </div>
            )}
            {!lotPickerLoading &&
              filteredLotPickerList.map((lot) => (
                <button
                  key={lot.id}
                  type="button"
                  className="list-group-item list-group-item-action text-start w-100 d-flex align-items-center"
                  onClick={() => onPickLotForParts(lot)}
                  style={{
                    border: 0,
                    borderBottom: "1px solid #e9ecef",
                    padding: "10px 12px",
                  }}
                >
                  <i
                    className="bi bi-archive-fill me-2"
                    style={{ color: "#81BB42" }}
                  />
                  <span className="flex-grow-1">{lot.name || "—"}</span>
                  <i className="bi bi-chevron-right text-muted" />
                </button>
              ))}
          </div>
        </ModalBody>
      </Modal>
    </div>
  );
};

export default PartsInventory;
